
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aZANo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $5xcRx = parcelRequire("5xcRx");

const $cd8031c628565989$export$e4680d4d53bbda72 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)((0, $5xcRx.ViewMoreModalParamsContext));
    if (!context) return $cd8031c628565989$var$_temp;
    return context.setParams;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $5xcRx.ViewMoreModalParamsContext));
    if (!context) return ()=>{};
    return context.setParams;
};
function $cd8031c628565989$var$_temp() {}
module.exports["useSetViewMoreModalParams"] = $cd8031c628565989$export$e4680d4d53bbda72;

});

parcelRegister("5xcRx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2b4d01f4000e67a5$export$fefe6102eaf106ab = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["ViewMoreModalParamsContext"] = $2b4d01f4000e67a5$export$fefe6102eaf106ab;

});

parcelRegister("a9u73", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $Ou0Zz = parcelRequire("Ou0Zz");




const $5b3368095e519648$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "rovo-settings-modal.title",
        defaultMessage: "Rovo Settings"
    },
    contentHeader: {
        id: "rovo-settings-modal.content-header",
        defaultMessage: "Rovo Settings"
    },
    searchPlaceholder: {
        id: "rovo-settings-modal.search-settings-input-placeholder",
        defaultMessage: "Search settings"
    }
});












var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $hAgam = parcelRequire("hAgam");


var $cDs9S = parcelRequire("cDs9S");

var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $aRGok = parcelRequire("aRGok");


var $iODl6 = parcelRequire("iODl6");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $145zT = parcelRequire("145zT");


var $iDdJP = parcelRequire("iDdJP");


var $4yg9g = parcelRequire("4yg9g");











var $hekY6 = parcelRequire("hekY6");


var $ad7Ou = parcelRequire("ad7Ou");


var $kdlgT = parcelRequire("kdlgT");





var $57p4j = parcelRequire("57p4j");




const $bc8adf56d9bb1842$var$styles = {
    overlay: "_2rko1qi0 _bfhk1bhr _4t3i1osq",
    header: "_1rjcpxbi _1e0c1txw _4cvr1h6o _1bah1yb4 _1o9zidpf",
    body: "_1rjcv77o _18zr1ejb _4t3i1osq _18m91wug _1e0c1txw _2lx21bp4",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf"
};
const $bc8adf56d9bb1842$var$enterFrom = 'left';
const $bc8adf56d9bb1842$export$c1eb102f844f2556 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { subscreen: subscreen, onBack: onBack, onClose: onClose } = t0;
    let t1;
    if ($[0] !== onBack || $[1] !== onClose || $[2] !== subscreen.backLabel || $[3] !== subscreen.content) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
            entranceDirection: $bc8adf56d9bb1842$var$enterFrom,
            exitDirection: "left",
            duration: "large"
        }, (fadeInProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...fadeInProps,
                style: {
                    ...fadeInProps.style,
                    position: "absolute",
                    inset: 0
                }
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $bc8adf56d9bb1842$var$styles.overlay
                ])
            }, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $bc8adf56d9bb1842$var$styles.body
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                xcss: $bc8adf56d9bb1842$var$styles.header
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                appearance: "default",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                onClick: onBack
            }, subscreen.backLabel), /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
                onClick: onClose
            })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                xcss: $bc8adf56d9bb1842$var$styles.content
            }, subscreen.content)))));
        $[0] = onBack;
        $[1] = onClose;
        $[2] = subscreen.backLabel;
        $[3] = subscreen.content;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ subscreen: subscreen, onBack: onBack, onClose: onClose })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), {
        entranceDirection: $bc8adf56d9bb1842$var$enterFrom,
        exitDirection: "left",
        duration: "large"
    }, (fadeInProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
            ...fadeInProps,
            style: {
                ...fadeInProps.style,
                position: 'absolute',
                inset: 0
            }
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $bc8adf56d9bb1842$var$styles.overlay
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $bc8adf56d9bb1842$var$styles.body
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $bc8adf56d9bb1842$var$styles.header
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            onClick: onBack
        }, subscreen.backLabel), /*#__PURE__*/ $cozmU.createElement((0, $cDs9S.CloseButton), {
            onClick: onClose
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $bc8adf56d9bb1842$var$styles.content
        }, subscreen.content)))));
};











const $4c988c945f910f3b$export$46a1b891f37517a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isOpen)=>{
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [subscreenStack, setSubscreenStack] = (0, $cozmU.useState)(t0);
    const keyCounter = (0, $cozmU.useRef)(0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (subscreen)=>{
            const key = keyCounter.current = keyCounter.current + 1;
            setSubscreenStack((prev)=>[
                    ...prev,
                    {
                        subscreen: subscreen,
                        key: key
                    }
                ]);
        };
        $[1] = t1;
    } else t1 = $[1];
    const pushSubscreen = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setSubscreenStack($4c988c945f910f3b$var$_temp);
        };
        $[2] = t2;
    } else t2 = $[2];
    const popSubscreen = t2;
    let t3;
    let t4;
    if ($[3] !== isOpen) {
        t3 = ()=>{
            if (!isOpen) setSubscreenStack([]);
        };
        t4 = [
            isOpen
        ];
        $[3] = isOpen;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const activeEntry = subscreenStack.length > 0 ? subscreenStack[subscreenStack.length - 1] : null;
    const t5 = subscreenStack.length > 0;
    let t6;
    if ($[6] !== t5) {
        t6 = {
            pushSubscreen: pushSubscreen,
            popSubscreen: popSubscreen,
            hasSubscreen: t5
        };
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const subscreenActions = t6;
    const t7 = activeEntry?.subscreen ?? null;
    const t8 = activeEntry?.key ?? 0;
    let t9;
    if ($[8] !== subscreenActions || $[9] !== t7 || $[10] !== t8) {
        t9 = {
            activeSubscreen: t7,
            activeSubscreenKey: t8,
            subscreenActions: subscreenActions
        };
        $[8] = subscreenActions;
        $[9] = t7;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : (isOpen)=>{
    const [subscreenStack, setSubscreenStack] = (0, $cozmU.useState)([]);
    const keyCounter = (0, $cozmU.useRef)(0);
    const pushSubscreen = (0, $cozmU.useCallback)((subscreen)=>{
        const key = ++keyCounter.current;
        setSubscreenStack((prev)=>[
                ...prev,
                {
                    subscreen: subscreen,
                    key: key
                }
            ]);
    }, []);
    const popSubscreen = (0, $cozmU.useCallback)(()=>{
        setSubscreenStack((prev_0)=>prev_0.slice(0, -1));
    }, []);
    // Clear subscreen stack when modal closes
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) setSubscreenStack([]);
    }, [
        isOpen
    ]);
    const activeEntry = subscreenStack.length > 0 ? subscreenStack[subscreenStack.length - 1] : null;
    const subscreenActions = {
        pushSubscreen: pushSubscreen,
        popSubscreen: popSubscreen,
        hasSubscreen: subscreenStack.length > 0
    };
    return {
        activeSubscreen: activeEntry?.subscreen ?? null,
        activeSubscreenKey: activeEntry?.key ?? 0,
        subscreenActions: subscreenActions
    };
};
function $4c988c945f910f3b$var$_temp(prev_0) {
    return prev_0.slice(0, -1);
}


const $3215380912e0b67b$var$styles = {
    wrapper: "_1reo15vq _18m915vq _2rkofajl _kqswh2mm _1e0c1txw _2lx21bp4 _4t3i1osq",
    wrapperT26: "_2rkopb1k",
    container: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1tkeidpf",
    sideNav: "_zulppxbi _1bsbeoa3 _1ul9eoa3 _1o9zidpf _1wpz1fhb _4cvr1y6m _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx21bp4",
    searchBoxWrapper: "_2rko12b0 _19itz0c1 _1rjc12x7 _18zru2gc _1bsb1osq _vchhusvi _6rthu2gc _bfhkr01l",
    searchIconWrapper: "_1q51v77o _bozgu2gc",
    navList: "_16jlkb7n _1o9zkb7n _i0dlf1ug _18m91wug _1bsb1osq",
    mainPane: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1tkeidpf _1e0c1txw _2lx21bp4",
    content: "_1ul9idpf _1tkeidpf _1bsb1osq _p12f1osq _4t3i1osq _vchhusvi _1e0c1txw _2lx21bp4",
    bodyHeaderRow: "_1o9zidpf _1e0c1txw _4cvr1h6o _1bah1yb4 _ca0qpxbi _n3tdpxbi",
    bodyContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1tkeidpf _18m91wug _n3tdpxbi"
};
const $3215380912e0b67b$var$CustomHeader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentHeader: contentHeader, onClose: onClose, titleId: titleId } = t0;
    let t1;
    if ($[0] !== contentHeader || $[1] !== titleId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "large",
            id: titleId
        }, contentHeader);
        $[0] = contentHeader;
        $[1] = titleId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== onClose) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
            onClick: onClose
        });
        $[3] = onClose;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.bodyHeaderRow
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ contentHeader: contentHeader, onClose: onClose, titleId: titleId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.bodyHeaderRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "large",
        id: titleId
    }, contentHeader), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: onClose
    }));
};
const $3215380912e0b67b$export$38c70214da7313d2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { isOpen: isOpen, onClose: onClose, title: title, items: items, defaultSelectedId: defaultSelectedId, navAriaLabel: navAriaLabel, searchPlaceholder: searchPlaceholder, testId: testId, onActiveTabChange: onActiveTabChange } = t0;
    const titleId = (0, $cozmU.useId)();
    const [selectedNavId, setSelectedNavId] = (0, $cozmU.useState)(defaultSelectedId ?? items[0]?.id ?? "");
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)("");
    const { activeSubscreen: activeSubscreen, activeSubscreenKey: activeSubscreenKey, subscreenActions: subscreenActions } = (0, $4c988c945f910f3b$export$46a1b891f37517a2)(isOpen);
    if (!isOpen) return null;
    if (items.length === 0) return null;
    let t1;
    if ($[0] !== items || $[1] !== searchQuery) {
        const query = searchQuery.trim().toLowerCase();
        t1 = query === "" ? items : items.filter((item)=>{
            const searchable = item.searchLabel ?? (typeof item.label === "string" ? item.label : "");
            return searchable.toLowerCase().includes(query);
        });
        $[0] = items;
        $[1] = searchQuery;
        $[2] = t1;
    } else t1 = $[2];
    const filteredItems = t1;
    let t2;
    if ($[3] !== filteredItems || $[4] !== selectedNavId) {
        t2 = filteredItems.some((item_0)=>item_0.id === selectedNavId) ? selectedNavId : filteredItems[0]?.id ?? "";
        $[3] = filteredItems;
        $[4] = selectedNavId;
        $[5] = t2;
    } else t2 = $[5];
    const effectiveSelectedId = t2;
    let T0;
    let t3;
    if ($[6] !== activeSubscreen || $[7] !== activeSubscreenKey || $[8] !== effectiveSelectedId || $[9] !== filteredItems || $[10] !== isOpen || $[11] !== items || $[12] !== navAriaLabel || $[13] !== onActiveTabChange || $[14] !== onClose || $[15] !== searchPlaceholder || $[16] !== searchQuery || $[17] !== subscreenActions || $[18] !== testId || $[19] !== title || $[20] !== titleId) {
        let t4;
        if ($[23] !== effectiveSelectedId) {
            t4 = (item_1)=>item_1.id === effectiveSelectedId;
            $[23] = effectiveSelectedId;
            $[24] = t4;
        } else t4 = $[24];
        const selectedItem = items.find(t4);
        T0 = (0, $aRGok.default);
        t3 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            width: "x-large",
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: true,
            onClose: onClose,
            "aria-labelledby": titleId,
            height: 640,
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($3215380912e0b67b$var$styles.wrapper, (0, $ixfCV.fg)("platform-dst-shape-theme-default") && $3215380912e0b67b$var$styles.wrapperT26)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.sideNav,
            as: "nav",
            "aria-label": navAriaLabel ?? (typeof title === "string" ? title : undefined)
        }, searchPlaceholder !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.searchBoxWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            appearance: "none",
            isCompact: true,
            type: "search",
            value: searchQuery,
            onChange: (e)=>setSearchQuery(e.currentTarget.value),
            placeholder: searchPlaceholder,
            "aria-label": searchPlaceholder,
            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $3215380912e0b67b$var$styles.searchIconWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                spacing: "spacious",
                color: "var(--ds-icon, #292A2E)",
                label: ""
            }))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.navList
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.025"
        }, filteredItems.map((item_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
                key: item_2.id,
                onClick: ()=>{
                    setSelectedNavId(item_2.id);
                    onActiveTabChange?.(item_2.id);
                },
                elemBefore: item_2.icon,
                isSelected: effectiveSelectedId === item_2.id
            }, typeof item_2.label === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                size: "medium",
                weight: "medium",
                color: effectiveSelectedId === item_2.id ? "color.text.selected" : undefined
            }, item_2.label) : item_2.label)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.mainPane
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3215380912e0b67b$var$CustomHeader, {
            contentHeader: selectedItem?.contentHeader,
            onClose: onClose,
            titleId: titleId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.bodyContent
        }, selectedItem?.content(subscreenActions) ?? null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, activeSubscreen !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc8adf56d9bb1842$export$c1eb102f844f2556), {
            key: activeSubscreenKey,
            subscreen: activeSubscreen,
            onBack: subscreenActions.popSubscreen,
            onClose: onClose
        }))));
        $[6] = activeSubscreen;
        $[7] = activeSubscreenKey;
        $[8] = effectiveSelectedId;
        $[9] = filteredItems;
        $[10] = isOpen;
        $[11] = items;
        $[12] = navAriaLabel;
        $[13] = onActiveTabChange;
        $[14] = onClose;
        $[15] = searchPlaceholder;
        $[16] = searchQuery;
        $[17] = subscreenActions;
        $[18] = testId;
        $[19] = title;
        $[20] = titleId;
        $[21] = T0;
        $[22] = t3;
    } else {
        T0 = $[21];
        t3 = $[22];
    }
    let t4;
    if ($[25] !== T0 || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, null, t3);
        $[25] = T0;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
} : ({ isOpen: isOpen, onClose: onClose, title: title, items: items, defaultSelectedId: defaultSelectedId, navAriaLabel: navAriaLabel, searchPlaceholder: searchPlaceholder, testId: testId, onActiveTabChange: onActiveTabChange })=>{
    const titleId = (0, $cozmU.useId)();
    const [selectedNavId, setSelectedNavId] = (0, $cozmU.useState)(defaultSelectedId ?? items[0]?.id ?? '');
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const { activeSubscreen: activeSubscreen, activeSubscreenKey: activeSubscreenKey, subscreenActions: subscreenActions } = (0, $4c988c945f910f3b$export$46a1b891f37517a2)(isOpen);
    if (!isOpen) return null;
    if (items.length === 0) return null;
    const query = searchQuery.trim().toLowerCase();
    const filteredItems = query === '' ? items : items.filter((item)=>{
        const searchable = item.searchLabel ?? (typeof item.label === 'string' ? item.label : '');
        return searchable.toLowerCase().includes(query);
    });
    const effectiveSelectedId = filteredItems.some((item_0)=>item_0.id === selectedNavId) ? selectedNavId : filteredItems[0]?.id ?? '';
    const selectedItem = items.find((item_1)=>item_1.id === effectiveSelectedId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: "x-large",
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        onClose: onClose,
        "aria-labelledby": titleId,
        height: 640,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($3215380912e0b67b$var$styles.wrapper, // Mirror @atlaskit/modal-dialog's gate so our inner clipping radius
        // stays in sync with the outer modal's actual rendered corner radius.
        (0, $ixfCV.fg)('platform-dst-shape-theme-default') && $3215380912e0b67b$var$styles.wrapperT26)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.sideNav,
        as: "nav",
        "aria-label": navAriaLabel ?? (typeof title === 'string' ? title : undefined)
    }, searchPlaceholder !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.searchBoxWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        appearance: "none",
        isCompact: true,
        type: "search",
        value: searchQuery,
        onChange: (e)=>setSearchQuery(e.currentTarget.value),
        placeholder: searchPlaceholder,
        "aria-label": searchPlaceholder,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3215380912e0b67b$var$styles.searchIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.navList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.025"
    }, filteredItems.map((item_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            key: item_2.id,
            onClick: ()=>{
                setSelectedNavId(item_2.id);
                onActiveTabChange?.(item_2.id);
            },
            elemBefore: item_2.icon,
            isSelected: effectiveSelectedId === item_2.id
        }, typeof item_2.label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium",
            color: effectiveSelectedId === item_2.id ? 'color.text.selected' : undefined
        }, item_2.label) : item_2.label)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.mainPane
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3215380912e0b67b$var$CustomHeader, {
        contentHeader: selectedItem?.contentHeader,
        onClose: onClose,
        titleId: titleId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3215380912e0b67b$var$styles.bodyContent
    }, selectedItem?.content(subscreenActions) ?? null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, activeSubscreen !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc8adf56d9bb1842$export$c1eb102f844f2556), {
        key: activeSubscreenKey,
        subscreen: activeSubscreen,
        onBack: subscreenActions.popSubscreen,
        onClose: onClose
    })))));
};


const $7e70e78141b455eb$var$SideNavModalScrollContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    scrollToAvailableApps: false
});
const $7e70e78141b455eb$var$SideNavModalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
const $7e70e78141b455eb$var$SIDE_NAV_MODAL_STUB = {
    open: ()=>{},
    close: ()=>{},
    isOpen: false,
    disabled: true
};
const $7e70e78141b455eb$var$SideNavModalRenderer = ({ isOpen: isOpen, onClose: onClose, modalOptions: modalOptions, items: items, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleActiveTabChange = (0, $cozmU.useCallback)((tabId)=>{
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'tab',
            actionSubjectId: 'rovoSettingsModalTab',
            attributes: {
                tabId: tabId,
                ...modalOptions?.surface !== undefined && {
                    surface: modalOptions.surface
                }
            }
        });
    }, [
        sendAnalyticsEvent,
        modalOptions?.surface
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3215380912e0b67b$export$38c70214da7313d2), {
        isOpen: isOpen,
        onClose: onClose,
        title: modalOptions?.title ?? formatMessage((0, $5b3368095e519648$export$defe85febe8b728c).title),
        items: items,
        defaultSelectedId: modalOptions?.defaultSelectedId,
        searchPlaceholder: modalOptions?.searchPlaceholder,
        navAriaLabel: modalOptions?.navAriaLabel,
        testId: testId,
        onActiveTabChange: handleActiveTabChange
    });
};
const $7e70e78141b455eb$export$cffe57958c3923f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { children: children, items: items, disabled: t1, testId: testId } = t0;
    const disabled = t1 === undefined ? false : t1;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [modalOptions, setModalOptions] = (0, $cozmU.useState)(null);
    let t2;
    if ($[0] !== items || $[1] !== sendAnalyticsEvent) {
        t2 = (options)=>{
            setModalOptions(options);
            setIsOpen(true);
            const initialTabId = options.defaultSelectedId ?? items[0]?.id;
            sendAnalyticsEvent({
                action: "viewed",
                actionSubject: "modal",
                actionSubjectId: "rovoSettingsModal",
                attributes: {
                    ...options.defaultSelectedId !== undefined && {
                        defaultSelectedId: options.defaultSelectedId
                    },
                    ...options.scrollToAvailableApps !== undefined && {
                        scrollToAvailableApps: options.scrollToAvailableApps
                    },
                    ...options.surface !== undefined && {
                        surface: options.surface
                    }
                }
            });
            if (initialTabId) sendAnalyticsEvent({
                action: "viewed",
                actionSubject: "tab",
                actionSubjectId: "rovoSettingsModalTab",
                attributes: {
                    tabId: initialTabId,
                    ...options.surface !== undefined && {
                        surface: options.surface
                    }
                }
            });
        };
        $[0] = items;
        $[1] = sendAnalyticsEvent;
        $[2] = t2;
    } else t2 = $[2];
    const open = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setIsOpen(false);
            setModalOptions(null);
        };
        $[3] = t3;
    } else t3 = $[3];
    const close = t3;
    let t4;
    let t5;
    if ($[4] !== disabled) {
        t4 = ()=>{
            if (disabled) {
                setIsOpen(false);
                setModalOptions(null);
            }
        };
        t5 = [
            disabled
        ];
        $[4] = disabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[7] !== disabled || $[8] !== isOpen || $[9] !== open) {
        t6 = disabled ? $7e70e78141b455eb$var$SIDE_NAV_MODAL_STUB : {
            open: open,
            close: close,
            isOpen: isOpen,
            disabled: false
        };
        $[7] = disabled;
        $[8] = isOpen;
        $[9] = open;
        $[10] = t6;
    } else t6 = $[10];
    const value = t6;
    let t7;
    if ($[11] !== disabled || $[12] !== isOpen || $[13] !== modalOptions?.scrollToAvailableApps) {
        t7 = ()=>({
                scrollToAvailableApps: Boolean(!disabled && isOpen && modalOptions?.scrollToAvailableApps)
            });
        $[11] = disabled;
        $[12] = isOpen;
        $[13] = modalOptions?.scrollToAvailableApps;
        $[14] = t7;
    } else t7 = $[14];
    modalOptions?.scrollToAvailableApps;
    let t8;
    if ($[15] !== t7) {
        t8 = t7();
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    const scrollContextValue = t8;
    let t9;
    if ($[17] !== disabled || $[18] !== isOpen || $[19] !== items || $[20] !== modalOptions || $[21] !== testId) {
        t9 = !disabled && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e70e78141b455eb$var$SideNavModalRenderer, {
            isOpen: isOpen,
            onClose: close,
            modalOptions: modalOptions,
            items: items,
            testId: testId
        });
        $[17] = disabled;
        $[18] = isOpen;
        $[19] = items;
        $[20] = modalOptions;
        $[21] = testId;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== children || $[24] !== scrollContextValue || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e70e78141b455eb$var$SideNavModalScrollContext.Provider, {
            value: scrollContextValue
        }, children, t9);
        $[23] = children;
        $[24] = scrollContextValue;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== t10 || $[28] !== value) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e70e78141b455eb$var$SideNavModalContext.Provider, {
            value: value
        }, t10);
        $[27] = t10;
        $[28] = value;
        $[29] = t11;
    } else t11 = $[29];
    return t11;
} : ({ children: children, items: items, disabled: disabled = false, testId: testId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [modalOptions, setModalOptions] = (0, $cozmU.useState)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        setModalOptions(options);
        setIsOpen(true);
        const initialTabId = options.defaultSelectedId ?? items[0]?.id;
        sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'modal',
            actionSubjectId: 'rovoSettingsModal',
            attributes: {
                ...options.defaultSelectedId !== undefined && {
                    defaultSelectedId: options.defaultSelectedId
                },
                ...options.scrollToAvailableApps !== undefined && {
                    scrollToAvailableApps: options.scrollToAvailableApps
                },
                ...options.surface !== undefined && {
                    surface: options.surface
                }
            }
        });
        if (initialTabId) sendAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'tab',
            actionSubjectId: 'rovoSettingsModalTab',
            attributes: {
                tabId: initialTabId,
                ...options.surface !== undefined && {
                    surface: options.surface
                }
            }
        });
    }, [
        sendAnalyticsEvent,
        items
    ]);
    const close = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setModalOptions(null);
    }, []);
    // Clean up open state when disabled transitions to true at runtime
    (0, $cozmU.useEffect)(()=>{
        if (disabled) {
            setIsOpen(false);
            setModalOptions(null);
        }
    }, [
        disabled
    ]);
    const value = (0, $cozmU.useMemo)(()=>disabled ? $7e70e78141b455eb$var$SIDE_NAV_MODAL_STUB : {
            open: open,
            close: close,
            isOpen: isOpen,
            disabled: false
        }, [
        disabled,
        open,
        close,
        isOpen
    ]);
    const scrollContextValue = (0, $cozmU.useMemo)(()=>({
            scrollToAvailableApps: Boolean(!disabled && isOpen && modalOptions?.scrollToAvailableApps)
        }), [
        disabled,
        isOpen,
        modalOptions?.scrollToAvailableApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e70e78141b455eb$var$SideNavModalContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e70e78141b455eb$var$SideNavModalScrollContext.Provider, {
        value: scrollContextValue
    }, children, !disabled && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e70e78141b455eb$var$SideNavModalRenderer, {
        isOpen: isOpen,
        onClose: close,
        modalOptions: modalOptions,
        items: items,
        testId: testId
    })));
};
const $7e70e78141b455eb$export$555940ae489e9183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($7e70e78141b455eb$var$SideNavModalScrollContext).scrollToAvailableApps;
} : ()=>(0, $cozmU.useContext)($7e70e78141b455eb$var$SideNavModalScrollContext).scrollToAvailableApps;
const $7e70e78141b455eb$export$7f616f6fda0a2a73 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($7e70e78141b455eb$var$SideNavModalContext);
    if (context !== null && ((0, $cXtTj.default).getExperimentValue("rovo_chat_3p_app_discovery_m1_experiment", "isEnabled", false, {
        fireExperimentExposure: false
    }) || (0, $cXtTj.default).getExperimentValue("memory_management_ux", "isEnabled", false, {
        fireExperimentExposure: false
    }) || [
        "short-list",
        "long-list"
    ].includes((0, $cXtTj.default).getExperimentValue("rovo_chat_settings_modal_new_apps_tab_enabled", "cohort", "control", {
        fireExperimentExposure: false
    })) || (0, $cXtTj.default).getExperimentValue("rovo_search_settings_modal_enabled", "isEnabled", false, {
        fireExperimentExposure: false
    }))) return context;
    return $7e70e78141b455eb$var$SIDE_NAV_MODAL_STUB;
} : ()=>{
    const context = (0, $cozmU.useContext)($7e70e78141b455eb$var$SideNavModalContext);
    /**
   * Return the real modal API only when at least one of the experiments that ship a
   * rovo settings modal entry point is on, and `SideNavModalProvider` is mounted.
   * Otherwise return a no-op stub: all experiments off, missing provider (e.g. unit
   * tests), or trees that have not wrapped with the provider yet.
   */ if (context !== null && ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false, {
        fireExperimentExposure: false
    }) || (0, $cXtTj.default).getExperimentValue('memory_management_ux', 'isEnabled', false, {
        fireExperimentExposure: false
    }) || [
        'short-list',
        'long-list'
    ].includes((0, $cXtTj.default).getExperimentValue('rovo_chat_settings_modal_new_apps_tab_enabled', 'cohort', 'control', {
        fireExperimentExposure: false
    })) || (0, $cXtTj.default).getExperimentValue('rovo_search_settings_modal_enabled', 'isEnabled', false, {
        fireExperimentExposure: false
    }))) return context;
    return $7e70e78141b455eb$var$SIDE_NAV_MODAL_STUB;
};
module.exports["SideNavModalProvider"] = $7e70e78141b455eb$export$cffe57958c3923f0;
module.exports["useSideNavModalScrollToAvailableApps"] = $7e70e78141b455eb$export$555940ae489e9183;
module.exports["useSideNavModal"] = $7e70e78141b455eb$export$7f616f6fda0a2a73;

});

parcelRegister("9Bssi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3ea5fcdbdd2a3db3d8f3f267a6778c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fdda46a58d223dd$var$_react = $6fdda46a58d223dd$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6fdda46a58d223dd$var$_baseNew = $6fdda46a58d223dd$var$_interopRequireDefault((parcelRequire("gElAV")));
function $6fdda46a58d223dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PowerCable".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Suggested uses: Data connectivity, Connection, Plugins, Extensions, Extensibility
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fdda46a58d223dd$var$PowerCableIcon = (props)=>/*#__PURE__*/ $6fdda46a58d223dd$var$_react.default.createElement($6fdda46a58d223dd$var$_baseNew.default, Object.assign({
        name: "PowerCableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.5 3h-3v1.5A.5.5 0 0 0 2 5h2a.5.5 0 0 0 .5-.5zM6 4.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2.25a.75.75 0 0 1 .75-.75H1V0h1.5v1.5h1V0H5v1.5h.33a.75.75 0 0 1 .67.75zm8.5 8.5h-3v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5zm1.5-1.5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2.25c0 .41.34.75.75.75H11V16h1.5v-1.5h1V16H15v-1.5h.33a.75.75 0 0 0 .67-.75z"/><path fill="currentcolor" d="M12.25 6.25a1.75 1.75 0 1 0-3.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-4h1.5v4a1.75 1.75 0 1 0 3.5 0v-3.5a3.25 3.25 0 1 1 6.5 0v4h-1.5z"/>`
    }, props));
$6fdda46a58d223dd$var$PowerCableIcon.displayName = 'PowerCableIcon';
var $6fdda46a58d223dd$var$_default = module.exports.default = $6fdda46a58d223dd$var$PowerCableIcon;

});

parcelRegister("eP3hM", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c3f48f68df089ed0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchAppsPlaceholder: {
        id: "ai-mate.chat-input.mode.menu.search-apps.placeholder",
        defaultMessage: "Search apps"
    },
    loadingApps: {
        id: "ai-mate.chat-input.mode.menu.loading-apps",
        defaultMessage: "Loading apps..."
    },
    filterByApps: {
        id: "ai-mate.chat-input.mode.menu.filter-by-apps",
        defaultMessage: "Filter by apps"
    },
    clearAll: {
        id: "ai-mate.chat-input.mode.menu.clear-all",
        defaultMessage: "Clear all"
    },
    backButtonLabel: {
        id: "ai-mate.chat-input.mode.menu.back-button-label",
        defaultMessage: "Go back"
    },
    connect: {
        id: "ai-mate.chat-input.mode.menu.connect-button-label",
        defaultMessage: "Connect"
    },
    selectApp: {
        id: "ai-mate.chat-input.mode.menu.select-app",
        defaultMessage: "Select {appName}"
    },
    deselectApp: {
        id: "ai-mate.chat-input.mode.menu.deselect-app",
        defaultMessage: "Deselect {appName}"
    },
    connectApp: {
        id: "ai-mate.chat-input.mode.menu.connect-app",
        defaultMessage: "Connect {appName}"
    },
    sourcesHeader: {
        id: "ai-mate.chat-input.mode.menu.sources-header",
        defaultMessage: "Sources"
    },
    appsHeader: {
        id: "ai-mate.chat-input.mode.menu.apps-header",
        defaultMessage: "Recently connected apps"
    },
    includeWebResults: {
        id: "ai-mate.chat-input.mode.menu.include-web-results",
        defaultMessage: "Include web results"
    },
    searchCompanyKnowledge: {
        id: "ai-mate.chat-input.mode.menu.search-company-knowledge",
        defaultMessage: "Search company knowledge"
    },
    newBadge: {
        id: "ai-mate.chat-input.mode.menu.new-badge",
        defaultMessage: "New"
    },
    viewMore: {
        id: "ai-mate.chat-input.mode.menu.view-more",
        defaultMessage: "View More"
    },
    viewMoreModalTitle: {
        id: "ai-mate.chat-input.mode.menu.view-more-modal-title",
        defaultMessage: "Sources & apps"
    },
    viewMoreConnectedApps: {
        id: "ai-mate.chat-input.mode.menu.view-more-connected-apps",
        defaultMessage: "Connected apps"
    },
    searchSettingsPlaceholder: {
        id: "ai-mate.chat-input.mode.menu.search-settings-placeholder",
        defaultMessage: "Search settings"
    },
    rovoSettingsHeader: {
        id: "ai-mate.chat-input.mode.menu.rovo-settings-header",
        defaultMessage: "Rovo Settings"
    },
    connectedAppsDescription: {
        id: "ai-mate.chat-input.mode.menu.connected-apps-description",
        defaultMessage: "Manage web results and company knowledge sources."
    },
    connectedAppsOutOfTotal: {
        id: "ai-mate.chat-input.mode.menu.connected-apps-out-of-total",
        defaultMessage: "{connectedCount} of your {totalCount} apps are connected"
    },
    connectMoreApps: {
        id: "ai-mate.chat-input.mode.menu.connect-more-apps",
        defaultMessage: "Connect more"
    },
    appsAvailableToConnectSectionHeader: {
        id: "ai-mate.chat-input.mode.menu.apps-available-to-connect-section-header",
        defaultMessage: "{count, plural, one {# app available to connect} other {# apps available to connect}}"
    },
    discoverMoreApps: {
        id: "ai-mate.chat-input.mode.menu.discover-more-apps",
        defaultMessage: "Discover more apps"
    }
});
module.exports["messages"] = $c3f48f68df089ed0$export$defe85febe8b728c;

});

parcelRegister("7685l", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $fiVb2 = parcelRequire("fiVb2");

const $69cb0d12a6c3bd0b$var$selector = (state, key)=>{
    const chatMode = state[key] || (0, $5osBM.getDerivedDefaultChatMode)();
    return {
        ...chatMode,
        ...(0, $eu92c.getDerivedReasoningMode)(chatMode.reasoningMode),
        appFilters: (0, $gchVc.getAppFilters)(chatMode.orgKnowledge)
    };
};
const $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa = (0, $kBr4q.createHook)((0, $fiVb2.store), {
    selector: $69cb0d12a6c3bd0b$var$selector
});
module.exports["useChatModeStore"] = $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa;

});

parcelRegister("glv1j", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $2uDbg = parcelRequire("2uDbg");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $jmUhx = parcelRequire("jmUhx");


var $iW7aI = parcelRequire("iW7aI");


var $krxYo = parcelRequire("krxYo");


var $kpuvJ = parcelRequire("kpuvJ");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $hLP6B = parcelRequire("hLP6B");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $c0A7H = parcelRequire("c0A7H");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $7pCWA = parcelRequire("7pCWA");


var $ekfm7 = parcelRequire("ekfm7");


var $gitiq = parcelRequire("gitiq");


var $a9u73 = parcelRequire("a9u73");


var $its7R = parcelRequire("its7R");


var $8hYSP = parcelRequire("8hYSP");


var $6xccU = parcelRequire("6xccU");


var $eP3hM = parcelRequire("eP3hM");




















var $5wHqn = parcelRequire("5wHqn");









var $4M6Ac = parcelRequire("4M6Ac");




const $b92d72d1e60f1273$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    authorizeConnectApp: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.authorize-connect-app",
        defaultMessage: "Your admin has added <strong>{appName}!</strong>{br}\n\t\t\tConnect your account to see missing results, including documents only you have access to.\n\t\t"
    },
    connect: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.connect",
        defaultMessage: "Connect"
    },
    notNow: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.not-now",
        defaultMessage: "Not now"
    }
});


const $74d0a6c3c6ad2b23$var$styles = {
    popupContent: "_2rko12b0 _1bsbtye8 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx21bp4 _bfhkvuon _16qs130s",
    buttonContainer: "_1e0c1txw _1bahesu3 _2lx2vrvc",
    button: "_19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc"
};
const $74d0a6c3c6ad2b23$var$OAuthPopupWrapperImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { app: app, source: t1, surface: surface, onAuthorizeAction: onAuthorizeAction, onCompletedAction: onCompletedAction, onDismissAction: onDismissAction, trigger: trigger, placement: placement } = t0;
    const source = t1 === undefined ? "appFilterMenu" : t1;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t2 = app.outboundAuthUrl || "";
    let t3;
    if ($[0] !== onCompletedAction) {
        t3 = ()=>{
            setIsOpen(false);
            onCompletedAction?.();
        };
        $[0] = onCompletedAction;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsOpen(false);
        };
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== app.isNewlyEnabled || $[4] !== source || $[5] !== surface) {
        t5 = {
            source: source,
            isNewlyEnabled: app.isNewlyEnabled,
            surface: surface
        };
        $[3] = app.isNewlyEnabled;
        $[4] = source;
        $[5] = surface;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== app.friendlyName || $[8] !== app.source || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
        t6 = {
            friendlyName: app.friendlyName,
            appSource: app.source,
            outboundAuthUrl: t2,
            onCompletedAction: t3,
            onFailAction: t4,
            analyticsAttributes: t5
        };
        $[7] = app.friendlyName;
        $[8] = app.source;
        $[9] = t2;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)(t6);
    let t7;
    if ($[13] !== onDismissAction) {
        t7 = ()=>{
            setIsOpen(false);
            onDismissAction?.();
        };
        $[13] = onDismissAction;
        $[14] = t7;
    } else t7 = $[14];
    const onDismiss = t7;
    let t8;
    if ($[15] !== app.isUserOAuthed || $[16] !== onAuthorize || $[17] !== onAuthorizeAction) {
        t8 = ()=>{
            if (!app.isUserOAuthed) {
                if ((0, $cXtTj.default).getExperimentValue("rovo_chat_3p_connect_one_click", "isEnabled", false) === true) {
                    onAuthorizeAction?.();
                    onAuthorize();
                    return;
                }
                setIsOpen(true);
            }
        };
        $[15] = app.isUserOAuthed;
        $[16] = onAuthorize;
        $[17] = onAuthorizeAction;
        $[18] = t8;
    } else t8 = $[18];
    const handleTriggerClick = t8;
    let t9;
    if ($[19] !== onAuthorize || $[20] !== onAuthorizeAction) {
        t9 = ()=>{
            onAuthorizeAction?.();
            onAuthorize();
        };
        $[19] = onAuthorize;
        $[20] = onAuthorizeAction;
        $[21] = t9;
    } else t9 = $[21];
    const handleAuthorizeClick = t9;
    let t10;
    if ($[22] !== handleTriggerClick || $[23] !== trigger) {
        t10 = (triggerProps)=>trigger({
                ...triggerProps,
                onClick: handleTriggerClick
            });
        $[22] = handleTriggerClick;
        $[23] = trigger;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== app.friendlyName || $[26] !== formatMessage || $[27] !== handleAuthorizeClick || $[28] !== onDismiss) {
        t11 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).authorizeConnectApp, {
                appName: app.friendlyName,
                strong: $74d0a6c3c6ad2b23$var$_temp,
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onDismiss
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).notNow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleAuthorizeClick,
                appearance: "primary"
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).connect)))));
        $[25] = app.friendlyName;
        $[26] = formatMessage;
        $[27] = handleAuthorizeClick;
        $[28] = onDismiss;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== isOpen || $[31] !== onDismiss || $[32] !== placement || $[33] !== t10 || $[34] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onDismiss,
            placement: placement,
            zIndex: 600,
            trigger: t10,
            shouldFitContainer: false,
            content: t11
        });
        $[30] = isOpen;
        $[31] = onDismiss;
        $[32] = placement;
        $[33] = t10;
        $[34] = t11;
        $[35] = t12;
    } else t12 = $[35];
    return t12;
} : ({ app: app, source: source = 'appFilterMenu', surface: surface, onAuthorizeAction: onAuthorizeAction, onCompletedAction: onCompletedAction, onDismissAction: onDismissAction, trigger: trigger, placement: placement })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)({
        friendlyName: app.friendlyName,
        appSource: app.source,
        outboundAuthUrl: app.outboundAuthUrl || '',
        onCompletedAction: ()=>{
            setIsOpen(false);
            onCompletedAction?.();
        },
        onFailAction: ()=>{
            setIsOpen(false);
        },
        analyticsAttributes: {
            source: source,
            isNewlyEnabled: app.isNewlyEnabled,
            surface: surface
        }
    });
    const onDismiss = ()=>{
        setIsOpen(false);
        onDismissAction?.();
    };
    const handleTriggerClick = ()=>{
        if (!app.isUserOAuthed) {
            // When the one-click 3P connect experiment is enabled, skip the confirmation
            // popup and take the user straight to the OAuth auth flow.
            if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_connect_one_click', 'isEnabled', false) === true) {
                onAuthorizeAction?.();
                onAuthorize();
                return;
            }
            setIsOpen(true);
        }
    };
    const handleAuthorizeClick = ()=>{
        onAuthorizeAction?.();
        onAuthorize();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: onDismiss,
        placement: placement,
        zIndex: 600,
        trigger: (triggerProps)=>trigger({
                ...triggerProps,
                onClick: handleTriggerClick
            }),
        shouldFitContainer: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).authorizeConnectApp, {
                appName: app.friendlyName,
                strong: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                        as: "strong"
                    }, text),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onDismiss
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).notNow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleAuthorizeClick,
                appearance: "primary"
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).connect)))))
    });
};
const $74d0a6c3c6ad2b23$export$766eeb8940fb526 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74d0a6c3c6ad2b23$var$OAuthPopupWrapperImpl, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74d0a6c3c6ad2b23$var$OAuthPopupWrapperImpl, props);
function $74d0a6c3c6ad2b23$var$_temp(text) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        as: "strong"
    }, text);
}



var $j3dQ1 = parcelRequire("j3dQ1");

const $cb6cdf8aaf174b1d$var$useAppTypesLoader = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    const loadKnowledgeSources = (0, $cozmU.useCallback)(async ()=>{
        try {
            const response = await assistanceService.getAgentKnowledgeConfiguration();
            return {
                type: 'available',
                sources: response.knowledgeSources
            };
        } catch (error) {
            return {
                type: 'errored',
                error: error instanceof Error ? error : new Error(String(error))
            };
        }
    }, [
        assistanceService
    ]);
    const { data: data, refetch: refetch, isFetching: isFetching } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agent-knowledge-configuration'
        ],
        queryFn: loadKnowledgeSources
    });
    return {
        cachedData: data,
        loadKnowledgeSources: refetch,
        isFetching: isFetching
    };
});
const $cb6cdf8aaf174b1d$var$styles = {
    appList: "_1bsb1osq _19bvidpf _18u0idpf",
    appListItem: "_1rjcu2gc _18zru2gc _1bsb1osq _80omtlke _bfhksm61 _irr31dpa",
    appListItemHoverFromParent: "_irr3sm61",
    appSelector: "_kqswh2mm _1ul91mjv _1bsb1osq _4t3ixilx _19bvu2gc _u5f3u2gc _1e0c1txw _2lx21bp4",
    appSelectorModal: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _kqswh2mm _1ul91mjv _1bsb1osq _4t3i1osq _1tkeidpf _1e0c1txw _2lx21bp4",
    stickyHeader: "_bfhk1bhr _n3tdu2gc _1o9zidpf",
    scrollableContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug _18m91wug _1reo15vq _1fjgurpi _1tkeidpf",
    scrollableContentLegacy: "_16jlkb7n _1o9zkb7n _i0dlf1ug _18m91wug _1reo15vq _1fjgurpi _1tkeidpf _19pkutpp",
    clearAll: "_18u01wug",
    appSelectorTitle: "_1bsb1osq",
    rovoLogoWrapper: "_2rko12b0 _1reo15vq _18m915vq _19itia51 _4t3i1tcg _1bsb1tcg _4cvr1h6o _1e0c1txw _1bah1h6o",
    placeholderLogo: "_2rko12b0 _4t3i1tcg _1bsb1tcg _bfhk115i",
    skeletonItem: "_18zrze3t _1tkezwfg",
    appItemInline: "_1e0c1txw",
    connectButtonText: "_syaz16jw _80omtlke _vjfr1r31 _10xf8stv _1w0vnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1",
    appItemContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug _u5f3u2gc",
    appItemContentNew: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    sectionHeader: "_1rjc12x7 _18zru2gc",
    searchInputWrapper: "_1o9zidpf",
    modalSectionHeader: "_1rjc12x7 _18zru2gc",
    modalSectionHeaderWithSearch: "_zulppxbi _1rjc12x7 _1e0c1txw _4cvr1h6o _1bah1yb4 _bozgidpf",
    modalSectionList: "_19itia51 _2rko12b0 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
    popupSectionList: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
    modalSectionListItem: "_1pfhidpf _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7",
    modalSectionListItemRowHover: "_80omtlke _irr31dpa",
    modalSectionListItemDivider: "_179ria51",
    sourceRow: "_1rjcu2gc _18zru2gc _1bsb1osq _bfhk1j28",
    separator: "_179ria51 _85i5u2gc _6rthu2gc",
    iconWrapper: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    viewMoreFooter: "_mqm2ia51 _1o9zidpf _1pfhu2gc _1q51u2gc",
    connectMoreAppsButton: "_2rko12b0"
};
const $cb6cdf8aaf174b1d$var$AppListItemLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { app: app, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, suppressItemHover: suppressItemHover } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== app || $[1] !== onAppSelectionChange || $[2] !== sendAnalyticsEvent) {
        t1 = ()=>{
            const newCheckedState = !app.isSelected;
            if (app.isUserOAuthed) onAppSelectionChange(app, newCheckedState);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "row",
                actionSubjectId: "rovoChatFilterByAppsClick",
                attributes: {
                    isConnected: app.isUserOAuthed,
                    interactionElement: "row",
                    isSelected: newCheckedState,
                    appSource: app.source,
                    appFriendlyName: app.friendlyName,
                    is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
                }
            });
        };
        $[0] = app;
        $[1] = onAppSelectionChange;
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const handleRowClick = t1;
    let t2;
    if ($[4] !== app || $[5] !== onAppSelectionChange || $[6] !== sendAnalyticsEvent) {
        t2 = (e)=>{
            e.stopPropagation();
            onAppSelectionChange(app, e.target.checked);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "row",
                actionSubjectId: "rovoChatFilterByAppsClick",
                attributes: {
                    isConnected: app.isUserOAuthed,
                    interactionElement: "checkbox",
                    isSelected: e.target.checked,
                    appSource: app.source,
                    appFriendlyName: app.friendlyName,
                    is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
                }
            });
        };
        $[4] = app;
        $[5] = onAppSelectionChange;
        $[6] = sendAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    const handleCheckboxChange = t2;
    const t3 = suppressItemHover ? $cb6cdf8aaf174b1d$var$styles.appListItemHoverFromParent : undefined;
    let t4;
    if ($[8] !== t3) {
        t4 = (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.appListItem, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== app.friendlyName || $[11] !== app.isSelected || $[12] !== app.isUserOAuthed || $[13] !== formatMessage) {
        t5 = !app.isUserOAuthed ? formatMessage((0, $eP3hM.messages).connectApp, {
            appName: app.friendlyName
        }) : app.isSelected ? formatMessage((0, $eP3hM.messages).deselectApp, {
            appName: app.friendlyName
        }) : formatMessage((0, $eP3hM.messages).selectApp, {
            appName: app.friendlyName
        });
        $[10] = app.friendlyName;
        $[11] = app.isSelected;
        $[12] = app.isUserOAuthed;
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = !app.isUserOAuthed;
    let t7;
    if ($[15] !== app.isSelected || $[16] !== app.source || $[17] !== handleCheckboxChange || $[18] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
            id: app.source,
            isChecked: app.isSelected,
            value: "default checkbox",
            isDisabled: t6,
            onChange: handleCheckboxChange,
            onClick: $cb6cdf8aaf174b1d$var$_temp,
            name: "checkbox-default"
        });
        $[15] = app.isSelected;
        $[16] = app.source;
        $[17] = handleCheckboxChange;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== app.iconUrl || $[21] !== app.source) {
        t8 = (0, $ixfCV.fg)("rovo_chat_use_be_knowledge_icons") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            id: app.source,
            width: 24,
            height: 24,
            src: (0, $ixfCV.fg)("use_new_knowledge_source_icon_url_prefix") ? app.iconUrl : `/gateway/api${app.iconUrl}`,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.rovoLogoWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: app.source,
            rovoLogoProps: {
                size: "small",
                label: ""
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $cb6cdf8aaf174b1d$var$styles.placeholderLogo
            })
        }));
        $[20] = app.iconUrl;
        $[21] = app.source;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== app.friendlyName) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium",
            maxLines: 1
        }, app.friendlyName);
        $[23] = app.friendlyName;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== app.isUserOAuthed || $[26] !== formatMessage) {
        t10 = !app.isUserOAuthed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.connectButtonText,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium",
            color: "color.link"
        }, formatMessage((0, $eP3hM.messages).connect)));
        $[25] = app.isUserOAuthed;
        $[26] = formatMessage;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== t10 || $[29] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, t9, t10));
        $[28] = t10;
        $[29] = t9;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== app.source || $[32] !== t11 || $[33] !== t7 || $[34] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            key: app.source,
            as: "li",
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemInline
        }, t7, t8, t11);
        $[31] = app.source;
        $[32] = t11;
        $[33] = t7;
        $[34] = t8;
        $[35] = t12;
    } else t12 = $[35];
    let t13;
    if ($[36] !== handleRowClick || $[37] !== t12 || $[38] !== t4 || $[39] !== t5) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            onClick: handleRowClick,
            xcss: t4,
            "aria-label": t5
        }, t12);
        $[36] = handleRowClick;
        $[37] = t12;
        $[38] = t4;
        $[39] = t5;
        $[40] = t13;
    } else t13 = $[40];
    const appItemContent = t13;
    let t14;
    if ($[41] !== app.source || $[42] !== onAppConnectClick) {
        t14 = ()=>onAppConnectClick?.(app.source);
        $[41] = app.source;
        $[42] = onAppConnectClick;
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== app || $[45] !== onAppSelectionChange) {
        t15 = ()=>{
            onAppSelectionChange(app, true, true);
        };
        $[44] = app;
        $[45] = onAppSelectionChange;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== appItemContent) {
        t16 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", triggerProps, appItemContent);
        $[47] = appItemContent;
        $[48] = t16;
    } else t16 = $[48];
    let t17;
    if ($[49] !== app || $[50] !== oauthSource || $[51] !== oauthSurface || $[52] !== t14 || $[53] !== t15 || $[54] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74d0a6c3c6ad2b23$export$766eeb8940fb526), {
            app: app,
            source: oauthSource,
            surface: oauthSurface,
            onAuthorizeAction: t14,
            onCompletedAction: t15,
            placement: "left",
            trigger: t16
        });
        $[49] = app;
        $[50] = oauthSource;
        $[51] = oauthSurface;
        $[52] = t14;
        $[53] = t15;
        $[54] = t16;
        $[55] = t17;
    } else t17 = $[55];
    return t17;
} : ({ app: app, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, suppressItemHover: suppressItemHover })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleRowClick = ()=>{
        const newCheckedState = !app.isSelected;
        if (app.isUserOAuthed) onAppSelectionChange(app, newCheckedState);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'row',
            actionSubjectId: 'rovoChatFilterByAppsClick',
            attributes: {
                isConnected: app.isUserOAuthed,
                interactionElement: 'row',
                isSelected: newCheckedState,
                appSource: app.source,
                appFriendlyName: app.friendlyName,
                is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
            }
        });
    };
    const handleCheckboxChange = (e)=>{
        e.stopPropagation();
        onAppSelectionChange(app, e.target.checked);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'row',
            actionSubjectId: 'rovoChatFilterByAppsClick',
            attributes: {
                isConnected: app.isUserOAuthed,
                interactionElement: 'checkbox',
                isSelected: e.target.checked,
                appSource: app.source,
                appFriendlyName: app.friendlyName,
                is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
            }
        });
    };
    const appItemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        onClick: handleRowClick,
        xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.appListItem, suppressItemHover ? $cb6cdf8aaf174b1d$var$styles.appListItemHoverFromParent : undefined),
        "aria-label": !app.isUserOAuthed ? formatMessage((0, $eP3hM.messages).connectApp, {
            appName: app.friendlyName
        }) : app.isSelected ? formatMessage((0, $eP3hM.messages).deselectApp, {
            appName: app.friendlyName
        }) : formatMessage((0, $eP3hM.messages).selectApp, {
            appName: app.friendlyName
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        key: app.source,
        as: "li",
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
        id: app.source,
        isChecked: app.isSelected,
        value: "default checkbox",
        isDisabled: !app.isUserOAuthed,
        onChange: handleCheckboxChange,
        onClick: (e_0)=>e_0.stopPropagation(),
        name: "checkbox-default"
    }), (0, $ixfCV.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        id: app.source,
        width: 24,
        height: 24,
        src: (0, $ixfCV.fg)('use_new_knowledge_source_icon_url_prefix') ? app.iconUrl : `/gateway/api${app.iconUrl}`,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.rovoLogoWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
        appSource: app.source,
        rovoLogoProps: {
            size: 'small',
            label: ''
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.placeholderLogo
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, app.friendlyName), !app.isUserOAuthed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.connectButtonText,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "medium",
        weight: "medium",
        color: "color.link"
    }, formatMessage((0, $eP3hM.messages).connect)))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74d0a6c3c6ad2b23$export$766eeb8940fb526), {
        app: app,
        source: oauthSource,
        surface: oauthSurface,
        onAuthorizeAction: ()=>onAppConnectClick?.(app.source),
        onCompletedAction: ()=>{
            onAppSelectionChange(app, true, true);
        },
        placement: "left",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", triggerProps, appItemContent)
    });
};
const $cb6cdf8aaf174b1d$var$AppListItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { app: app, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, suppressItemHover: suppressItemHover } = t0;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== app || $[1] !== onAppSelectionChange || $[2] !== sendAnalyticsEvent) {
        t1 = ()=>{
            const newCheckedState = !app.isSelected;
            if (app.isUserOAuthed) onAppSelectionChange(app, newCheckedState);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "row",
                actionSubjectId: "rovoChatFilterByAppsClick",
                attributes: {
                    isConnected: app.isUserOAuthed,
                    interactionElement: "row",
                    isSelected: newCheckedState,
                    appSource: app.source,
                    appFriendlyName: app.friendlyName,
                    is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
                }
            });
        };
        $[0] = app;
        $[1] = onAppSelectionChange;
        $[2] = sendAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const handleRowClick = t1;
    let t2;
    if ($[4] !== app || $[5] !== onAppSelectionChange || $[6] !== sendAnalyticsEvent) {
        t2 = (e)=>{
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            onAppSelectionChange(app, e.target.checked);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "row",
                actionSubjectId: "rovoChatFilterByAppsClick",
                attributes: {
                    isConnected: app.isUserOAuthed,
                    interactionElement: "toggle",
                    isSelected: e.target.checked,
                    appSource: app.source,
                    appFriendlyName: app.friendlyName,
                    is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
                }
            });
        };
        $[4] = app;
        $[5] = onAppSelectionChange;
        $[6] = sendAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    const handleToggleChange = t2;
    const t3 = suppressItemHover ? $cb6cdf8aaf174b1d$var$styles.appListItemHoverFromParent : undefined;
    let t4;
    if ($[8] !== t3) {
        t4 = (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.appListItem, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== app.friendlyName || $[11] !== app.isSelected || $[12] !== app.isUserOAuthed || $[13] !== formatMessage) {
        t5 = !app.isUserOAuthed ? formatMessage((0, $eP3hM.messages).connectApp, {
            appName: app.friendlyName
        }) : app.isSelected ? formatMessage((0, $eP3hM.messages).deselectApp, {
            appName: app.friendlyName
        }) : formatMessage((0, $eP3hM.messages).selectApp, {
            appName: app.friendlyName
        });
        $[10] = app.friendlyName;
        $[11] = app.isSelected;
        $[12] = app.isUserOAuthed;
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== app.iconUrl || $[16] !== app.source) {
        t6 = (0, $ixfCV.fg)("rovo_chat_use_be_knowledge_icons") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            id: app.source,
            width: 24,
            height: 24,
            src: (0, $ixfCV.fg)("use_new_knowledge_source_icon_url_prefix") ? app.iconUrl : `/gateway/api${app.iconUrl}`,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.rovoLogoWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: app.source,
            rovoLogoProps: {
                size: "small",
                label: ""
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $cb6cdf8aaf174b1d$var$styles.placeholderLogo
            })
        }));
        $[15] = app.iconUrl;
        $[16] = app.source;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== app.friendlyName) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium",
            maxLines: 1
        }, app.friendlyName);
        $[18] = app.friendlyName;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== app.isNewlyEnabled || $[21] !== formatMessage) {
        t8 = app.isNewlyEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery",
            isBold: true
        }, formatMessage((0, $eP3hM.messages).newBadge));
        $[20] = app.isNewlyEnabled;
        $[21] = formatMessage;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== t7 || $[24] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, t7, t8);
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== app.isSelected || $[27] !== app.isUserOAuthed || $[28] !== app.source || $[29] !== formatMessage || $[30] !== handleToggleChange) {
        t10 = app.isUserOAuthed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            id: app.source,
            isChecked: app.isSelected,
            onChange: handleToggleChange,
            size: "regular"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.connectButtonText,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium",
            color: "color.link"
        }, formatMessage((0, $eP3hM.messages).connect)));
        $[26] = app.isSelected;
        $[27] = app.isUserOAuthed;
        $[28] = app.source;
        $[29] = formatMessage;
        $[30] = handleToggleChange;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== t10 || $[33] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, t9, t10));
        $[32] = t10;
        $[33] = t9;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== app.source || $[36] !== t11 || $[37] !== t6) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            key: app.source,
            as: "li",
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemInline
        }, t6, t11);
        $[35] = app.source;
        $[36] = t11;
        $[37] = t6;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== handleRowClick || $[40] !== t12 || $[41] !== t4 || $[42] !== t5) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            onClick: handleRowClick,
            xcss: t4,
            "aria-label": t5
        }, t12);
        $[39] = handleRowClick;
        $[40] = t12;
        $[41] = t4;
        $[42] = t5;
        $[43] = t13;
    } else t13 = $[43];
    const appItemContent = t13;
    let t14;
    if ($[44] !== app.source || $[45] !== onAppConnectClick) {
        t14 = ()=>onAppConnectClick?.(app.source);
        $[44] = app.source;
        $[45] = onAppConnectClick;
        $[46] = t14;
    } else t14 = $[46];
    let t15;
    if ($[47] !== app || $[48] !== onAppSelectionChange) {
        t15 = ()=>{
            onAppSelectionChange(app, true, true);
        };
        $[47] = app;
        $[48] = onAppSelectionChange;
        $[49] = t15;
    } else t15 = $[49];
    let t16;
    if ($[50] !== appItemContent) {
        t16 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", triggerProps, appItemContent);
        $[50] = appItemContent;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== app || $[53] !== oauthSource || $[54] !== oauthSurface || $[55] !== t14 || $[56] !== t15 || $[57] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74d0a6c3c6ad2b23$export$766eeb8940fb526), {
            app: app,
            source: oauthSource,
            surface: oauthSurface,
            onAuthorizeAction: t14,
            onCompletedAction: t15,
            placement: "left",
            trigger: t16
        });
        $[52] = app;
        $[53] = oauthSource;
        $[54] = oauthSurface;
        $[55] = t14;
        $[56] = t15;
        $[57] = t16;
        $[58] = t17;
    } else t17 = $[58];
    return t17;
} : ({ app: app, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, suppressItemHover: suppressItemHover })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleRowClick = ()=>{
        const newCheckedState = !app.isSelected;
        if (app.isUserOAuthed) onAppSelectionChange(app, newCheckedState);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'row',
            actionSubjectId: 'rovoChatFilterByAppsClick',
            attributes: {
                isConnected: app.isUserOAuthed,
                interactionElement: 'row',
                isSelected: newCheckedState,
                appSource: app.source,
                appFriendlyName: app.friendlyName,
                is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
            }
        });
    };
    const handleToggleChange = (e)=>{
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        onAppSelectionChange(app, e.target.checked);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'row',
            actionSubjectId: 'rovoChatFilterByAppsClick',
            attributes: {
                isConnected: app.isUserOAuthed,
                interactionElement: 'toggle',
                isSelected: e.target.checked,
                appSource: app.source,
                appFriendlyName: app.friendlyName,
                is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
            }
        });
    };
    const appItemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        onClick: handleRowClick,
        xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.appListItem, suppressItemHover ? $cb6cdf8aaf174b1d$var$styles.appListItemHoverFromParent : undefined),
        "aria-label": !app.isUserOAuthed ? formatMessage((0, $eP3hM.messages).connectApp, {
            appName: app.friendlyName
        }) : app.isSelected ? formatMessage((0, $eP3hM.messages).deselectApp, {
            appName: app.friendlyName
        }) : formatMessage((0, $eP3hM.messages).selectApp, {
            appName: app.friendlyName
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        key: app.source,
        as: "li",
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemInline
    }, (0, $ixfCV.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        id: app.source,
        width: 24,
        height: 24,
        src: (0, $ixfCV.fg)('use_new_knowledge_source_icon_url_prefix') ? app.iconUrl : `/gateway/api${app.iconUrl}`,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.rovoLogoWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
        appSource: app.source,
        rovoLogoProps: {
            size: 'small',
            label: ''
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.placeholderLogo
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, app.friendlyName), app.isNewlyEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery",
        isBold: true
    }, formatMessage((0, $eP3hM.messages).newBadge))), app.isUserOAuthed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        id: app.source,
        isChecked: app.isSelected,
        onChange: handleToggleChange,
        size: "regular"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.connectButtonText,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "medium",
        weight: "medium",
        color: "color.link"
    }, formatMessage((0, $eP3hM.messages).connect)))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74d0a6c3c6ad2b23$export$766eeb8940fb526), {
        app: app,
        source: oauthSource,
        surface: oauthSurface,
        onAuthorizeAction: ()=>onAppConnectClick?.(app.source),
        onCompletedAction: ()=>{
            onAppSelectionChange(app, true, true);
        },
        placement: "left",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", triggerProps, appItemContent)
    });
};
const $cb6cdf8aaf174b1d$var$AppsList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { apps: apps, isLoading: isLoading, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, useLegacyItem: useLegacyItem, oauthSource: oauthSource, oauthSurface: oauthSurface, showItemDividers: t1 } = t0;
    const showItemDividers = t1 === undefined ? false : t1;
    if (isLoading) {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                as: "ul",
                space: "space.100",
                xcss: $cb6cdf8aaf174b1d$var$styles.appList
            }, [
                ...Array(7)
            ].map($cb6cdf8aaf174b1d$var$_temp2));
            $[0] = t2;
        } else t2 = $[0];
        return t2;
    }
    const ItemComponent = useLegacyItem ? $cb6cdf8aaf174b1d$var$AppListItemLegacy : $cb6cdf8aaf174b1d$var$AppListItem;
    let t2;
    if ($[1] !== ItemComponent || $[2] !== apps || $[3] !== oauthSource || $[4] !== oauthSurface || $[5] !== onAppConnectClick || $[6] !== onAppSelectionChange || $[7] !== showItemDividers || $[8] !== useLegacyItem) {
        let t3;
        if ($[10] !== ItemComponent || $[11] !== apps.length || $[12] !== oauthSource || $[13] !== oauthSurface || $[14] !== onAppConnectClick || $[15] !== onAppSelectionChange || $[16] !== showItemDividers || $[17] !== useLegacyItem) {
            t3 = (app, index_0)=>{
                const isLast = index_0 === apps.length - 1;
                const item = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, {
                    key: app.source,
                    app: app,
                    oauthSource: oauthSource,
                    oauthSurface: oauthSurface,
                    onAppConnectClick: onAppConnectClick,
                    onAppSelectionChange: onAppSelectionChange,
                    suppressItemHover: showItemDividers && !useLegacyItem
                });
                if (showItemDividers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    key: app.source,
                    as: "li",
                    xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.modalSectionListItem, !isLast && $cb6cdf8aaf174b1d$var$styles.modalSectionListItemDivider, !useLegacyItem && $cb6cdf8aaf174b1d$var$styles.modalSectionListItemRowHover)
                }, item);
                return item;
            };
            $[10] = ItemComponent;
            $[11] = apps.length;
            $[12] = oauthSource;
            $[13] = oauthSurface;
            $[14] = onAppConnectClick;
            $[15] = onAppSelectionChange;
            $[16] = showItemDividers;
            $[17] = useLegacyItem;
            $[18] = t3;
        } else t3 = $[18];
        t2 = apps.map(t3);
        $[1] = ItemComponent;
        $[2] = apps;
        $[3] = oauthSource;
        $[4] = oauthSurface;
        $[5] = onAppConnectClick;
        $[6] = onAppSelectionChange;
        $[7] = showItemDividers;
        $[8] = useLegacyItem;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[19] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            as: "ul",
            space: "space.0",
            xcss: $cb6cdf8aaf174b1d$var$styles.appList
        }, t2);
        $[19] = t2;
        $[20] = t3;
    } else t3 = $[20];
    return t3;
} : ({ apps: apps, isLoading: isLoading, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, useLegacyItem: useLegacyItem, oauthSource: oauthSource, oauthSurface: oauthSurface, showItemDividers: showItemDividers = false })=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        as: "ul",
        space: "space.100",
        xcss: $cb6cdf8aaf174b1d$var$styles.appList
    }, [
        ...Array(7)
    ].map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            key: index,
            xcss: $cb6cdf8aaf174b1d$var$styles.skeletonItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLP6B.default), {
            hasIcon: true
        }))));
    const ItemComponent = useLegacyItem ? $cb6cdf8aaf174b1d$var$AppListItemLegacy : $cb6cdf8aaf174b1d$var$AppListItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        as: "ul",
        space: "space.0",
        xcss: $cb6cdf8aaf174b1d$var$styles.appList
    }, apps.map((app, index_0)=>{
        const isLast = index_0 === apps.length - 1;
        const item = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, {
            key: app.source,
            app: app,
            oauthSource: oauthSource,
            oauthSurface: oauthSurface,
            onAppConnectClick: onAppConnectClick,
            onAppSelectionChange: onAppSelectionChange,
            suppressItemHover: showItemDividers && !useLegacyItem
        });
        if (showItemDividers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            key: app.source,
            as: "li",
            xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.modalSectionListItem, !isLast && $cb6cdf8aaf174b1d$var$styles.modalSectionListItemDivider, !useLegacyItem && $cb6cdf8aaf174b1d$var$styles.modalSectionListItemRowHover)
        }, item);
        return item;
    }));
};
const $cb6cdf8aaf174b1d$export$5b094453ea724a = ({ assistanceServiceParams: assistanceServiceParams, preservedSelectedApps: preservedSelectedApps, onChange: onChange, onClose: onClose, hideBackButton: hideBackButton = false, hideViewMoreButton: hideViewMoreButton = false, showGroupedSectionsWithCounts: showGroupedSectionsWithCounts = false, maxVisibleItems: maxVisibleItems, webSearchEnabled: webSearchEnabled, onWebSearchToggle: onWebSearchToggle, orgKnowledgeEnabled: orgKnowledgeEnabled, onOrgKnowledgeToggle: onOrgKnowledgeToggle, oauthSource: oauthSource = 'appFilterMenu', oauthSurface: oauthSurface, onAppConnectClick: onAppConnectClick, initialScrollToAvailableApps: initialScrollToAvailableApps = false, maxUnconnectedApps: maxUnconnectedApps })=>{
    const isChatAppsTabTestCohort = maxUnconnectedApps !== undefined;
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [appSelectorState, setAppSelectorState] = (0, $cozmU.useState)({
        type: 'loading'
    });
    const [allSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [storeFetching] = (0, $7pCWA.useConnectorsIsFetching)();
    const newlyEnabledConnectors = (0, $7pCWA.useNewlyEnabledConnectors)();
    const [connectors] = (0, $7pCWA.useConnectors)();
    const { loadKnowledgeSources: loadKnowledgeSources, cachedData: cachedData } = $cb6cdf8aaf174b1d$var$useAppTypesLoader({
        assistanceServiceParams: assistanceServiceParams
    });
    const inputRef = (0, $cozmU.useRef)(null);
    const appsAvailableToConnectSectionRef = (0, $cozmU.useRef)(null);
    const hasInitializedRef = (0, $cozmU.useRef)(false);
    const newlyEnabledConnectorSet = (0, $cozmU.useMemo)(()=>new Set(newlyEnabledConnectors.map((c)=>c.source)), [
        newlyEnabledConnectors
    ]);
    const isOnFiltersChangeEnabled = (0, $ixfCV.fg)('rovo-chat-input-on-filters-change-enabled');
    const { open: openSideNavModal, disabled: sideNavModalDisabled } = (0, $a9u73.useSideNavModal)();
    const productSortOrderProvider = (0, $8hYSP.useProductSortOrder)();
    const scrollToAppsAvailableToConnect = (0, $cozmU.useCallback)(()=>{
        appsAvailableToConnectSectionRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, []);
    const handleConnectMoreClick = (0, $cozmU.useCallback)(()=>{
        /** Already inside Rovo settings modal — opening again is a no-op; scroll in place */ if (oauthSource === 'rovoSettingsModal') {
            scrollToAppsAvailableToConnect();
            return;
        }
        if (!sideNavModalDisabled && ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'showRovoSettingsModal', false) || isChatAppsTabTestCohort)) openSideNavModal({
            title: formatMessage((0, $eP3hM.messages).viewMoreModalTitle),
            searchPlaceholder: formatMessage((0, $eP3hM.messages).searchSettingsPlaceholder),
            navAriaLabel: formatMessage((0, $eP3hM.messages).viewMoreModalTitle),
            // In a test cohort, "Connect more" bookends the list with the
            // footer's "View more" — both should open the new Discovery tab.
            defaultSelectedId: isChatAppsTabTestCohort ? 'discovery' : 'connected-apps',
            scrollToAvailableApps: true
        });
        else scrollToAppsAvailableToConnect();
    }, [
        oauthSource,
        openSideNavModal,
        sideNavModalDisabled,
        formatMessage,
        scrollToAppsAvailableToConnect,
        isChatAppsTabTestCohort
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false)) {
            if (storeFetching) return;
            if (allSources.length === 0 && appSelectorState.type === 'loading') return;
            if (hasInitializedRef.current) {
                setAppSelectorState((currentState)=>{
                    if (currentState.type !== 'available') return currentState;
                    const selectedSet = new Set(preservedSelectedApps.map((a)=>a.source));
                    const updatedApps = allSources.map((source)=>({
                            friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source.source, source.friendlyName),
                            source: source.source,
                            iconUrl: source.iconUrl,
                            isSelected: selectedSet.has(source.source),
                            outboundAuthUrl: source.outboundAuthUrl,
                            isUserOAuthed: source.isUserOAuthed,
                            isNewlyEnabled: newlyEnabledConnectorSet.has(source.source)
                        }));
                    return {
                        ...currentState,
                        apps: updatedApps
                    };
                });
                return;
            }
            const loadApps = async ()=>{
                if (hasInitializedRef.current) return;
                const sortProduct = await productSortOrderProvider();
                const shouldSelectAll = preservedSelectedApps.length === 0 && orgKnowledgeEnabled !== false;
                const apps = allSources.map((source)=>({
                        friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source.source, source.friendlyName),
                        source: source.source,
                        iconUrl: source.iconUrl,
                        isSelected: shouldSelectAll ? !!source.isUserOAuthed : preservedSelectedApps.find((app)=>app.source === source.source) !== undefined,
                        outboundAuthUrl: source.outboundAuthUrl,
                        isUserOAuthed: source.isUserOAuthed,
                        isNewlyEnabled: newlyEnabledConnectorSet.has(source.source)
                    })).sort((a, b)=>sortProduct(a.source, b.source));
                setAppSelectorState({
                    type: 'available',
                    apps: apps,
                    searchTerm: undefined
                });
                if (shouldSelectAll) {
                    const selectedApps = apps.filter((app)=>app.isSelected);
                    onChange(selectedApps);
                }
                hasInitializedRef.current = true;
            };
            loadApps();
        } else {
            if (appSelectorState.type !== 'loading') return;
            const loadApps = async ()=>{
                let response;
                if (cachedData && cachedData.type === 'available') response = cachedData;
                else {
                    const responseOrNull = await loadKnowledgeSources();
                    if (!responseOrNull) return;
                    response = responseOrNull;
                }
                if (response.type === 'available') {
                    const sortProduct = await productSortOrderProvider();
                    setAppSelectorState({
                        type: 'available',
                        apps: response.sources?.map((source)=>({
                                friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source.source, source.friendlyName),
                                source: source.source,
                                iconUrl: source.iconUrl,
                                isSelected: preservedSelectedApps.find((app)=>app.source === source.source) !== undefined,
                                outboundAuthUrl: source.outboundAuthUrl,
                                isUserOAuthed: source.isUserOAuthed
                            }))?.sort((a, b)=>sortProduct(a.source, b.source)) ?? [],
                        searchTerm: undefined
                    });
                } else setAppSelectorState({
                    type: 'errored',
                    error: response.error
                });
            };
            loadApps();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productSortOrderProvider,
        allSources,
        storeFetching,
        preservedSelectedApps,
        appSelectorState.type,
        cachedData,
        loadKnowledgeSources,
        onChange,
        newlyEnabledConnectorSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false) && !hasInitializedRef.current) return;
        setAppSelectorState((currentState)=>{
            if (currentState.type === 'loading' || currentState.type === 'errored') return currentState;
            return {
                ...currentState,
                apps: currentState.apps.map((app)=>({
                        ...app,
                        isSelected: preservedSelectedApps.find((a)=>a.source === app.source) !== undefined
                    }))
            };
        });
    }, [
        preservedSelectedApps,
        setAppSelectorState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false) && appSelectorState.type === 'available') inputRef.current?.focus();
    }, [
        appSelectorState
    ]);
    const onAppSelectionChange = (0, $cozmU.useCallback)((app, checked, successfulOauth)=>{
        let filteredApps = preservedSelectedApps.filter((a)=>a.source !== app.source);
        let updatedApp = {
            ...app
        };
        if (successfulOauth && appSelectorState.type === 'available') {
            updatedApp = {
                ...app,
                isUserOAuthed: true
            };
            setAppSelectorState((currentState)=>{
                if (currentState.type === 'loading' || currentState.type === 'errored') return currentState;
                return {
                    ...currentState,
                    apps: currentState.apps.map((existingApp)=>existingApp.source === app.source ? {
                            ...existingApp,
                            isUserOAuthed: true,
                            isSelected: true
                        } : existingApp)
                };
            });
        }
        if (checked) filteredApps = [
            ...filteredApps,
            updatedApp
        ];
        onChange(filteredApps);
    }, [
        preservedSelectedApps,
        onChange,
        setAppSelectorState,
        appSelectorState.type
    ]);
    const handleSearchChange = (0, $cozmU.useCallback)((searchText)=>{
        setAppSelectorState((currentState)=>{
            if (currentState.type === 'loading' || currentState.type === 'errored') return currentState;
            return {
                ...currentState,
                searchTerm: searchText
            };
        });
        sendAnalyticsEvent({
            action: 'searched',
            actionSubject: 'input',
            actionSubjectId: 'rovoChatFilterByAppsSearchInput',
            attributes: {
                searchValueLength: searchText.length
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const sortedAndFilteredApps = (0, $cozmU.useMemo)(()=>{
        if (appSelectorState.type !== 'available') return [];
        if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false)) return [
            ...appSelectorState.apps
        ].sort((a, b)=>{
            const aConnected = a.isUserOAuthed ? 1 : 0;
            const bConnected = b.isUserOAuthed ? 1 : 0;
            if (aConnected !== bConnected) return bConnected - aConnected;
            const aTimestamp = connectors[a.source]?.connectedAt ? new Date(connectors[a.source].connectedAt).getTime() : 0;
            const bTimestamp = connectors[b.source]?.connectedAt ? new Date(connectors[b.source].connectedAt).getTime() : 0;
            return bTimestamp - aTimestamp;
        });
        let filtered = appSelectorState.apps.filter((app)=>{
            if (!appSelectorState.searchTerm) return true;
            return app.friendlyName.toLowerCase().includes(appSelectorState.searchTerm.toLowerCase());
        });
        return filtered.sort((a, b)=>{
            const aConnected = a.isUserOAuthed ? 1 : 0;
            const bConnected = b.isUserOAuthed ? 1 : 0;
            return bConnected - aConnected;
        });
    }, [
        appSelectorState,
        connectors
    ]);
    const searchTerm = appSelectorState.type === 'available' ? appSelectorState.searchTerm : undefined;
    const { connectedApps: connectedApps, availableToConnectApps: availableToConnectApps } = (0, $cozmU.useMemo)(()=>{
        if (appSelectorState.type !== 'available') return {
            connectedApps: [],
            availableToConnectApps: []
        };
        let apps = sortedAndFilteredApps;
        if (showGroupedSectionsWithCounts && searchTerm) apps = apps.filter((app)=>app.friendlyName.toLowerCase().includes(searchTerm.toLowerCase()));
        const connected = apps.filter((app)=>app.isUserOAuthed);
        const available = apps.filter((app)=>!app.isUserOAuthed);
        return {
            connectedApps: connected,
            availableToConnectApps: available
        };
    }, [
        appSelectorState.type,
        searchTerm,
        sortedAndFilteredApps,
        showGroupedSectionsWithCounts
    ]);
    const totalAppsInSections = showGroupedSectionsWithCounts && appSelectorState.type === 'available' ? connectedApps.length + availableToConnectApps.length : 0;
    const shouldLimitPopupGroupedApps = showGroupedSectionsWithCounts && oauthSource !== 'rovoSettingsModal' && (0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'showRovoSettingsModal', false);
    const { connectedAppsForDisplay: connectedAppsForDisplay, availableToConnectAppsForDisplay: availableToConnectAppsForDisplay } = (0, $cozmU.useMemo)(()=>{
        if (shouldLimitPopupGroupedApps) {
            // M1 limiter: cap total visible items (connected + unconnected) to 7
            const maxVisible = 7;
            const connectedSlice = connectedApps.slice(0, Math.min(connectedApps.length, maxVisible));
            const remaining = maxVisible - connectedSlice.length;
            const availableSlice = availableToConnectApps.slice(0, remaining);
            return {
                connectedAppsForDisplay: connectedSlice,
                availableToConnectAppsForDisplay: availableSlice
            };
        } else if (maxUnconnectedApps !== undefined) // Cohort-based limit: show all connected apps, cap unconnected apps only
        return {
            connectedAppsForDisplay: connectedApps,
            availableToConnectAppsForDisplay: availableToConnectApps.slice(0, maxUnconnectedApps)
        };
        return {
            connectedAppsForDisplay: connectedApps,
            availableToConnectAppsForDisplay: availableToConnectApps
        };
    }, [
        shouldLimitPopupGroupedApps,
        connectedApps,
        availableToConnectApps,
        maxUnconnectedApps
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!initialScrollToAvailableApps) return;
        if (appSelectorState.type !== 'available' || availableToConnectApps.length === 0) return;
        const frame = requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                appsAvailableToConnectSectionRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
        return ()=>cancelAnimationFrame(frame);
    }, [
        initialScrollToAvailableApps,
        appSelectorState.type,
        availableToConnectApps.length
    ]);
    const renderContent = ()=>{
        switch(appSelectorState.type){
            case 'errored':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
            case 'loading':
            case 'available':
                if (showGroupedSectionsWithCounts && appSelectorState.type === 'available') {
                    const isModalGroupedLayout = oauthSource === 'rovoSettingsModal';
                    const connectedAppsSummaryRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                        space: "space.100",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                        size: "small",
                        weight: isModalGroupedLayout ? 'bold' : 'semibold',
                        color: isModalGroupedLayout ? 'color.text' : 'color.text.subtlest'
                    }, formatMessage((0, $eP3hM.messages).connectedAppsOutOfTotal, {
                        connectedCount: connectedApps.length,
                        totalCount: totalAppsInSections
                    })), availableToConnectApps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                        role: "button",
                        onClick: handleConnectMoreClick,
                        xcss: $cb6cdf8aaf174b1d$var$styles.connectMoreAppsButton
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                        size: "small",
                        weight: "medium",
                        color: "color.link"
                    }, formatMessage((0, $eP3hM.messages).connectMoreApps))));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                        space: "space.200"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, isModalGroupedLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        xcss: $cb6cdf8aaf174b1d$var$styles.modalSectionHeaderWithSearch
                    }, connectedAppsSummaryRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        xcss: $cb6cdf8aaf174b1d$var$styles.searchInputWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
                        placeholderText: formatMessage((0, $eP3hM.messages).searchAppsPlaceholder),
                        onSearch: handleSearchChange,
                        isDisabled: false,
                        debounceTime: 200,
                        isCompact: true
                    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        xcss: $cb6cdf8aaf174b1d$var$styles.sectionHeader
                    }, connectedAppsSummaryRow), connectedAppsForDisplay.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        xcss: isModalGroupedLayout ? $cb6cdf8aaf174b1d$var$styles.modalSectionList : $cb6cdf8aaf174b1d$var$styles.popupSectionList
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppsList, {
                        apps: connectedAppsForDisplay,
                        onAppSelectionChange: onAppSelectionChange,
                        isLoading: false,
                        useLegacyItem: !(0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false),
                        oauthSource: oauthSource,
                        oauthSurface: oauthSurface,
                        onAppConnectClick: onAppConnectClick,
                        showItemDividers: oauthSource === 'rovoSettingsModal'
                    }))), availableToConnectAppsForDisplay.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        ref: appsAvailableToConnectSectionRef
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        xcss: isModalGroupedLayout ? $cb6cdf8aaf174b1d$var$styles.modalSectionHeader : $cb6cdf8aaf174b1d$var$styles.sectionHeader
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                        size: "small",
                        weight: isModalGroupedLayout ? 'bold' : 'semibold',
                        color: isModalGroupedLayout ? 'color.text' : 'color.text.subtlest'
                    }, formatMessage((0, $eP3hM.messages).appsAvailableToConnectSectionHeader, {
                        count: availableToConnectApps.length
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                        xcss: isModalGroupedLayout ? $cb6cdf8aaf174b1d$var$styles.modalSectionList : $cb6cdf8aaf174b1d$var$styles.popupSectionList
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppsList, {
                        apps: availableToConnectAppsForDisplay,
                        onAppSelectionChange: onAppSelectionChange,
                        isLoading: false,
                        useLegacyItem: !(0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false),
                        oauthSource: oauthSource,
                        oauthSurface: oauthSurface,
                        onAppConnectClick: onAppConnectClick,
                        showItemDividers: oauthSource === 'rovoSettingsModal'
                    }))));
                }
                const appsToShow = maxVisibleItems !== undefined ? sortedAndFilteredApps.slice(0, maxVisibleItems) : sortedAndFilteredApps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppsList, {
                    apps: appsToShow,
                    onAppSelectionChange: onAppSelectionChange,
                    isLoading: appSelectorState.type === 'loading',
                    useLegacyItem: !(0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false),
                    oauthSource: oauthSource,
                    oauthSurface: oauthSurface,
                    onAppConnectClick: onAppConnectClick
                });
        }
    };
    if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false)) {
        const showSourcesSection = onWebSearchToggle !== undefined || onOrgKnowledgeToggle !== undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: showGroupedSectionsWithCounts && oauthSource === 'rovoSettingsModal' ? $cb6cdf8aaf174b1d$var$styles.appSelectorModal : $cb6cdf8aaf174b1d$var$styles.appSelector
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.scrollableContent
        }, showSourcesSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.separator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.sectionHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "small",
            weight: "semibold",
            color: "color.text.subtlest"
        }, formatMessage((0, $eP3hM.messages).sourcesHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.0"
        }, onWebSearchToggle !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            onClick: (e)=>{
                // Only handle clicks on the row itself, not on the Toggle (which handles its own events)
                // This was causing a double state change on the toggle.
                if (isOnFiltersChangeEnabled && e.target instanceof HTMLInputElement) return;
                onWebSearchToggle(!webSearchEnabled);
            },
            xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
            label: "",
            size: "medium"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium"
        }, formatMessage((0, $eP3hM.messages).includeWebResults)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            id: "web_search_toggle",
            isChecked: !!webSearchEnabled,
            onChange: (e)=>{
                e.stopPropagation();
                onWebSearchToggle(e.target.checked);
            },
            size: "regular"
        }))))), onOrgKnowledgeToggle !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            onClick: (e)=>{
                // Only handle clicks on the row itself, not on the Toggle (which handles its own events)
                // This was causing a double state change on the toggle.
                if (isOnFiltersChangeEnabled && e.target instanceof HTMLInputElement) return;
                onOrgKnowledgeToggle(!orgKnowledgeEnabled);
            },
            xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ))), {
            label: "",
            size: "medium"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium"
        }, formatMessage((0, $eP3hM.messages).searchCompanyKnowledge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            id: "org_knowledge_toggle",
            isChecked: !!orgKnowledgeEnabled,
            onChange: (e)=>{
                e.stopPropagation();
                onOrgKnowledgeToggle(e.target.checked);
            },
            size: "regular"
        }))))))), !showGroupedSectionsWithCounts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.sectionHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "small",
            weight: "semibold",
            color: "color.text.subtlest"
        }, formatMessage((0, $eP3hM.messages).appsHeader))), renderContent()), !hideViewMoreButton && !sideNavModalDisabled && ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'showRovoSettingsModal', false) || isChatAppsTabTestCohort) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.viewMoreFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow,
            onClick: ()=>{
                openSideNavModal({
                    title: formatMessage((0, $eP3hM.messages).viewMoreModalTitle),
                    searchPlaceholder: formatMessage((0, $eP3hM.messages).searchSettingsPlaceholder),
                    navAriaLabel: formatMessage((0, $eP3hM.messages).viewMoreModalTitle),
                    defaultSelectedId: isChatAppsTabTestCohort ? 'discovery' : 'connected-apps'
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
            label: "",
            size: "medium"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "medium",
            weight: "medium"
        }, formatMessage(isChatAppsTabTestCohort ? (0, $eP3hM.messages).discoverMoreApps : (0, $eP3hM.messages).viewMore)))))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appSelector
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.stickyHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $cb6cdf8aaf174b1d$var$styles.appSelectorTitle
    }, !hideBackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                size: "medium",
                label: ""
            }),
        onClick: ()=>{
            onClose?.();
        },
        label: formatMessage((0, $eP3hM.messages).backButtonLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "medium",
        weight: "semibold",
        role: "heading",
        "aria-level": 2
    }, formatMessage((0, $eP3hM.messages).filterByApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.clearAll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: ()=>onChange([]),
        isDisabled: appSelectorState.type === 'loading'
    }, formatMessage((0, $eP3hM.messages).clearAll)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
        placeholderText: formatMessage((0, $eP3hM.messages).searchAppsPlaceholder),
        onSearch: handleSearchChange,
        isDisabled: appSelectorState.type === 'loading',
        debounceTime: 200,
        ref: inputRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $cb6cdf8aaf174b1d$var$styles.scrollableContentLegacy
    }, renderContent()));
};
function $cb6cdf8aaf174b1d$var$_temp(e_0) {
    return e_0.stopPropagation();
}
function $cb6cdf8aaf174b1d$var$_temp2(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        key: index,
        xcss: $cb6cdf8aaf174b1d$var$styles.skeletonItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLP6B.default), {
        hasIcon: true
    }));
}
module.exports["FilterByAppsSelector"] = $cb6cdf8aaf174b1d$export$5b094453ea724a;

});

parcelRegister("7pCWA", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $330c78dbc9702cc6$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $ixfCV.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};



var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");




/**
 * Base path for the Rovo assist "resources" icon endpoint. The endpoint
 * resolves a connector `source` slug to a hosted icon image, e.g.
 * `/gateway/api/assist/rovo/v1/resources/icon/microsoft_onedrive`.
 */ const $c5b0757f6a449752$var$ASSIST_RESOURCES_ICON_BASE = '/gateway/api/assist/rovo/v1/resources/icon';
const $c5b0757f6a449752$export$70e383dd9d60be1d = (source)=>source ? `${$c5b0757f6a449752$var$ASSIST_RESOURCES_ICON_BASE}/${source}` : '';


const $2f811c19de96991c$export$1edd7fd2422503b1 = 'help_aggregator';
const $2f811c19de96991c$export$dc7637393f87560d = 'Atlassian Support Docs';
const $2f811c19de96991c$export$967ac09376bd9e = ()=>({
        source: $2f811c19de96991c$export$1edd7fd2422503b1,
        iconUrl: (0, $c5b0757f6a449752$export$70e383dd9d60be1d)($2f811c19de96991c$export$1edd7fd2422503b1),
        friendlyName: $2f811c19de96991c$export$dc7637393f87560d,
        // The knowledge endpoint returns this connector as already user-OAuthed; it
        // is an always-present first-party source that does not require a connect
        // flow.
        isUserOAuthed: true,
        outboundAuthUrl: '',
        connectorCreatedAt: null,
        connectedAt: null,
        resourceType: null,
        providerId: null,
        datasourceId: null,
        connectorSyncType: null
    });



var $8ICvC = parcelRequire("8ICvC");

/**
 * @internal Only for use by `coerceFirstPartyFriendlyName`.
 *
 * Name-only fallbacks for first-party products that have **no** entry in
 * {@link FirstPartyConfigs} (which is keyed by {@link ProductKeys1P}).
 *
 * TODO RAOC23: Migrate these into FirstPartyConfigs
 * TODO RAOC23: improve downstream code sites so these can be i18n (goals, projects should be translated). conversation-assistant-store does not implement i18n today for these, so there is no new regression from this code
 */ const $e4cc11cbb0be5538$var$FIRST_PARTY_FRIENDLY_NAME_FALLBACKS = {
    loom: 'Loom',
    goal: 'Goals',
    project: 'Projects'
};
const $e4cc11cbb0be5538$export$5d806d5746dae5e5 = (productKey)=>{
    const config = (0, $8ICvC.FirstPartyConfigs)[productKey];
    if (config?.displayName) return config.displayName;
    return $e4cc11cbb0be5538$var$FIRST_PARTY_FRIENDLY_NAME_FALLBACKS[productKey] ?? '';
};



var $fd0l2 = parcelRequire("fd0l2");


var $fR63l = parcelRequire("fR63l");

/**
 * @internal Only for use by `coerceFriendlyName`.
 *
 * Hard-coded English fallbacks for connectors whose static
 * {@link ThirdPartyConfigsSync} `displayName` is a non-string `React.ReactNode`
 * (e.g. a `<FormattedMessage />`), which we cannot resolve to a string
 * synchronously here.
 *
 * KNOWN EDGE CASE (RAOC-23 — to review): `atlassian-web-crawler` declares its
 * display name as a translatable `<FormattedMessage />`, so it cannot be
 * resolved to a string synchronously and falls back to this fixed English
 * string ("Web Pages"). This is the connector's canonical chat-side label: it
 * is intentionally NOT given `workspaceName` precedence (unlike the DC
 * connectors) because the chat path collapses all crawler instances into one
 * connector. We deliberately do NOT solve full i18n here — that is a larger
 * piece of the iterative migration.
 *
 * Downstreams of conversation-assistant-store do not implement i18n today, so there is no new regression from this code
 *
 * TODO RAOC-23: Improve downstream code sites to accept `string | React.ReactNode` for display names, allowing i18n names, and removing this fallback
 */ const $cb5204a5ed3b0894$var$REACT_NODE_DISPLAY_NAME_FALLBACKS = {
    [(0, $fR63l.ProductKeys3P).AtlassianWebCrawler]: 'Web Pages'
};
/**
 * @internal Only for use by `coerceFriendlyName`.
 *
 * Connectors for which the per-instance `workspaceName` from the combined-config
 * response should take precedence over the generic static catalogue name.
 *
 * `workspaceName` is opt-in (rather than applied to every connector) because its
 * meaning varies by connector type:
 *
 * TODO RAOC-23: Move this to be a variable in the config objects, and also support this in search downstream, which has its own specical logic handling this.
 */ const $cb5204a5ed3b0894$var$WORKSPACE_NAME_PRECEDENCE_KEYS = new Set([
    // NOTE: `atlassian-web-crawler` is deliberately NOT in this allowlist.
    // In Search the crawler is fanned out into one row per indexed site, each
    // labelled with its `workspaceName` (see `displayWorkspaceNameAsProductName`
    // / `fanOutConnectorSources` on the web-crawler config). On the chat path,
    // however, every crawler instance collapses into a single
    // `atlassian-web-crawler` connector, so taking one instance's
    // `workspaceName` would surface an arbitrary site name (e.g. "Atlassian
    // Community") and sort it under that name rather than the connector's own
    // identity. The crawler must instead resolve to its catalogue/fallback name
    // "Web Pages" (see `REACT_NODE_DISPLAY_NAME_FALLBACKS` below) so it sorts and
    // displays consistently. See RAOC-23.
    //
    // FC Connectors: used to distinguish from cloud products (Cloud: Confluence, DC: Bullhorn, etc.)
    (0, $fR63l.ProductKeys3P).JiraDC,
    (0, $fR63l.ProductKeys3P).JsmDC,
    (0, $fR63l.ProductKeys3P).ConfluenceDC
]);
const $cb5204a5ed3b0894$export$3ed827f54fd11033 = (displayName, workspaceName, productKey)=>{
    if (productKey !== undefined && $cb5204a5ed3b0894$var$WORKSPACE_NAME_PRECEDENCE_KEYS.has(productKey) && typeof workspaceName === 'string' && workspaceName !== '') return workspaceName;
    if (typeof displayName === 'string' && displayName !== '') return displayName;
    if (productKey) {
        const staticDisplayName = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey)?.displayName;
        if (typeof staticDisplayName === 'string' && staticDisplayName !== '') return staticDisplayName;
        const fallback = $cb5204a5ed3b0894$var$REACT_NODE_DISPLAY_NAME_FALLBACKS[productKey];
        if (fallback) return fallback;
    }
    return '';
};




var $aqAfG = parcelRequire("aqAfG");

/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than `src/services/hooks/useRovoConfigStore.tsx` —
 * it is intentionally not part of the package's public API.
 *
 * The set of first-party / noun product keys that are genuine chat connectors
 * and should be synthesised into the store as 1P entries.
 *
 * `accessibleProducts` (from combined-config) is broader than this: it also
 * includes combined-only **sub-product** keys (e.g. `jira-core`,
 * `jira-software`) and other accessible products that are not chat connectors
 * (e.g. `avp`, `devai`). The FG-off knowledge endpoint never surfaced those as
 * connectors, so emitting them here produces phantom rows with no friendly
 * name and an icon URL that does not resolve. We therefore only synthesise 1P
 * entries for keys we explicitly recognise.
 *
 * Derived from the package's canonical constants so it stays in sync as new
 * first-party products / nouns are added:
 * - every {@link ProductKeys1P} value (except the exclusions below), plus
 * - the {@link NounKeys} that chat surfaces (`goal`, `project`), plus
 * - `loom` (a first-party connector handled via the friendly-name fallback).
 *
 * TODO RAOC-23: these are genuine first-party products but the chat knowledge
 * backend has no corresponding `KnowledgeSourceType` for them yet, so they have
 * no chat `source` and their icon endpoint URLs do not resolve. They are
 * excluded here until the static-config icon lookup lands (see the icon TODO in
 * `getIconUrlForSource`). Re-include each one once it can render a resolvable
 * icon:
 * - `jira-product-discovery` (Jira Product Discovery)
 * - `cmdb` (Assets)
 * - `mercury` (Focus)
 * - `radar` (Talent)
 */ const $e919183eac44ae76$var$FIRST_PARTY_KEYS_PENDING_CHAT_SOURCE = new Set([
    (0, $aqAfG.ProductKeys1P).JiraProductDiscovery,
    (0, $aqAfG.ProductKeys1P).Assets,
    (0, $aqAfG.ProductKeys1P).Focus,
    (0, $aqAfG.ProductKeys1P).Talent
]);
/**
 * First-party product keys that are **permanently** excluded from the store —
 * they are not chat connectors and should never be synthesised, regardless of
 * any future chat-source / icon work.
 *
 * - `townsquare` (Atlas / Home) — Home is not a knowledge connector.
 */ const $e919183eac44ae76$var$FIRST_PARTY_KEYS_EXCLUDED = new Set([
    (0, $aqAfG.ProductKeys1P).Atlas
]);
const $e919183eac44ae76$var$RECOGNISED_FIRST_PARTY_KEYS = new Set([
    ...Object.values((0, $aqAfG.ProductKeys1P)),
    (0, $aqAfG.NounKeys).goal,
    (0, $aqAfG.NounKeys).project,
    'loom'
].filter((key)=>!$e919183eac44ae76$var$FIRST_PARTY_KEYS_PENDING_CHAT_SOURCE.has(key) && !$e919183eac44ae76$var$FIRST_PARTY_KEYS_EXCLUDED.has(key)));
const $e919183eac44ae76$export$e645f9e57bf8f7fc = (productKey)=>$e919183eac44ae76$var$RECOGNISED_FIRST_PARTY_KEYS.has(productKey);





/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than `src/services/hooks/useRovoConfigStore.tsx` —
 * it is intentionally not part of the package's public API.
 *
 * The set of third-party connector keys that the chat config endpoint can
 * surface in `thirdPartyConfigs` but which the chat surface does **not** yet
 * support, so they must not be projected into the store.
 *
 * This is the 3P counterpart to the 1P exclusion in
 * {@link isRecognisedFirstPartyConnector}: rather than allow-listing the keys
 * we recognise (as the 1P loop does, because `accessibleProducts` is broad and
 * noisy), the 3P config endpoint only ever returns genuine 3P connectors, so
 * we instead deny-list the specific keys that are not ready. Everything else
 * is supported by default — mirroring how `isRecognisedFirstPartyConnector`
 * stays in sync with new products via the canonical constants.
 *
 * TODO RAOC-23: `jsm-dc` (Jira Service Management Data Center) is a genuine 3P
 * connector but is not yet supported on the chat surface. Remove it from this
 * set once chat support lands.
 */ const $9c58d158feb51826$var$THIRD_PARTY_KEYS_PENDING_SUPPORT = new Set([
    (0, $fR63l.ProductKeys3P).JsmDC
]);
const $9c58d158feb51826$export$375228c3207db2cf = (productKey)=>!$9c58d158feb51826$var$THIRD_PARTY_KEYS_PENDING_SUPPORT.has(productKey);


/**
 * @file
 * RAOC-23: pure translation logic backing the `markUserConnected(source)` API
 * exposed by {@link useRovoConfigStore}.
 *
 * The chat connectors-store action `markUserConnected` is invoked with a
 * connector's chat-namespace `source` key (e.g. `'slack'`, `'google_drive'`).
 * `useRovoConfig`'s `onOAuthSuccess`, however, is keyed on the config-namespace
 * 3P **product key** (the `thirdPartyConfigs` key, e.g. `'slack'`,
 * `'google-drive'`) plus an optional `datasourceId`. This module owns the
 * translation so the hook can stay a thin wiring layer.
 *
 * Kept as a standalone pure function (rather than inline in the hook) so the
 * mapping can be unit-tested in isolation and so the hook body stays sane.
 */ /**
 * @file Store-only helpers for {@link useRovoConfigStore}.
 *
 * Map a connector identifier from the **config namespace** (what `useRovoConfig`
 * emits — `ProductResourceTypes3P` connector keys for 3P connectors, and 1P
 * product / noun keys for first-party products) to the **chat / knowledge
 * namespace** that downstream `@atlassian/conversation-assistant-store`
 * selectors key off (the `source` field returned by the knowledge endpoint).
 *
 * Internal to the store — not exported via a package subpath.
 *
 * ---------------------------------------------------------------------------
 * RAOC-23 — Why this exists
 * ---------------------------------------------------------------------------
 * On each side of the `rovo_cas_use_rovo_config` feature gate the connector
 * lists come from a different backend, and those backends return **different
 * key strings for the same connector**:
 *   - FG off → the legacy knowledge endpoint (conversational-ai-platform),
 *     which returns chat-namespace `source` strings such as `google_drive`,
 *     `microsoft_sharepoint`, `jsm`, `google_drive_sl`.
 *   - FG on  → the combined-config endpoint (via `useRovoConfig`), which
 *     returns config-namespace keys: a kebab-case product key (`drive`) plus a
 *     connector `resourceType` (`google-drive-connector`).
 * We treat the FG-on (combined-config) backend as the source of truth and
 * remap its identifiers here so that consumers of `useRovoConfigStore` always
 * see the chat-namespace `source` they were built against, regardless of the
 * gate.
 *
 * ---------------------------------------------------------------------------
 * Why keying on `resourceType` (not the product key) for 3P
 * ---------------------------------------------------------------------------
 * The kebab product key alone is **ambiguous**: a single product (e.g. config
 * `drive`) can correspond to two different knowledge `source` values depending
 * on whether the connected datasource is the full connector (`google_drive`)
 * or the SmartLinks connector (`google_drive_sl`). The only field that
 * disambiguates is the connector key — which the config response carries as
 * `resourceType` (e.g. `google-drive-connector` vs `smartlinks-connector-gdrive`),
 * matching the BE `KnowledgeSourceType.thirdPartyConnectorKey` 1:1. So 3P
 * remapping is keyed on `resourceType`; only the 1P / noun entries (which have
 * no `resourceType`) are remapped by product key.
 *
 * ---------------------------------------------------------------------------
 * Provenance
 * ---------------------------------------------------------------------------
 * Both maps below are generated from the authoritative
 * `KnowledgeSourceType` enum in conversational-ai-platform
 * (`.../platform/base/knowledge/KnowledgeSourceType.kt`): the RHS is the enum
 * `value` (`@JsonValue` = the `source` the knowledge endpoint emits) and the
 * LHS is the enum `thirdPartyConnectorKey` (3P) / config `product` (1P/noun).
 * The FG-off store keys connectors verbatim by this `source`
 * (`connectors[source.source] = ...` in
 * `conversation-assistant-store/.../connectors-store`), so it is the only
 * source of truth for the key strings.
 *
 * TODO RAOC-23: once the chat selector hooks are fully migrated and the chat
 * backend converges on the config-namespace keys, these remaps can be deleted.
 * Alternatively: converge to this version for search as well.
 */ /**
 * Maps a connector `resourceType` (config-namespace connector key, equal to
 * `ProductResourceTypes3P` values and the BE `thirdPartyConnectorKey`) to the
 * chat-namespace `source` value.
 *
 * Generated from `KnowledgeSourceType` (conversational-ai-platform). Covers
 * every 3P knowledge source, including the SmartLinks (`*_sl`) variants which
 * share a product key with their full-connector sibling but have a distinct
 * `resourceType` and a distinct `source`.
 *
 * NOTE: `forge-connector` intentionally omitted. The backend reuses the
 * generic `forge-connector` key for multiple Forge-hosted integrations, so
 * it cannot be mapped to a single `source` unambiguously. Until the backend
 * disambiguates it, Forge connectors fall through to the product-key remap
 * (and otherwise pass through unchanged) rather than silently resolving to
 * the wrong source.
 *
 * TODO RAOC-23: Move this constant into the 3P static configs per connector
 */ const $985791042dd30882$export$f3ac85cf46d74e63 = {
    'adobe-sign-connector': 'adobe_sign',
    'adobexd-connector': 'adobe_xd',
    'aha-connector': 'aha',
    'airtable-connector': 'airtable',
    'asana-connector': 'asana',
    'aws-connector': 'aws',
    'azure-connector': 'azure',
    'azure-devops-connector': 'azure_devops',
    'bitbucket-connector': 'bitbucket',
    'box-connector': 'box',
    'canva-connector': 'canva',
    'clickup-connector': 'clickup',
    'confluence-dc-connector': 'confluence-dc',
    'confluent-connector': 'confluent',
    'databricks-connector': 'databricks',
    'datadog-connector': 'datadog',
    'docker-connector': 'docker',
    'docusign-connector': 'docusign',
    'dovetail-connector': 'dovetail',
    'dropbox-connector': 'dropbox',
    'entra-id-connector': 'entra',
    'figma-connector': 'figma',
    'freshservice-connector': 'freshservice',
    'github-connector': 'github',
    'gitlab-connector': 'gitlab',
    'gmail-connector': 'gmail',
    'google-calendar-connector': 'google_calendar',
    'google-cloud-platform-connector': 'gcp',
    'google-drive-connector': 'google_drive',
    'hubspot-connector': 'hubspot',
    'jenkins-connector': 'jenkins',
    'jira-dc-connector': 'jira_dc',
    'launchdarkly-connector': 'launchdarkly',
    'loom-connector': 'loom',
    'lucid-connector': 'lucid',
    'microsoft-connector': 'microsoft',
    'microsoft-teams-connector': 'teams',
    'miro-connector': 'miro',
    'monday-connector': 'monday',
    'mural-connector': 'mural',
    'notion-connector': 'notion',
    'onedrive-connector': 'microsoft_onedrive',
    'outlook-calendar-connector': 'microsoft_outlook_calendar',
    'outlook-mail-connector': 'microsoft_outlook_mail',
    'pagerduty-connector': 'pagerduty',
    'pipedrive-connector': 'pipedrive',
    'salesforce-connector': 'salesforce',
    'sentry-connector': 'sentry',
    'servicenow-connector': 'servicenow',
    'sharepoint-connector': 'microsoft_sharepoint',
    'slack-connector': 'slack',
    'smartlinks-connector-adobexd': 'adobe_xd_sl',
    'smartlinks-connector-airtable': 'airtable_sl',
    'smartlinks-connector-amplitude': 'amplitude',
    'smartlinks-connector-asana': 'asana_sl',
    'smartlinks-connector-box': 'box_sl',
    'smartlinks-connector-clickup': 'clickup_sl',
    'smartlinks-connector-docusign': 'docusign_sl',
    'smartlinks-connector-dovetail': 'dovetail_sl',
    'smartlinks-connector-dropbox': 'dropbox_sl',
    'smartlinks-connector-figma': 'figma_sl',
    'smartlinks-connector-gdrive': 'google_drive_sl',
    'smartlinks-connector-gitlab': 'gitlab_sl',
    'smartlinks-connector-hubspot': 'hubspot_sl',
    'smartlinks-connector-launchdarkly': 'launchdarkly_sl',
    'smartlinks-connector-lucid': 'lucid_sl',
    'smartlinks-connector-miro': 'miro_sl',
    'smartlinks-connector-mural': 'mural_sl',
    'smartlinks-connector-notion': 'notion_sl',
    'smartlinks-connector-onedrive': 'microsoft_onedrive_sl',
    'smartlinks-connector-pagerduty': 'pagerduty_sl',
    'smartlinks-connector-pipedrive': 'pipedrive_sl',
    'smartlinks-connector-power-bi': 'microsoft_power_bi',
    'smartlinks-connector-salesforce': 'salesforce_sl',
    'smartlinks-connector-sentry': 'sentry_sl',
    'smartlinks-connector-sharepoint': 'microsoft_sharepoint_sl',
    'smartlinks-connector-slack': 'slack_sl',
    'smartlinks-connector-smartsheet': 'smartsheet_sl',
    'smartlinks-connector-stripe': 'stripe_sl',
    'smartlinks-connector-teams': 'microsoft_teams_sl',
    'smartlinks-connector-todoist': 'todoist',
    'smartlinks-connector-webex': 'cisco_webex',
    'smartlinks-connector-zeplin': 'zeplin',
    'smartsheet-connector': 'smartsheet',
    'splunk-connector': 'splunk',
    'stripe-connector': 'stripe',
    'webcrawler-connector': 'atlassian-web-crawler',
    'zendesk-connector': 'zendesk'
};
const $985791042dd30882$export$89fdcff8d9dee79d = {
    'jira-servicedesk': 'jsm',
    goal: 'atlas_goal',
    project: 'atlas_project'
};
const $985791042dd30882$export$7620cdb993bdcefe = (resourceType)=>resourceType ? $985791042dd30882$export$f3ac85cf46d74e63[resourceType] : undefined;
const $985791042dd30882$export$a8bdef839b443283 = (productKey)=>$985791042dd30882$export$89fdcff8d9dee79d[productKey] ?? productKey;
const $985791042dd30882$export$f64d9e2f6c8f5b6d = (productKey, resourceType)=>$985791042dd30882$export$7620cdb993bdcefe(resourceType) ?? $985791042dd30882$export$a8bdef839b443283(productKey);


const $6e29e52126d9ff5c$export$aa9890ea4e085182 = (thirdPartyConfigs, source)=>{
    if (!thirdPartyConfigs) return undefined;
    // TODO RAOC-23 add coverage for bidirectional mapping here (so that
    // smartlinks vs full connectors resolve correctly) (pending branch
    // rwasher/RAOC-23-drive-connector-collapse-fix merging will require a rebase)
    for (const [productKey, config] of Object.entries(thirdPartyConfigs)){
        if (!config) continue;
        if ((0, $985791042dd30882$export$f64d9e2f6c8f5b6d)(productKey, config.resourceType) !== source) continue;
        return {
            product: productKey
        };
    }
    return undefined;
};


const $44b64fbb9c093e8d$export$fc392cb6f9de2d01 = (entries)=>{
    const sorted = [
        ...entries
    ].sort((a, b)=>a.friendlyName.localeCompare(b.friendlyName, undefined, {
            sensitivity: 'base'
        }) || (a.source < b.source ? -1 : a.source > b.source ? 1 : 0));
    const connectors = {};
    for (const entry of sorted)connectors[entry.source] = entry;
    return connectors;
};




var $hCtla = parcelRequire("hCtla");

const $9008ed4cacfbe41b$export$a031966c0660bfc9 = (props = {})=>{
    const { accessibleProducts: accessibleProducts, thirdPartyConfigs: thirdPartyConfigs, isConfigLoaded: isConfigLoaded, onOAuthSuccess: onOAuthSuccess } = (0, $hCtla.useRovoConfig)({
        cloudId: props.cloudId,
        // Intentionally not surfaced on UseRovoConfigStoreProps — see the
        // type-level comment on that interface for rationale.
        aggAbsoluteUrl: undefined,
        multiSiteSearchInRovo: undefined,
        preloadDataProvider: undefined,
        shouldBypassPreloadProvider: undefined,
        onForgeConnectorTypeMapping: undefined
    });
    // When `cloudId` is absent `useRovoConfig` short-circuits its fetch
    // effect, so `isConfigLoaded` would stay `false` forever and chat
    // consumers would spin indefinitely with no indication that no
    // request was ever in flight. Surface an "idle" store instead:
    // not fetching, not yet attempted, empty connectors.
    // TODO RAOC-23: tighten this — `cloudId` should be a *required* prop
    // on `UseRovoConfigStoreProps` once every chat call site can supply
    // it. Removing this branch will let TypeScript catch missing tenants
    // at the call site rather than papering over them at runtime.
    const isIdle = !props.cloudId;
    // Keep a live ref to the latest `thirdPartyConfigs` so `markUserConnected`
    // resolves the `source` against the *current* config rather than the
    // render-snapshot it closed over. `useRovoConfig`'s `onOAuthSuccess` mutates
    // via its own internal ref synchronously, so reading the snapshot here would
    // resolve against stale config if `markUserConnected` is called again before
    // the resulting re-render. Mirroring the ref keeps resolution and mutation
    // consistent.
    const thirdPartyConfigsRef = (0, $cozmU.useRef)(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    // `markUserConnected(source)` — part of the store's public API (the OAuth
    // write counterpart to the connectors read-state above). The actual
    // chat-`source` → config-namespace product/datasource translation lives in
    // {@link resolveOAuthTargetForSource} to keep this hook a thin wiring layer.
    // No-op while idle, and no-op for sources with no matching 3P config.
    const markUserConnected = (0, $cozmU.useCallback)((source)=>{
        if (isIdle) return;
        const target = (0, $6e29e52126d9ff5c$export$aa9890ea4e085182)(thirdPartyConfigsRef.current, source);
        if (!target) return;
        onOAuthSuccess(target);
    }, [
        isIdle,
        onOAuthSuccess
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (isIdle) return {
            connectors: {},
            isFetching: false,
            error: null,
            lastFetchedAt: null,
            hasFetchAttempted: false,
            markUserConnected: markUserConnected
        };
        // Connectors are accumulated here, then sorted by friendlyName when
        // building the final record (see `sortConnectorsByFriendlyName`).
        const connectorEntries = [];
        // Source keys already produced, so 1P synthesis doesn't duplicate a
        // 3P connector.
        const seenKeys = new Set();
        // 3P keys with a null config — skip them in 1P synthesis below so they
        // aren't misclassified as authed 1P products.
        const skipped3pKeys = new Set();
        // 3P (and Forge) connectors — rich metadata from the config endpoint.
        // TODO: here we will need to async import/bind the 3P configs into the list from the endpoint (powers url, names, etc)
        if (thirdPartyConfigs) for (const [productKey, config] of Object.entries(thirdPartyConfigs)){
            // Some 3P connectors are returned by the config endpoint but are
            // not yet supported on the chat surface (e.g. `jsm-dc`), so skip
            // anything we do not yet support. This is the 3P counterpart to
            // the 1P allow-list guard below. See
            // {@link isSupportedThirdPartyConnector}.
            //
            // Mark the raw product key's chat form as handled so that, if the
            // unsupported key also appears in `accessibleProducts`, the 1P
            // loop below does not synthesise a phantom authed 1P entry for it
            // — the same reason the null-config and post-projection guards
            // populate `skipped3pKeys`.
            if (!(0, $9c58d158feb51826$export$375228c3207db2cf)(productKey)) {
                skipped3pKeys.add((0, $985791042dd30882$export$a8bdef839b443283)(productKey));
                continue;
            }
            // Remap the config-namespace identifier to the chat-namespace
            // `source` so downstream chat selectors find the connector
            // regardless of the `rovo_cas_use_rovo_config` gate. 3P is keyed
            // on the unambiguous `resourceType` (connector key); when the
            // config is null we have no resourceType, so fall back to the
            // product-key remap. See {@link resolveChatSource}.
            const sourceKey = (0, $985791042dd30882$export$f64d9e2f6c8f5b6d)(productKey, config?.resourceType);
            if (!config) {
                skipped3pKeys.add(sourceKey);
                continue;
            }
            seenKeys.add(sourceKey);
            connectorEntries.push({
                source: sourceKey,
                iconUrl: (0, $c5b0757f6a449752$export$70e383dd9d60be1d)(sourceKey),
                // TODO RAOC-23: reach into the per-config strings catalogue for the real icon URL rather than deriving it from the assist resources endpoint here.
                friendlyName: (0, $cb5204a5ed3b0894$export$3ed827f54fd11033)(config.displayName, config.workspaceName, productKey),
                // `userNeedsOAuth === false` => user has authed; treat unknown as authed
                // to avoid hiding connectors that don't participate in OAuth.
                isUserOAuthed: config.userNeedsOAuth !== true,
                outboundAuthUrl: config.outboundAuthUrl ?? '',
                connectorCreatedAt: config.connectorCreatedAt ?? null,
                connectedAt: config.connectedAt ?? null,
                resourceType: config.resourceType ?? null,
                providerId: config.providerId ?? null,
                datasourceId: config.datasourceId ?? null,
                connectorSyncType: config.connectorSyncType ?? null
            });
            // The 3P entry was written under the (possibly remapped) chat
            // `sourceKey`, but `accessibleProducts` references the raw product
            // key. Mark the raw product key's chat form as handled so the 1P
            // loop below does not synthesise a phantom authed 1P entry under
            // the original product key alongside the correctly-remapped 3P
            // entry (e.g. a remapped `drive` → `google_drive` would otherwise
            // also produce a stray `drive` 1P entry).
            skipped3pKeys.add((0, $985791042dd30882$export$a8bdef839b443283)(productKey));
        }
        // 1P products — synthesised stub entries so the shape is complete.
        // `accessibleProducts` is the union of 1P + already-OAuthed 3P, so we
        // skip (a) any key already covered by `thirdPartyConfigs` above, and
        // (b) any key we *intentionally* skipped from `thirdPartyConfigs`
        // because its config was null — those are still 3P, just unconfigured.
        if (accessibleProducts) for (const productKey_0 of accessibleProducts){
            // `accessibleProducts` includes combined-only sub-product keys
            // (e.g. `jira-core`, `jira-software`) and accessible products
            // that are not chat connectors (e.g. `avp`, `devai`). The FG-off
            // knowledge endpoint never surfaced those as connectors, and they
            // have no friendly name or resolvable icon, so skip anything we do
            // not explicitly recognise. See {@link isRecognisedFirstPartyConnector}.
            if (!(0, $e919183eac44ae76$export$e645f9e57bf8f7fc)(productKey_0)) continue;
            // 1P / noun products have no `resourceType`, so they are remapped
            // by product key. Done before the collision checks so a remapped
            // key (e.g. `jira-servicedesk` → `jsm`) is compared against the
            // same namespace used for the 3P entries and `skipped3pKeys`
            // above. See {@link toChatSourceKey}.
            const sourceKey_0 = (0, $985791042dd30882$export$a8bdef839b443283)(productKey_0);
            if (seenKeys.has(sourceKey_0) || skipped3pKeys.has(sourceKey_0)) continue;
            seenKeys.add(sourceKey_0);
            connectorEntries.push({
                source: sourceKey_0,
                iconUrl: (0, $c5b0757f6a449752$export$70e383dd9d60be1d)(sourceKey_0),
                friendlyName: (0, $e4cc11cbb0be5538$export$5d806d5746dae5e5)(productKey_0),
                isUserOAuthed: true,
                // 1P is implicitly authed.
                outboundAuthUrl: '',
                connectorCreatedAt: null,
                connectedAt: null,
                resourceType: null,
                providerId: null,
                datasourceId: null,
                connectorSyncType: null
            });
        }
        // Always-present synthetic connector for the help/support docs
        // aggregator, added once config has loaded. It is authoritative for its
        // key: any real connector already produced with the same `source` is
        // replaced rather than duplicated.
        if (isConfigLoaded) {
            const helpAggregator = (0, $2f811c19de96991c$export$967ac09376bd9e)();
            if (seenKeys.has(helpAggregator.source)) {
                const existingIndex = connectorEntries.findIndex((entry)=>entry.source === helpAggregator.source);
                connectorEntries.splice(existingIndex, 1);
            }
            connectorEntries.push(helpAggregator);
        }
        return {
            connectors: (0, $44b64fbb9c093e8d$export$fc392cb6f9de2d01)(connectorEntries),
            isFetching: !isConfigLoaded,
            error: null,
            lastFetchedAt: null,
            hasFetchAttempted: isConfigLoaded,
            markUserConnected: markUserConnected
        };
    }, [
        isIdle,
        accessibleProducts,
        thirdPartyConfigs,
        isConfigLoaded,
        markUserConnected
    ]);
};










const $955d6a3eafdfc84c$var$initialState = {
    siteId: undefined
};
const $955d6a3eafdfc84c$export$8bbd526186d37358 = (0, $8s9DV.createStore)({
    name: 'rovoConfigSiteIdStore',
    initialState: $955d6a3eafdfc84c$var$initialState,
    actions: {
        setSiteId: (siteId)=>({ getState: getState, setState: setState })=>{
                // Only re-render consumers when the tenant actually changes.
                if (getState().siteId === siteId) return;
                setState({
                    siteId: siteId
                });
            }
    }
});
const $955d6a3eafdfc84c$export$f6673eaeb9b549fc = (0, $kBr4q.createStateHook)($955d6a3eafdfc84c$export$8bbd526186d37358, {
    selector: (state)=>state.siteId
});
const $955d6a3eafdfc84c$var$useSiteIdActions = (0, $kBr4q.createActionsHook)($955d6a3eafdfc84c$export$8bbd526186d37358);
const $955d6a3eafdfc84c$export$8b2b764904b0a042 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { setSiteId: setSiteId } = $955d6a3eafdfc84c$var$useSiteIdActions();
    return setSiteId;
} : ()=>{
    const { setSiteId: setSiteId } = $955d6a3eafdfc84c$var$useSiteIdActions();
    return setSiteId;
};



var $7pCWA = parcelRequire("7pCWA");

const $5a56dcf5e04d6ce9$var$warnNoop = (name)=>(...args)=>{
        // eslint-disable-next-line no-console
        console.warn(`[RAOC-23] No-op stub called: ${name}. Under rovo_cas_use_rovo_config FG, connectors-store actions are not yet wired.`, ...args);
    };
/**
 * No-op action stubs for the connectors-store *writes* that are not yet wired
 * on the rovo-config path.
 *
 * TODO RAOC-23: implement the remaining real actions backed by
 *               `useRovoConfigStore` (setKnowledgeSources, setError,
 *               markLastUsed)
 */ const $5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS = {
    setKnowledgeSources: $5a56dcf5e04d6ce9$var$warnNoop('setKnowledgeSources'),
    setError: $5a56dcf5e04d6ce9$var$warnNoop('setError'),
    markLastUsed: $5a56dcf5e04d6ce9$var$warnNoop('markLastUsed')
};
/**
 * Single co-located controller for the rovo-config FG path.
 *
 * Consolidates:
 *
 *   1. the captured tenant (`siteId` === cloudId) read back from
 *      {@link useRovoConfigSiteId};
 *   2. the connector read-state, fetched declaratively by
 *      `useRovoConfigStore({ cloudId })`; and
 *   3. the bound actions object (tenant-capturing `fetchIfEmpty` /
 *      `prefetchIfEmpty`, the real `markUserConnected`, and the remaining
 *      no-op writes).
 *
 * Every `*FromRovoConfig` selector hook delegates here and then projects the
 * slice of state it needs.
 */ const $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(16);
    const captureSiteId = (0, $955d6a3eafdfc84c$export$8b2b764904b0a042)();
    const siteId = (0, $955d6a3eafdfc84c$export$f6673eaeb9b549fc)();
    let t0;
    if ($[0] !== siteId) {
        t0 = {
            cloudId: siteId
        };
        $[0] = siteId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = (0, $9008ed4cacfbe41b$export$a031966c0660bfc9)(t0);
    let markUserConnected;
    let state;
    if ($[2] !== t1) {
        ({ markUserConnected: markUserConnected, ...state } = t1);
        $[2] = t1;
        $[3] = markUserConnected;
        $[4] = state;
    } else {
        markUserConnected = $[3];
        state = $[4];
    }
    let t2;
    if ($[5] !== captureSiteId) {
        t2 = async (_fetcher, siteId_0)=>{
            captureSiteId(siteId_0);
        };
        $[5] = captureSiteId;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = t2;
    let t4;
    if ($[7] !== captureSiteId) {
        t4 = async (_fetcher_0, siteId_1, callbacks)=>{
            callbacks?.onStart?.();
            captureSiteId(siteId_1);
        };
        $[7] = captureSiteId;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = t4;
    let t6;
    if ($[9] !== markUserConnected || $[10] !== t3 || $[11] !== t5) {
        t6 = {
            ...$5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS,
            markUserConnected: markUserConnected,
            fetchIfEmpty: t3,
            prefetchIfEmpty: t5
        };
        $[9] = markUserConnected;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actions = t6;
    const t7 = state;
    let t8;
    if ($[13] !== actions || $[14] !== t7) {
        t8 = [
            t7,
            actions
        ];
        $[13] = actions;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ()=>{
    const captureSiteId = (0, $955d6a3eafdfc84c$export$8b2b764904b0a042)();
    const siteId = (0, $955d6a3eafdfc84c$export$f6673eaeb9b549fc)();
    const { markUserConnected: markUserConnected, ...state } = (0, $9008ed4cacfbe41b$export$a031966c0660bfc9)({
        cloudId: siteId
    });
    const actions = (0, $cozmU.useMemo)(()=>({
            ...$5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS,
            markUserConnected: markUserConnected,
            fetchIfEmpty: async (_fetcher, siteId_0)=>{
                // Capture the tenant so this controller can drive
                // `useRovoConfigStore({ cloudId: siteId })`.
                captureSiteId(siteId_0);
            },
            prefetchIfEmpty: async (_fetcher_0, siteId_1, callbacks)=>{
                callbacks?.onStart?.();
                // Capture the tenant so this controller can drive
                // `useRovoConfigStore({ cloudId: siteId })`. The actual fetch
                // lifecycle (success/error) is owned by the declarative
                // `useRovoConfig` fetch, not by this stub.
                captureSiteId(siteId_1);
            }
        }), [
        captureSiteId,
        markUserConnected
    ]);
    return [
        state,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$1db0f214e585aaa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
} : ()=>$5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
const $5a56dcf5e04d6ce9$export$f6d78c12502aa095 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const [, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return actions;
} : ()=>{
    const [, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return actions;
};
const $5a56dcf5e04d6ce9$export$b3cad934ca5ab31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const t0 = state.connectors;
    let t1;
    if ($[0] !== actions || $[1] !== t0) {
        t1 = [
            t0,
            actions
        ];
        $[0] = actions;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.connectors,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6ffb976747141e7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== state.connectors) {
        t0 = Object.values(state.connectors);
        $[0] = state.connectors;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = t0;
    let t2;
    if ($[2] !== actions || $[3] !== t1) {
        t2 = [
            t1,
            actions
        ];
        $[2] = actions;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        Object.values(state.connectors),
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6fcdc8da0119c3fa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== actions || $[1] !== state.isFetching) {
        t0 = [
            state.isFetching,
            actions
        ];
        $[0] = actions;
        $[1] = state.isFetching;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.isFetching,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6346a2c706329c22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const t0 = state.hasFetchAttempted && !state.isFetching;
    let t1;
    if ($[0] !== actions || $[1] !== t0) {
        t1 = [
            t0,
            actions
        ];
        $[0] = actions;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.hasFetchAttempted && !state.isFetching,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$b8e06e7766358e10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [state] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== state.connectors) {
        t0 = Object.values(state.connectors).filter((0, $7pCWA.isNewlyEnabledApp));
        $[0] = state.connectors;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [state] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return Object.values(state.connectors).filter((0, $7pCWA.isNewlyEnabledApp));
};
const $5a56dcf5e04d6ce9$export$4239da95f29be831 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [, t0] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const { markUserConnected: markUserConnected } = t0;
    let t1;
    if ($[0] !== markUserConnected) {
        t1 = {
            markUserConnected: markUserConnected
        };
        $[0] = markUserConnected;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const [, { markUserConnected: markUserConnected }] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return (0, $cozmU.useMemo)(()=>({
            markUserConnected: markUserConnected
        }), [
        markUserConnected
    ]);
};


const $46a1ea770063856a$var$LS_KEY = 'rovo-connectors-metadata';
const $46a1ea770063856a$var$getPersistedMetadata = ()=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = localStorage.getItem($46a1ea770063856a$var$LS_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object') return {
                lastUsedAt: parsed.lastUsedAt ?? {}
            };
        }
    } catch  {
    // localStorage may be unavailable or corrupted
    }
    return {
        lastUsedAt: {}
    };
};
const $46a1ea770063856a$var$persistMetadata = (connectors)=>{
    try {
        const metadata = {
            lastUsedAt: {}
        };
        for (const [source, connector] of Object.entries(connectors))if (connector.lastUsedAt) metadata.lastUsedAt[source] = connector.lastUsedAt;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem($46a1ea770063856a$var$LS_KEY, JSON.stringify(metadata));
    } catch  {
    // localStorage may be unavailable
    }
};
const $46a1ea770063856a$var$initialState = {
    connectors: {},
    isFetching: false,
    error: null,
    lastFetchedAt: null,
    hasFetchAttempted: false
};
const $46a1ea770063856a$export$a7a6b0f2cd14ebd2 = (0, $8s9DV.createStore)({
    name: 'connectorsStore',
    initialState: $46a1ea770063856a$var$initialState,
    actions: {
        setKnowledgeSources: (response)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors;
                const persisted = $46a1ea770063856a$var$getPersistedMetadata();
                const now = Date.now();
                const connectors = {};
                response.knowledgeSources.forEach((source)=>{
                    const prev = existing[source.source];
                    connectors[source.source] = {
                        ...source,
                        lastUsedAt: prev?.lastUsedAt ?? persisted.lastUsedAt[source.source]
                    };
                });
                const nextState = {
                    connectors: connectors,
                    isFetching: false,
                    error: null,
                    lastFetchedAt: now,
                    hasFetchAttempted: true
                };
                setState(nextState);
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    error: error,
                    isFetching: false
                });
            },
        markUserConnected: (source)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors[source];
                if (!existing) return;
                const nextState = {
                    ...getState(),
                    connectors: {
                        ...getState().connectors,
                        [source]: {
                            ...existing,
                            isUserOAuthed: true
                        }
                    }
                };
                setState(nextState);
                $46a1ea770063856a$var$persistMetadata(nextState.connectors);
            },
        markLastUsed: (source)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors[source];
                if (!existing) return;
                const nextState = {
                    ...getState(),
                    connectors: {
                        ...getState().connectors,
                        [source]: {
                            ...existing,
                            lastUsedAt: Date.now()
                        }
                    }
                };
                setState(nextState);
                $46a1ea770063856a$var$persistMetadata(nextState.connectors);
            },
        fetchIfEmpty: (fetcher, _siteId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { isFetching: isFetching, lastFetchedAt: lastFetchedAt, hasFetchAttempted: hasFetchAttempted } = getState();
                if (isFetching || lastFetchedAt !== null || hasFetchAttempted) return;
                setState({
                    isFetching: true,
                    hasFetchAttempted: true
                });
                try {
                    const response = await fetcher();
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setKnowledgeSources(response));
                } catch (error) {
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setError(error instanceof Error ? error : new Error(String(error))));
                }
            },
        prefetchIfEmpty: (fetcher, _siteId, callbacks)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { isFetching: isFetching, lastFetchedAt: lastFetchedAt, hasFetchAttempted: hasFetchAttempted } = getState();
                if (isFetching || lastFetchedAt !== null || hasFetchAttempted) return;
                callbacks?.onStart?.();
                setState({
                    isFetching: true
                });
                try {
                    const response = await fetcher();
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setKnowledgeSources(response));
                    callbacks?.onSuccess?.();
                } catch (error) {
                    const normalizedError = error instanceof Error ? error : new Error(String(error));
                    setState({
                        error: normalizedError,
                        isFetching: false,
                        hasFetchAttempted: false
                    });
                    callbacks?.onError?.(normalizedError);
                }
            }
    }
});
const $46a1ea770063856a$export$7937e7630f0056f6 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$898eb43e6b581728 = (...args)=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$1db0f214e585aaa)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$7937e7630f0056f6(...args);
const $46a1ea770063856a$export$2747a5ab28531a82 = (0, $kBr4q.createActionsHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$84d5e4e34c83f341 = ()=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$f6d78c12502aa095)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$2747a5ab28531a82(); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$c04fb020edc7a7e1 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.connectors
});
const $46a1ea770063856a$export$16923bfe907be002 = (...args)=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$b3cad934ca5ab31)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$c04fb020edc7a7e1(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$f556525c4fd00510 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>Object.values(state.connectors)
});
const $46a1ea770063856a$export$dde4871ee2244748 = (...args)=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$6ffb976747141e7e)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$f556525c4fd00510(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$e19a704921e382b = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.isFetching
});
const $46a1ea770063856a$export$b0cd8ed831d57493 = (...args)=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$6fcdc8da0119c3fa)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$e19a704921e382b(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$274cdd492c0627f7 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.hasFetchAttempted && !state.isFetching
});
const $46a1ea770063856a$export$616b42d985fb1595 = (...args)=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$6346a2c706329c22)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$274cdd492c0627f7(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
// ---------------------------------------------------------------------------
// isNewlyEnabledApp + useNewlyEnabledConnectors
// ---------------------------------------------------------------------------
const $46a1ea770063856a$var$NEW_APP_WINDOW_MS = 2592000000; // 30 days
const $46a1ea770063856a$export$721bae997d4403d0 = (connector)=>{
    if (connector.isUserOAuthed) return false;
    if (!connector.connectorCreatedAt) return false;
    const enabledAt = new Date(connector.connectorCreatedAt).getTime();
    if (isNaN(enabledAt)) return false;
    return Date.now() - enabledAt <= $46a1ea770063856a$var$NEW_APP_WINDOW_MS;
};
const $46a1ea770063856a$var$newlyEnabledConnectorsSelector = (0, $fjHkB.createSelector)((state)=>state.connectors, (connectors)=>Object.values(connectors).filter($46a1ea770063856a$export$721bae997d4403d0));
const $46a1ea770063856a$export$c843a631d8e0397 = (0, $kBr4q.createStateHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: $46a1ea770063856a$var$newlyEnabledConnectorsSelector
});
const $46a1ea770063856a$export$863e0dc987bff04b = (...args)=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$b8e06e7766358e10)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$c843a631d8e0397(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$94f5eea2ae699a7b = (0, $kBr4q.createActionsHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$6c25604552e40c1b = ()=>(0, $330c78dbc9702cc6$export$aa9f97d4dfccb6ff)() ? (0, $5a56dcf5e04d6ce9$export$4239da95f29be831)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$94f5eea2ae699a7b(); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
module.exports["useKnowledgeSourcesStore"] = $46a1ea770063856a$export$898eb43e6b581728;
module.exports["useKnowledgeSourcesActions"] = $46a1ea770063856a$export$84d5e4e34c83f341;
module.exports["useConnectors"] = $46a1ea770063856a$export$16923bfe907be002;
module.exports["useEnabledKnowledgeSources"] = $46a1ea770063856a$export$dde4871ee2244748;
module.exports["useConnectorsIsFetching"] = $46a1ea770063856a$export$b0cd8ed831d57493;
module.exports["useConnectorsDataReady"] = $46a1ea770063856a$export$616b42d985fb1595;
module.exports["isNewlyEnabledApp"] = $46a1ea770063856a$export$721bae997d4403d0;
module.exports["useNewlyEnabledConnectors"] = $46a1ea770063856a$export$863e0dc987bff04b;

});

parcelRegister("8ICvC", function(module, exports) {
/**
 * First-party product configurations.
 * These are the Atlassian 1P products with their display metadata (icons, display names).
 */ 
var $bltJZ = parcelRequire("bltJZ");

var $NlHoa = parcelRequire("NlHoa");


var $aqAfG = parcelRequire("aqAfG");

/**
 * Default entity ATIs for Assets/CMDB (1P).
 */ const $5a926523d3fc04b7$export$9303a82ed1def835 = [
    'ati:cloud:cmdb:object',
    'ati:cloud:cmdb:schema',
    'ati:cloud:cmdb:type'
];


/**
 * Default entity ATIs for Atlas/Townsquare (1P).
 */ const $fe65860a61b90dcd$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag',
    'ati:cloud:townsquare:question',
    'ati:cloud:townsquare:learning'
];


/**
 * Default entity ATIs for Bitbucket (1P).
 * Combines devinfo pull request and repository ATIs.
 */ 
var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");

const $75d61be85073872e$export$bbc68bbdfb2251e1 = [
    ...(0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI)
];


/**
 * Default entity ATIs for Compass (1P).
 */ const $ebead1a1e45f84e3$export$7e1741905a27fa1c = [
    'ati:cloud:compass:component'
];


/**
 * Default entity ATIs for Confluence (1P).
 *
 * Intentionally excludes:
 * - `calendar` / `space-calendar` — handled via team-calendars plugin ATIs separately
 * - Legacy plugin ATIs (confluence.com.atlassian.confluence.extra.team-calendars:*, confluence.ac:*) — handled separately
 */ const $c28750505456c170$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder',
    'ati:cloud:confluence:slide',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:answer',
    'ati:cloud:confluence:question'
];


/**
 * Default entity ATIs for Focus/Mercury (1P).
 */ const $1aa4ef4643cfac70$export$e45b6700dc30d17 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];


/**
 * Default entity ATIs for Jira (1P).
 */ const $20f7d1cf01c86447$export$b4a7e1c18385196d = [
    'ati:cloud:jira:project',
    'ati:cloud:jira:issue',
    'ati:cloud:jira:filter',
    'ati:cloud:jira:dashboard',
    'ati:cloud:jira:board',
    'ati:cloud:jira:plan'
];


/**
 * Default entity ATIs for Talent/Radar (1P).
 */ const $00dded7f28999ba2$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];


/**
 * Default entity ATIs for Trello (1P).
 */ const $ecce451ed89c40dc$export$9f88fe41a620c75d = [
    'ati:cloud:trello:board',
    'ati:cloud:trello:card'
];



var $i52Hf = parcelRequire("i52Hf");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0ab7327346d1509d$export$93ca83db1787dea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "27.5092",
            height: "26.3",
            fill: "white",
            transform: "translate(6.45831 6.875)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));
const $0ab7327346d1509d$export$b0a52366c3fb9b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "28.9104",
            height: "28.8583",
            fill: "white",
            transform: "translate(5.83331 3.33337)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));
const $0ab7327346d1509d$export$1afe31d4b2891d7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "27.2333",
            height: "27.2333",
            fill: "white",
            transform: "translate(6.25 7.08334)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));
const $0ab7327346d1509d$export$7221b4e3b691d1b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$4b1b9db11d699ccb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$4d0238652f4b6bc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$24d355ce80de5803 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            height: "100%",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--tile-color,#ffc716)",
            d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            fillRule: "evenodd",
            d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
            clipRule: "evenodd"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));
const $0ab7327346d1509d$export$5427c633f31d110f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "#FB9700"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
            fill: "#101214"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "33",
            viewBox: "0 0 32 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "white"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));



var $3h5an = parcelRequire("3h5an");


var $aIhxJ = parcelRequire("aIhxJ");

const $8ce35fa7bd4698cd$export$3e4929b42b34f3a8 = {
    [(0, $aqAfG.ProductKeys1P).Confluence]: {
        displayName: 'Confluence',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.ConfluenceIcon), 'Confluence'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$93ca83db1787dea), 'Confluence', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Atlas]: {
        displayName: 'Home',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $NlHoa.AtlassianIcon), 'Home'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$b0a52366c3fb9b), 'Home', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Jira]: {
        displayName: 'Jira',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.JiraIcon), 'Jira'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $3h5an.JiraSearchResultIcon), 'Jira', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$1afe31d4b2891d7a), 'Jira Product Discovery', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.JiraServiceManagementIcon), 'Jira Service Management'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $aIhxJ.JiraServiceManagementSearchResultIcon), 'Jira Service Management', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Bitbucket]: {
        displayName: 'Bitbucket',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.BitbucketIcon), 'Bitbucket'),
        // Bitbucket uses the same icon for search results
        searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.BitbucketIcon), 'Bitbucket')
    },
    [(0, $aqAfG.ProductKeys1P).Trello]: {
        displayName: 'Trello',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.TrelloIcon), 'Trello'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$7221b4e3b691d1b3), 'Trello', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Compass]: {
        displayName: 'Compass',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.CompassIcon), 'Compass'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$4b1b9db11d699ccb), 'Compass', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Focus]: {
        displayName: 'Focus',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.FocusIcon), 'Focus'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$4d0238652f4b6bc4), 'Focus', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Assets]: {
        displayName: 'Assets',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.AssetsIcon), 'Assets'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$24d355ce80de5803), 'Assets', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Talent]: {
        displayName: 'Talent',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $bltJZ.TalentIcon), 'Talent'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $0ab7327346d1509d$export$5427c633f31d110f), 'Talent', 'large')
    }
};
const $8ce35fa7bd4698cd$export$88aff1c9a685343e = [
    (0, $aqAfG.ProductKeys1P).Confluence,
    (0, $aqAfG.ProductKeys1P).Jira,
    (0, $aqAfG.ProductKeys1P).JiraProductDiscovery,
    (0, $aqAfG.ProductKeys1P).JiraServiceManagement,
    (0, $aqAfG.ProductKeys1P).Atlas,
    (0, $aqAfG.ProductKeys1P).Trello,
    (0, $aqAfG.ProductKeys1P).Bitbucket,
    (0, $aqAfG.ProductKeys1P).Compass,
    (0, $aqAfG.ProductKeys1P).Focus,
    (0, $aqAfG.ProductKeys1P).Assets,
    (0, $aqAfG.ProductKeys1P).Talent
];
const $8ce35fa7bd4698cd$export$633a31c0b66df80f = (productKey)=>{
    return $8ce35fa7bd4698cd$export$3e4929b42b34f3a8[productKey];
};
const $8ce35fa7bd4698cd$export$6351cb1baf5bc02f = new Map([
    [
        (0, $aqAfG.ProductKeys1P).Confluence,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Confluence],
            entities: (0, $c28750505456c170$export$c07a1c127052b557)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Jira,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Jira],
            entities: (0, $20f7d1cf01c86447$export$b4a7e1c18385196d)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Atlas,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Atlas],
            entities: (0, $fe65860a61b90dcd$export$c87d62ed9387fa60)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Compass,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Compass],
            entities: (0, $ebead1a1e45f84e3$export$7e1741905a27fa1c)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Trello,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Trello],
            entities: (0, $ecce451ed89c40dc$export$9f88fe41a620c75d)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Bitbucket,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Bitbucket],
            entities: (0, $75d61be85073872e$export$bbc68bbdfb2251e1)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Assets,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Assets],
            entities: (0, $5a926523d3fc04b7$export$9303a82ed1def835)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Talent,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Talent],
            entities: (0, $00dded7f28999ba2$export$368c06447ee18b39)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Focus,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Focus],
            entities: (0, $1aa4ef4643cfac70$export$e45b6700dc30d17)
        }
    ]
]);
module.exports["FirstPartyConfigs"] = $8ce35fa7bd4698cd$export$3e4929b42b34f3a8;
module.exports["ProductsOrder1P"] = $8ce35fa7bd4698cd$export$88aff1c9a685343e;

});

parcelRegister("fd0l2", function(module, exports) {

var $au9jr = parcelRequire("au9jr");


var $hIDj1 = parcelRequire("hIDj1");


var $7WW80 = parcelRequire("7WW80");


var $52Drw = parcelRequire("52Drw");


var $juuLe = parcelRequire("juuLe");


var $4Be7r = parcelRequire("4Be7r");


var $jAKKt = parcelRequire("jAKKt");


var $9Om9G = parcelRequire("9Om9G");


var $4x6XK = parcelRequire("4x6XK");


var $fauGM = parcelRequire("fauGM");


var $fg2gb = parcelRequire("fg2gb");


var $5pWqV = parcelRequire("5pWqV");


var $8oQ7k = parcelRequire("8oQ7k");


var $kiNtZ = parcelRequire("kiNtZ");


var $k521G = parcelRequire("k521G");


var $8djpu = parcelRequire("8djpu");


var $2qza4 = parcelRequire("2qza4");


var $7dzhu = parcelRequire("7dzhu");


var $1RpaO = parcelRequire("1RpaO");


var $jENKA = parcelRequire("jENKA");


var $9JBuG = parcelRequire("9JBuG");


var $aHqTQ = parcelRequire("aHqTQ");


var $j34lg = parcelRequire("j34lg");


var $in2Pi = parcelRequire("in2Pi");


var $7vbr8 = parcelRequire("7vbr8");


var $k6vRK = parcelRequire("k6vRK");


var $aiL8h = parcelRequire("aiL8h");


var $cY0ZT = parcelRequire("cY0ZT");


var $9SYma = parcelRequire("9SYma");


var $ie06K = parcelRequire("ie06K");


var $h5NUz = parcelRequire("h5NUz");


var $9Y160 = parcelRequire("9Y160");


var $hdy05 = parcelRequire("hdy05");


var $djF8v = parcelRequire("djF8v");


var $dChew = parcelRequire("dChew");


var $TCovD = parcelRequire("TCovD");


var $feDPe = parcelRequire("feDPe");


var $klS4t = parcelRequire("klS4t");


var $hFdyH = parcelRequire("hFdyH");


var $e6TPF = parcelRequire("e6TPF");


var $7piBv = parcelRequire("7piBv");


var $3yXQ1 = parcelRequire("3yXQ1");


var $cmwLF = parcelRequire("cmwLF");


var $brRUk = parcelRequire("brRUk");


var $dwyZc = parcelRequire("dwyZc");


var $9sIt4 = parcelRequire("9sIt4");


var $7UyZr = parcelRequire("7UyZr");


var $2KPYZ = parcelRequire("2KPYZ");


var $3LgSg = parcelRequire("3LgSg");


var $bRkOn = parcelRequire("bRkOn");


var $eoGOF = parcelRequire("eoGOF");


var $jWqmd = parcelRequire("jWqmd");


var $34wuK = parcelRequire("34wuK");


var $g36Mb = parcelRequire("g36Mb");


var $eODbN = parcelRequire("eODbN");


var $2k3z5 = parcelRequire("2k3z5");


var $lHAGV = parcelRequire("lHAGV");


var $iPw5B = parcelRequire("iPw5B");


var $9lVxQ = parcelRequire("9lVxQ");


var $1HfnT = parcelRequire("1HfnT");


var $fA9zj = parcelRequire("fA9zj");


var $h8Js2 = parcelRequire("h8Js2");


var $aZX0c = parcelRequire("aZX0c");


var $382mb = parcelRequire("382mb");


var $52jas = parcelRequire("52jas");


var $kFYBW = parcelRequire("kFYBW");


var $6eg6r = parcelRequire("6eg6r");


var $cdiu6 = parcelRequire("cdiu6");


var $79ijY = parcelRequire("79ijY");


var $e7BOf = parcelRequire("e7BOf");


var $3P9fk = parcelRequire("3P9fk");


var $lSeWC = parcelRequire("lSeWC");


var $43W2t = parcelRequire("43W2t");


var $6lsSn = parcelRequire("6lsSn");


var $6ThsT = parcelRequire("6ThsT");


var $diJOH = parcelRequire("diJOH");


var $kcCFv = parcelRequire("kcCFv");


var $4TRyZ = parcelRequire("4TRyZ");


var $ijAga = parcelRequire("ijAga");


var $dPp45 = parcelRequire("dPp45");


var $emznk = parcelRequire("emznk");


var $fMCQp = parcelRequire("fMCQp");


var $iTxTm = parcelRequire("iTxTm");


var $lPRuX = parcelRequire("lPRuX");


var $2zNcl = parcelRequire("2zNcl");


var $iN1Vs = parcelRequire("iN1Vs");


var $gOrBS = parcelRequire("gOrBS");


var $kDG5l = parcelRequire("kDG5l");


var $aaz0Y = parcelRequire("aaz0Y");


var $3juV6 = parcelRequire("3juV6");


var $6sCQO = parcelRequire("6sCQO");


var $dVIA3 = parcelRequire("dVIA3");


var $fR63l = parcelRequire("fR63l");


var $5bQLl = parcelRequire("5bQLl");


var $kmEEk = parcelRequire("kmEEk");


var $3VdqU = parcelRequire("3VdqU");


var $bj13p = parcelRequire("bj13p");

const $0b44d50a3ced5459$export$f26e5f55e570679c = new Map([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        (0, $jAKKt.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $7dzhu.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        (0, $aZX0c.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $kFYBW.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $gOrBS.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        (0, $lSeWC.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $4TRyZ.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $2qza4.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $kDG5l.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $6sCQO.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        (0, $6eg6r.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        (0, $52jas.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        (0, $ijAga.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        (0, $dPp45.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        (0, $4Be7r.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        (0, $kmEEk.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $52Drw.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $aaz0Y.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $kcCFv.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $6lsSn.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $k521G.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        (0, $43W2t.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        (0, $6ThsT.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        (0, $4x6XK.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        (0, $382mb.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $8oQ7k.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        (0, $79ijY.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        (0, $e7BOf.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        (0, $fg2gb.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fauGM.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        (0, $bj13p.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        (0, $3VdqU.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        (0, $iN1Vs.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        (0, $fA9zj.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        (0, $iTxTm.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        (0, $5pWqV.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        (0, $juuLe.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        (0, $3juV6.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        (0, $hIDj1.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        (0, $7WW80.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        (0, $au9jr.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        (0, $diJOH.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        (0, $5bQLl.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        (0, $dVIA3.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        (0, $emznk.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        (0, $fMCQp.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $cdiu6.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        (0, $8djpu.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        (0, $3P9fk.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $lPRuX.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        (0, $2zNcl.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        (0, $h8Js2.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        (0, $9Om9G.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        (0, $kiNtZ.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $1RpaO.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $jENKA.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $j34lg.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $in2Pi.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        (0, $7vbr8.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        (0, $k6vRK.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        (0, $aiL8h.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        (0, $cY0ZT.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        (0, $9SYma.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        (0, $ie06K.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $h5NUz.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $9Y160.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        (0, $hdy05.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        (0, $djF8v.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $dChew.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $TCovD.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        (0, $feDPe.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        (0, $klS4t.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $hFdyH.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $e6TPF.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        (0, $7piBv.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        (0, $3yXQ1.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        (0, $cmwLF.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        (0, $brRUk.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        (0, $dwyZc.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        (0, $9sIt4.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $7UyZr.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $2KPYZ.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $9lVxQ.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $1HfnT.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $9JBuG.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $aHqTQ.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $34wuK.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $g36Mb.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $eODbN.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $2k3z5.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $lHAGV.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $iPw5B.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $3LgSg.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $bRkOn.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $eoGOF.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $jWqmd.forgeUnitoBasecampConfig)
    ]
]);
module.exports["ThirdPartyConfigsSync"] = $0b44d50a3ced5459$export$f26e5f55e570679c;

});

parcelRegister("hCtla", function(module, exports) {
/**
 * RAOC-22 — Canonical `useRovoConfig` hook, ported from
 * `@atlassian/search-page/src/controllers/config/index.tsx` (the search-page
 * `useFetchConfig`).
 *
 * This hook is intended to become the canonical way to fetch the combined
 * Rovo search bootstrap config (1P + 3P + nouns + site metadata + linked
 * sites). It is currently being rolled out behind the
 * `rovo_fps_use_rovo_config` feature gate and is **not yet** the supported
 * replacement for the legacy `useFetchConfig` (also exported from this
 * package) — that hook will only be marked `@deprecated` after rollout
 * completes. See RAOC-22.
 *
 * Also being rolled out behind the `rovo_cas_use_rovo_config` as part of RAOC-23
 * used by downstreams of conversation-assistant-store (Chat, etc)
 *
 * Differences from search-page's `useFetchConfig` body (clean up when removing rovo_fps_use_rovo_config):
 *   - `primaryProduct` is **not** a prop. Primary-product patching moves
 *     out of the hook and into search-page as a post-hook transform
 *     applied at the call site (PR-3). Per plan decision #21.
 *   - Analytics are fully internalised: the hook builds its own
 *     `fireAnalyticsEvent` via `useAnalyticsEvents()` from
 *     `@atlaskit/analytics-next` and its own `logException`. No `analytics`
 *     prop is required.
 *   - VitalStats task names are hard-coded at module scope
 *     (`search-page/combined-config-ux` and
 *     `search-page/combined-config-network`) — owned by this
 *     hook, not caller-supplied. Same rationale for `actionSubject` and the
 *     VitalStats event factories themselves (they live in
 *     `../network/network-task-tracker`, not as a prop). The analytics
 *     taxonomy is part of this hook's contract with the dashboards, not
 *     something each caller redefines. Per RAOC-22 open questions Q1
 *     and Q3 (resolved 2026-05-25).
 *   - Optional `shouldBypassPreloadProvider(preloaded)` callback lets the
 *     caller skip the preload provider for specific sources (search-page
 *     passes `isQuickFindAsyncPreloadEnabled() && preloaded?.source ===
 *     'quick-find'`). Per plan decision #5.
 *   - `preloadDataProvider` is typed as the narrow
 *     `RovoConfigPreloadProvider` (see `./combined-config/preload-types.ts`).
 *     Search-page's wider `SearchPreloadDataProvider` satisfies the narrow
 *     shape structurally.
 *   - The combined-config `parseCombinedConfig` post-processing is removed
 *     from this hook: callers that want it should call `parseCombinedConfig`
 *     directly on the returned `combinedConfigResponse`. This keeps the
 *     hook's return shape stable across the `search_async_ssr` cleanup
 *     boundary (post-cleanup shape per plan decision #7).
 *   - `isNounsAvailable` is **not** returned — per plan decision #8.
 *
 * thirdPartyConfigs{}.userNeedsOAuth is overridded by a global in-tab store
 * that tracks which products/datasources have been OAuth-connected. This is
 * to ensure that all instances of useRovoConfig reflect the same OAuth state.
 * Any usages of onOAuthSuccess will propagate the updated userNeedsOAuth value
 * to all useRovoConfig hook instances. Now when a user oauths successfully from
 * from any downstream of useRovoConfig, all experiences get the connected state (search<>chat etc)
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $kQgL7 = parcelRequire("kQgL7");


var $dv1ov = parcelRequire("dv1ov");


var $9XgN6 = parcelRequire("9XgN6");

/**
 * RAOC-22 PR-2 — Copied verbatim from
 * `@atlassian/search-page/src/controllers/config/combined-config-adapter.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Adapts the combined-config response shape to the legacy 1P/3P shape that
 * downstream consumers (third-party-products parser, site-metadata helpers)
 * still operate on. Long-term these consumers should be re-written to read
 * the combined-config shape directly (see TODO QS-9614 in search-page).
 */ const $e088b8fa7aa2d140$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $e088b8fa7aa2d140$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $e088b8fa7aa2d140$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            // field removed from aggregator; kept to satisfy TSiteMetadata type contract in search-client
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $e088b8fa7aa2d140$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $e088b8fa7aa2d140$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $e088b8fa7aa2d140$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $e088b8fa7aa2d140$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            // `product.integrationARI` arrives as `string | null` from the
            // aggregator; `T3pResource['integrationId']` is the branded
            // `PlatformIntegrationAri` nominal type. The value is already an
            // ARI string at this point (it originates server-side from the
            // platform integration registry), so this is structurally safe —
            // the cast only exists to satisfy the brand. Single-step casts
            // (`as PlatformIntegrationAri`) don't work because TS rejects
            // `string`-to-branded direct assignment; the `unknown` hop is the
            // idiomatic workaround. Same pattern is used in
            // `third-party-products.ts`. RAOC-22 follow-up: tighten in
            // search-client by exposing a constructor for branded ARIs.
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            connectedAt: product.connectedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $e088b8fa7aa2d140$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $e088b8fa7aa2d140$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            intercomHmac: configuration.intercomHmac || '',
            siteMetadata: $e088b8fa7aa2d140$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $e088b8fa7aa2d140$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};


/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/controllers/config/utils/third-party-products.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Brings the following feature gates with it (all registered in this package's
 * `platform-feature-flags` map; cleanup tracked in their respective FFCLEANUP
 * tickets — see RAOC-22 plan FG inventory):
 *   - `rovo-search-dynamic-forge-config` (FFCLEANUP-94074)
 *   - `ai_3p_slack_connector_status_transition_enabled` (no FFCLEANUP yet)
 *   - `ai3p_webcrawler_multi_domain_support` (FFCLEANUP-96797)
 */ 
var $ixfCV = parcelRequire("ixfCV");


var $aoy1P = parcelRequire("aoy1P");


var $fd0l2 = parcelRequire("fd0l2");


var $cXtTj = parcelRequire("cXtTj");




const $c2bdff781059a6b6$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $ixfCV.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
const $c2bdff781059a6b6$export$752769d90d201b0a = ()=>{
    return (0, $cXtTj.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};



var $hGRCq = parcelRequire("hGRCq");


var $eSwze = parcelRequire("eSwze");

const $dc4d5222d6ee07ae$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
const $dc4d5222d6ee07ae$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $dc4d5222d6ee07ae$export$4cb8ef4a677c563c = (resources, onForgeConnectorTypeMapping)=>{
    const THIRD_PARTY_TYPES = $dc4d5222d6ee07ae$export$6750011b01164bda();
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type) && (0, $ixfCV.fg)('rovo-search-dynamic-forge-config')) {
            const config = (0, $eSwze.mapForgeConnectorToThirdPartyConfig)(resource, onForgeConnectorTypeMapping);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        // NOTE: `productKey` is pushed unconditionally, BEFORE the `if (staticConfig)` guard
        // below. This means a connector type present in `THIRD_PARTY_TYPES` but absent from
        // `ThirdPartyConfigsSync` will appear in the returned `productKeys` without a
        // corresponding entry in `thirdPartyConfigs`. Downstream consumers must therefore
        // treat `thirdPartyConfigs[productKey]` as possibly-undefined for keys that exist in
        // `productKeys`. This is the verbatim search-page behaviour — changing the ordering
        // here would alter the analytics/contract surface and break the search-page
        // equivalence test. RAOC-22 follow-up: reconcile in a behaviour-fix PR after PR-4.
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = productKey === 'slack' && (0, $ixfCV.fg)('ai_3p_slack_connector_status_transition_enabled');
            const isFederatedNoOAuthConnector = $dc4d5222d6ee07ae$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE) && (0, $ixfCV.fg)('rovo_fps_hide_federated_servicenow_zendesk_auth');
            let sourceType;
            if (resource.type.startsWith((0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE) : (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            // The static config's `resourceType` is the *full-connector* key
            // (e.g. `box-connector`), which is correct for full/federated/lite
            // connections. But a SmartLinks connection arrives with a distinct
            // `resource.type` (e.g. `smartlinks-connector-box`) that the chat
            // layer must be able to disambiguate so it can remap to the
            // SmartLinks-specific source (e.g. `box_sl`). Inheriting only the
            // static key collapses both variants onto the full-connector source,
            // so for a *pure* SmartLinks connection we preserve the real
            // `resource.type`. See `resolveChatSource` / `SOURCE_BY_RESOURCE_TYPE`.
            //
            // Full always wins: a single product key holds one merged config, so
            // when a full connector also exists for this product we must keep the
            // full-connector `resourceType` (→ chat source `box`, not `box_sl`),
            // regardless of the order the endpoint returns the two variants in.
            // `isExistingConfigFullConnectorSource` covers "full processed first";
            // a non-SmartLinks current resource already yields the static key, so
            // the only way to reach the SmartLinks key is a SmartLinks resource
            // with no full sibling already recorded.
            //
            // We key the decision off the already-computed `sourceType` so that the
            // SmartLinks detection here cannot drift from the `sourceType`
            // classification above (both use `SMARTLINKS_CONNECTOR_SOURCE`).
            //
            // Gated behind `rovo_cas_use_rovo_config`: `map3pResourcesToProductKeys`
            // also feeds the (currently un-gated) `getThirdPartyConfigs` /
            // `parseCombinedConfig` path, so we only change the emitted
            // `resourceType` when the chat-side (CAS) consumer is enabled. When the
            // gate is off we keep the legacy static full-connector key.
            const resourceType = sourceType === (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE) && !isExistingConfigFullConnectorSource && (0, $c2bdff781059a6b6$export$aa9f97d4dfccb6ff)() ? resource.type : staticConfig.resourceType;
            config = {
                ...staticConfig,
                resourceType: resourceType,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                connectorCreatedAt: resource.connectorCreatedAt ?? undefined,
                connectedAt: resource.connectedAt ?? undefined
            };
            const datasourceList = [];
            const { datasources: _datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// Renamed to avoid shadowing the outer `_datasources` / `configWithoutDatasources`
            // destructuring above (introduced when removing the eslint-disable in the same
            // review round).
            ({ datasources: _d, ...cleanedEntry })=>cleanedEntry);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        return (0, $hGRCq.allProductKeys).includes(productKey);
    });
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};



var $gABt9 = parcelRequire("gABt9");

/**
 * RAOC: account-id resolution for the combined-config SSR cache fill.
 *
 * `useRovoConfig` no longer receives a `userId` prop. The only remaining need
 * for the Atlassian Account ID (AAID) is to write the SSR localStorage cache
 * entry under the AAID-based inner hash that the Confluence SSR preloader
 * (`@confluence/search-route-preloader` → `preloadSearch.ts`) reads back.
 *
 * This module resolves the current user's AAID via a local lookup of
 * `/gateway/api/me`, mirroring the existing pattern in
 * `@confluence/error-app` (`fetchGet('/gateway/api/me') → account_id`).
 *
 * It lives in `rovo-connectors-config` (the orchestrator of the SSR-fill)
 * rather than `search-client`, so the network call is owned by the package
 * that decides when to fill the cache; `search-client` only owns the cache
 * key shape.
 *
 * The result is memoised for the lifetime of the page: the AAID does not
 * change within a session, and the SSR-fill may run on multiple config
 * resolutions, so we fetch at most once.
 */ const $dfcac43b6a59aecf$var$RELATIVE_URL_ME = '/gateway/api/me';
/**
 * In-memory, page-lifetime memo of the in-flight (or resolved) `/me` request.
 * Reset only by a full page load. Stores the promise (not just the value) so
 * concurrent callers share a single network request.
 */ let $dfcac43b6a59aecf$var$currentUserAccountIdPromise;
const $dfcac43b6a59aecf$var$requestCurrentUserAccountId = async ()=>{
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    try {
        const response = await (0, $gABt9.utils).requestService({
            url: $dfcac43b6a59aecf$var$RELATIVE_URL_ME
        }, options);
        return response?.account_id ?? null;
    } catch  {
        // Best-effort: a failed /me lookup only degrades the SSR warm path
        // (the next SSR falls back to a network preload). Never throw.
        return null;
    }
};
const $dfcac43b6a59aecf$export$35d4e28a86099a2d = async ()=>{
    // SSR guard — the fill only ever runs in the browser.
    if (typeof window === 'undefined') return null;
    if (!$dfcac43b6a59aecf$var$currentUserAccountIdPromise) $dfcac43b6a59aecf$var$currentUserAccountIdPromise = $dfcac43b6a59aecf$var$requestCurrentUserAccountId().then((accountId)=>{
        // Do not memoise a null result: allow a later retry to succeed
        // (e.g. transient /me failure during early page load).
        if (accountId == null) $dfcac43b6a59aecf$var$currentUserAccountIdPromise = undefined;
        return accountId;
    });
    return $dfcac43b6a59aecf$var$currentUserAccountIdPromise;
};
const $dfcac43b6a59aecf$export$a4689f8cac12fef8 = ()=>{
    $dfcac43b6a59aecf$var$currentUserAccountIdPromise = undefined;
};


/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 *
 * Not exported via a package subpath — consumers should not import this
 * directly; the canonical way to fire a degraded-dependency event is by
 * passing analytics callbacks into the hook.
 *
 * NOTE: `FireAnalyticsEvent` is intentionally not imported from search-page
 * to avoid a cross-package cycle. We type the return value structurally to
 * match the search-page shape — search-page's `FireAnalyticsEvent` and ours
 * are compatible at the structural level (both extend `GasPayload &
 * AnalyticsAttributes`).
 */ const $dd25054093a45ece$export$e98932ab9e22c265 = ({ dependency: dependency, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason
            }
        }
    };
};


/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $da74afbce11dfb8c$export$7199f2d13e6ae9f7 = ({ dependency: dependency, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                ...moreContext || {}
            }
        }
    };
};



var $3X0xX = parcelRequire("3X0xX");


var $cFPRS = parcelRequire("cFPRS");

const $fbae18216f314d2d$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await (0, $cFPRS.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $3X0xX.COMMON_TAGS)))scope.setTag(key, value);
            SentryClient.captureException(error, scope);
        });
    } catch (sentryError) {
        // When there was an error with Sentry, just output to console.
        // eslint-disable-next-line no-console
        console.error(sentryError);
    }
};


/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $6d93faa27bc9189b$export$786813d6840571a0 = ({ requestName: requestName, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered
            }
        }
    };
};


/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/common/utils/network-task-tracker.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * The `task-names`/`vital-stats-events` modules referenced by the search-page
 * version live in search-page. To keep this helper self-contained inside
 * rovo-connectors-config (and free of cross-package cycles), we type the
 * task name as a plain `string` and accept the vital-stats event factories
 * (`onTaskStart` / `onTaskSuccess` / `onTaskFail`) implicitly via the
 * provided `fireAnalyticsEvent` callback — the caller in search-page builds
 * the events at the call site.
 *
 * Brings `fg('rovo-search-vitalstats-tracing-headers')`, registered in this
 * package's `platform-feature-flags` map.
 */ 



var $8N8EQ = parcelRequire("8N8EQ");

/**
 * VitalStats event factories owned by this module. The vital-stats event wire
 * shape is part of the `useRovoConfig` contract with the VitalStats taxonomy,
 * not something each caller redefines — owning them here keeps every consumer
 * emitting the same shape and prevents drift between dashboards. Behaviour is
 * identical to search-page's `onTaskStart` / `onTaskSuccess` / `onTaskFail`
 * from `common/utils/events/vital-stats-events.ts`.
 */ const $58ebc13b05b74641$var$buildVitalStatsEvent = (action, { taskId: taskId, task: task, moreContext: moreContext })=>({
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                ...moreContext
            }
        }
    });
const $58ebc13b05b74641$export$656fa717a09eb821 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskStart', args);
const $58ebc13b05b74641$export$3e9761d670712e50 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskSuccess', args);
const $58ebc13b05b74641$export$2e311f5a2c70a936 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskFail', args);
const $58ebc13b05b74641$export$b551db3ea2671aa7 = (taskId, taskName, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent($58ebc13b05b74641$export$656fa717a09eb821({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $ixfCV.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $8N8EQ.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent($58ebc13b05b74641$export$3e9761d670712e50({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $ixfCV.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $8N8EQ.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent($58ebc13b05b74641$export$2e311f5a2c70a936({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};


/**
 * @file
 * RAOC-23: pure overlay that forces `userNeedsOAuth: false` onto the
 * `thirdPartyConfigs` by useRovoConfig. Designed to be supported by a
 * singleton store to track which products/datasources have been OAuth-connected.
 *
 * Extracted as a pure function (no React, no store) so it can be unit-tested in
 * isolation and shared by whichever shared-store implementation drives it. The
 * `isConnected` predicate is injected so the overlay does not couple to the
 * store mechanism (module singleton, react-sweet-state, etc.).
 */ const $c65a9fcd52aa8158$export$d10296f0916f2406 = (configs, isConnected)=>{
    if (!configs) return configs;
    let next;
    for (const [productKey, config] of Object.entries(configs)){
        if (!config) continue;
        const productConnected = isConnected(productKey);
        // Compute any datasource-level overrides first.
        let nextDatasources;
        if (config.datasources?.length) {
            let datasourcesChanged = false;
            const mapped = config.datasources.map((ds)=>{
                if (ds.userNeedsOAuth !== false && ds.datasourceId != null && isConnected(productKey, ds.datasourceId)) {
                    datasourcesChanged = true;
                    return {
                        ...ds,
                        userNeedsOAuth: false
                    };
                }
                return ds;
            });
            if (datasourcesChanged) nextDatasources = mapped;
        }
        const needsProductFlip = productConnected && config.userNeedsOAuth !== false;
        if (!needsProductFlip && !nextDatasources) continue;
        const nextConfig = {
            ...config,
            ...needsProductFlip ? {
                userNeedsOAuth: false
            } : {},
            ...nextDatasources ? {
                datasources: nextDatasources
            } : {}
        };
        next = next ?? {
            ...configs
        };
        next[productKey] = nextConfig;
    }
    return next ?? configs;
};


/**
 * @file
 * RAOC-23: shared, in-tab OAuth-override store backing the "singleton" semantics
 * of {@link useRovoConfig}.
 *
 * ## Why this exists
 *
 * Multiple independent components may each call `useRovoConfig` (it is widely
 * shared and intentionally cheap to re-call). Each call is its own React hook
 * instance with its own `accessibleProductsConfig` state. When one instance's
 * `onOAuthSuccess` fires, it would only update *that* instance — so a connector
 * list rendered by a *different* instance would never reflect the new
 * `userNeedsOAuth: false` and would keep showing the connector as not connected.
 *
 * This module is a tiny global store of "products (optionally
 * datasources) that the user has just OAuth-connected, per cloudId". It is
 * written by `onOAuthSuccess` and **subscribed to by every `useRovoConfig`
 * instance** (via `useSyncExternalStore`). Instances overlay it onto their
 * derived `thirdPartyConfigs`, so a single OAuth success becomes reactively
 * visible across **all** instances — i.e. `useRovoConfig` behaves as a singleton
 * with respect to OAuth success actions.
 *
 * It is an **additive overlay**: it only ever forces `userNeedsOAuth` to
 * `false`. It never removes a connection and never fabricates a connector. On a
 * full reload the in-memory set is empty, but the persisted runtime cache
 * (`updateBaseCombinedConfigCacheEntry`) already re-derives the connected state,
 * so reload remains correct without this store. Or rather, persisting across reloads
 * is not the role of this store, we lean on the config/BE caching for that.
 *
 * Later improvements could layer a LS key set/subscribe here to persist into other tabs.
 */ const $78251dd6557baa84$var$SENTINEL_VALUE = '\u0000product'; // \u0000 is unicode <NUL>
/**
 * Generate a unique key for a product (optionally a specific datasource) in a
 * given cloud. The sentinel is used for whole-product entries (no datasource).
 *
 * e.g.
 * - without datasource: 	abc-cloud<NUL>amplitude<NUL><NUL>product
 * - with datasource: 		abc-cloud<NUL>amplitude<NUL>cf41ec6c-d2a1-30fd-be10-3eb26e28d71c
 */ const $78251dd6557baa84$var$makeKey = (cloudId, product, datasourceId)=>`${cloudId}\u0000${product}\u0000${datasourceId ?? $78251dd6557baa84$var$SENTINEL_VALUE}`;
/** Set of `${cloudId}\0${product}\0${datasourceId|sentinel}` entries. */ const $78251dd6557baa84$var$connected = new Set();
/** Subscribers (one per mounted `useRovoConfig` instance). */ const $78251dd6557baa84$var$listeners = new Set();
/**
 * Monotonic version counter used as the `useSyncExternalStore` snapshot. A new
 * value is returned whenever the set changes, which is what triggers subscribed
 * components to re-render. (We expose a primitive version rather than the Set
 * itself so the snapshot is referentially stable between unrelated renders.)
 */ let $78251dd6557baa84$var$version = 0;
const $78251dd6557baa84$export$dbe98d1c08f0f87d = (onStoreChange)=>{
    $78251dd6557baa84$var$listeners.add(onStoreChange);
    return ()=>{
        $78251dd6557baa84$var$listeners.delete(onStoreChange);
    };
};
const $78251dd6557baa84$export$6a79912ef915aaf2 = ()=>$78251dd6557baa84$var$version;
const $78251dd6557baa84$export$deca34c5919575a8 = (cloudId, product, datasourceId)=>{
    const key = $78251dd6557baa84$var$makeKey(cloudId, product, datasourceId);
    if ($78251dd6557baa84$var$connected.has(key)) return;
    $78251dd6557baa84$var$connected.add(key);
    $78251dd6557baa84$var$version++;
    $78251dd6557baa84$var$listeners.forEach((listener)=>listener());
};
const $78251dd6557baa84$export$e22c9249ea1d8d39 = (cloudId, product, datasourceId)=>$78251dd6557baa84$var$connected.has($78251dd6557baa84$var$makeKey(cloudId, product, datasourceId));
const $78251dd6557baa84$export$d6e8588579be44ec = (cloudId)=>{
    if ($78251dd6557baa84$var$connected.size === 0) return false;
    const prefix = `${cloudId}\u0000`;
    for (const key of $78251dd6557baa84$var$connected){
        if (key.startsWith(prefix)) return true;
    }
    return false;
};
const $78251dd6557baa84$export$9d21dc5f8e25d00f = ()=>{
    $78251dd6557baa84$var$connected.clear();
    $78251dd6557baa84$var$listeners.clear();
    $78251dd6557baa84$var$version = 0;
};


const $1d42590b353a470b$var$EMPTY_RESPONSE = [];
/**
 * VitalStats task names emitted by this hook. Owned by `useRovoConfig`
 * (not caller-supplied) — see RAOC-22 open question Q1.
 *
 * TODO RAOC-22 migrate analytics off search-specific naming
 */ const $1d42590b353a470b$var$TASK_NAME_UX = 'search-page/combined-config-ux';
const $1d42590b353a470b$var$TASK_NAME_NETWORK = 'search-page/combined-config-network';
// TODO RAOC-22 migrate analytics off search-specific naming
const $1d42590b353a470b$var$source = 'advancedSearchScreen';
const $1d42590b353a470b$export$9d26acf0ac0b34e7 = ({ cloudId: cloudIdProp, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, preloadDataProvider: preloadDataProvider, shouldBypassPreloadProvider: shouldBypassPreloadProvider, onForgeConnectorTypeMapping: onForgeConnectorTypeMapping })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || $1d42590b353a470b$var$source,
            attributes: {
                ...payload.attributes?.commonAttributes,
                ...payload.attributes?.additionalAttributes
            }
        }).fire('fabric-elements');
    }, [
        createAnalyticsEvent
    ]);
    const taskNameUx = $1d42590b353a470b$var$TASK_NAME_UX;
    const taskNameNetwork = $1d42590b353a470b$var$TASK_NAME_NETWORK;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $cozmU.useState)({});
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $cozmU.useState)();
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    // Keep a live ref to the latest thirdPartyConfigs so the stable
    // `onOAuthSuccess` callback (created once with no React-state deps)
    // can read the current value without going stale across renders.
    const thirdPartyConfigsRef = (0, $cozmU.useRef)(accessibleProductsConfig.thirdPartyConfigs);
    thirdPartyConfigsRef.current = accessibleProductsConfig.thirdPartyConfigs;
    const onOAuthSuccess = (0, $cozmU.useCallback)(({ product: product, datasourceId: datasourceId })=>{
        const currentConfigs = thirdPartyConfigsRef.current;
        const productConfig = currentConfigs?.[product];
        if (!productConfig) return;
        if (datasourceId !== undefined && !productConfig.datasources?.some((ds)=>ds.datasourceId === datasourceId)) return;
        let nextConfigs = currentConfigs;
        if (datasourceId === undefined) {
            if (productConfig.userNeedsOAuth !== false) nextConfigs = {
                ...currentConfigs,
                [product]: {
                    ...productConfig,
                    userNeedsOAuth: false
                }
            };
        } else {
            const datasources = productConfig.datasources ?? [];
            const targetIdx = datasources.findIndex((ds)=>ds.datasourceId === datasourceId);
            if (targetIdx >= 0 && datasources[targetIdx].userNeedsOAuth !== false) {
                const nextDatasources = datasources.map((ds, i)=>i === targetIdx ? {
                        ...ds,
                        userNeedsOAuth: false
                    } : ds);
                nextConfigs = {
                    ...currentConfigs,
                    [product]: {
                        ...productConfig,
                        datasources: nextDatasources
                    }
                };
            }
        }
        thirdPartyConfigsRef.current = nextConfigs;
        setAccessibleProductsConfig((prev)=>({
                ...prev,
                thirdPartyConfigs: nextConfigs
            }));
        // Record the connection in the shared, in-tab OAuth-override store so
        // that EVERY other `useRovoConfig` instance for this cloudId (not just
        // this one) reactively re-renders and overlays `userNeedsOAuth: false`.
        // This is what gives `useRovoConfig` its singleton-like OAuth behaviour
        // across independent component subtrees. Keyed on the same cloudId used
        // for the persisted cache below.
        if (cloudIdProp) (0, $78251dd6557baa84$export$deca34c5919575a8)(cloudIdProp, product, datasourceId);
        if (cloudIdProp) {
            const thirdPartyTypes = (0, $dc4d5222d6ee07ae$export$6750011b01164bda)();
            (0, $kQgL7.updateBaseCombinedConfigCacheEntry)(cloudIdProp, (config)=>({
                    ...config,
                    thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                        if (datasourceId) {
                            if (entry.datasourceId === datasourceId) return {
                                ...entry,
                                isUserOAuthed: true
                            };
                        } else if (thirdPartyTypes[entry.name] === product) return {
                            ...entry,
                            isUserOAuthed: true
                        };
                        return entry;
                    })
                }));
        }
    }, [
        cloudIdProp
    ]);
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $9XgN6.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        // `isCancelled` guards against a stale `searchLinkedSitesQuery` promise
        // resolving after the effect has been re-run (e.g. when `cloudIdProp` or
        // `firstCloudId` changes). Without this, a slower in-flight request could
        // overwrite a newer, correct linkedCloudARIs value. Set in the cleanup
        // function returned below and checked before every state update inside
        // `.then()` / `.catch()`.
        let isCancelled = false;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        })// The shape returned by `searchLinkedSitesQuery` is not exported by
        // `@atlassian/search-client/search-page`, so we narrow it locally:
        // it's a GraphQL response keyed by the operation name with an
        // `edges`/`node`/`id` chain. Use `unknown` + a structural cast at the
        // access site instead of `any` so subsequent property access stays
        // type-checked. Long-term fix is to export a type from search-client
        // — tracked alongside the other search-client type-promotion follow-ups
        // in the RAOC-22 work doc.
        .then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            if (isCancelled) return;
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            if (isCancelled) return;
            (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(error);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        aggAbsoluteUrl
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = {
                    taskId: uxTaskId,
                    task: taskNameUx
                };
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $dd25054093a45ece$export$e98932ab9e22c265)({
                        dependency: 'search-combined-config',
                        reason: reason,
                        source: $1d42590b353a470b$var$source
                    }));
                };
                // NOTE: `CacheAnalyticsCallback` is strictly typed as
                // `(state) => Promise<void>` in `@atlassian/search-client/persist-refresh`,
                // so the `async` keyword is structurally required even though the body
                // is synchronous. (Earlier review feedback suggested dropping `async`
                // — that turns out to be incorrect against the current type.) The
                // long-term fix is to widen `CacheAnalyticsCallback` to also accept
                // `void`, tracked as a search-client-tightening follow-up alongside
                // the other type-promotion items in the RAOC-22 work doc.
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $6d93faa27bc9189b$export$786813d6840571a0)({
                        requestName: 'search-combined-config',
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: $1d42590b353a470b$var$source
                    }));
                };
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $58ebc13b05b74641$export$b551db3ea2671aa7)(configNetworkTaskId, taskNameNetwork, // `createVitalStatsNetworkCallbacks` types its sink as
                // `(event: unknown) => void` to match the factory return
                // shape; our caller sink is typed `(event: FireAnalyticsEvent) => void`.
                // Adapt at the call site — narrow cast is safe because the
                // values come from `onTaskStart` / `onTaskSuccess` / `onTaskFail`
                // in `../network/network-task-tracker`, owned by this package.
                (event)=>fireAnalyticsEvent(event), taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                fireAnalyticsEvent((0, $58ebc13b05b74641$export$656fa717a09eb821)(baseUXVitalStatsParams));
                (0, $kQgL7.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    // RAOC: fill the AAID-scoped SSR cache key so the next
                    // server-side render can hydrate `window.__PRELOADED_SEARCH__`.
                    // The hook no longer receives a `userId` prop, so the account
                    // id is resolved asynchronously via `/gateway/api/me` (owned by
                    // this package) and passed to `fillSsrCombinedConfigCache`.
                    if (cloudIdProp) (0, $dfcac43b6a59aecf$export$35d4e28a86099a2d)().then((accountId)=>(0, $kQgL7.fillSsrCombinedConfigCache)({
                            accountId: accountId,
                            cloudId: cloudIdProp,
                            config: configuration,
                            expiration: combinedConfigTTL
                        })).catch((fillError)=>{
                        (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(fillError);
                    });
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $e088b8fa7aa2d140$export$160fbca21b53d78a)(configuration, cloudIdProp);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse((0, $dc4d5222d6ee07ae$export$4cb8ef4a677c563c)(thirdPartyConfig, onForgeConnectorTypeMapping));
                    fireAnalyticsEvent((0, $58ebc13b05b74641$export$3e9761d670712e50)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(error);
                    fireAnalyticsEvent((0, $da74afbce11dfb8c$export$7199f2d13e6ae9f7)({
                        dependency: 'search-combined-config',
                        source: $1d42590b353a470b$var$source
                    }));
                    fireAnalyticsEvent((0, $58ebc13b05b74641$export$2e311f5a2c70a936)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $1d42590b353a470b$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // Read the preload provider at most once per effect run. A stateful
            // provider (e.g. one that clears the entry on first access) would
            // otherwise return null on the second read. Per plan decision #5,
            // `shouldBypassPreloadProvider` receives the cached value below.
            let cachedPreloadedSearch = null;
            let hasReadPreload = false;
            const readPreloadedSearch = ()=>{
                if (!hasReadPreload) {
                    hasReadPreload = true;
                    try {
                        cachedPreloadedSearch = preloadDataProvider?.getPreloadedSearch({
                            cloudId: cloudIdProp
                        }) ?? null;
                    } catch  {
                        // Reading the preload provider must never throw — be defensive.
                        cachedPreloadedSearch = null;
                    }
                }
                return cachedPreloadedSearch;
            };
            // Optional bypass — see plan decision #5
            let shouldBypass = false;
            if (shouldBypassPreloadProvider) shouldBypass = shouldBypassPreloadProvider(readPreloadedSearch());
            if (preloadDataProvider && !shouldBypass) {
                try {
                    const preloadedSearch = readPreloadedSearch();
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = {
                            taskId: preloadUxTaskId,
                            task: taskNameUx,
                            moreContext: preloadMoreContext
                        };
                        fireAnalyticsEvent((0, $58ebc13b05b74641$export$656fa717a09eb821)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $e088b8fa7aa2d140$export$160fbca21b53d78a)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $dc4d5222d6ee07ae$export$4cb8ef4a677c563c)(thirdPartyConfig, onForgeConnectorTypeMapping));
                            const preloadedConfig = preloadedSearch.config;
                            if (preloadedConfig && cloudIdProp) {
                                (0, $kQgL7.seedBaseCombinedConfigCacheEntry)({
                                    cloudId: cloudIdProp,
                                    config: preloadedConfig,
                                    expiration: combinedConfigTTL
                                }).catch((seedError)=>{
                                    (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(seedError);
                                });
                                (0, $dfcac43b6a59aecf$export$35d4e28a86099a2d)().then((accountId)=>(0, $kQgL7.fillSsrCombinedConfigCache)({
                                        accountId: accountId,
                                        cloudId: cloudIdProp,
                                        config: preloadedConfig,
                                        expiration: combinedConfigTTL
                                    })).catch((fillError)=>{
                                    (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(fillError);
                                });
                            }
                            fireAnalyticsEvent((0, $58ebc13b05b74641$export$3e9761d670712e50)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            return;
                        } catch (error) {
                            (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(error);
                            fireAnalyticsEvent((0, $58ebc13b05b74641$export$2e311f5a2c70a936)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return;
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $da74afbce11dfb8c$export$7199f2d13e6ae9f7)({
                        dependency: 'search-config-ssr',
                        source: $1d42590b353a470b$var$source,
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    (0, $fbae18216f314d2d$export$f86b2a1a2ce291b3)(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        aggAbsoluteUrl,
        fireAnalyticsEvent,
        preloadDataProvider,
        shouldBypassPreloadProvider,
        taskNameUx,
        taskNameNetwork,
        onForgeConnectorTypeMapping
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (combinedThirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            const allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match((0, $9XgN6.EXTRACT_PRODUCT_FROM_ARI));
                    if (match && match.length >= 2 && match[1]) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            allAccessibleProducts.push(...firstPartyProducts);
            const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match((0, $9XgN6.EXTRACT_PRODUCT_FROM_ARI));
                if (match && match.length >= 2 && (match[1] === 'project' || match[1] === 'goal')) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also add Townsquare to the list of accessible products.
            // NOTE (RAOC-22 review): The threshold here (`> 0`) intentionally
            // differs from `parseCombinedConfig.getAccessibleProducts` in
            // `services/combined-config/parse.ts`, which uses `> 1`. This drift is
            // inherited verbatim from search-page (`controllers/config/index.tsx`
            // uses `> 0`, `controllers/config/utils/parse-combined-config.ts` uses
            // `> 1`). RAOC-22 deliberately keeps both as-is so the equivalence test
            // stays honest; reconciling the two thresholds is a search-page
            // behaviour bug-fix that should land in its own PR.
            if (accessibleNouns.length > 0) allAccessibleProducts.push('townsquare');
            const doesUserHaveRovo = (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = combinedThirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: combinedThirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `setAccessibleProductsConfig`
    // is a useState setter with a stable identity guaranteed by React; including it in the
    // dep array would be misleading. The fields that genuinely drive this effect are the
    // three values below.
    }, [
        combinedThirdPartyResponse,
        firstPartyResponse,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const isRovoEnabled = (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
    const isJiraIssueIndexed = (0, $9XgN6.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
    const productEdition = (0, $9XgN6.getProductEdition)(firstPartyResponse, cloudIdProp);
    const productDataRegions = (0, $9XgN6.getProductDataRegions)(firstPartyResponse, cloudIdProp);
    const rovoFeatures = (0, $9XgN6.getRovoFeatures)(firstPartyResponse, cloudIdProp);
    // Subscribe this instance to the shared in-tab OAuth-override store. Any
    // `onOAuthSuccess` (from THIS or ANY OTHER `useRovoConfig` instance) bumps
    // the version, re-rendering every subscriber so the overlay below recomputes.
    const oauthOverridesVersion = (0, $cozmU.useSyncExternalStore)((0, $78251dd6557baa84$export$dbe98d1c08f0f87d), (0, $78251dd6557baa84$export$6a79912ef915aaf2), // Server snapshot: no overrides exist during SSR — return a constant 0
    // so the server-side contract is immune to any module-level state that
    // might be non-zero in a long-lived SSR process.
    ()=>0);
    // Overlay the shared OAuth overrides onto the derived configs so a connection
    // performed by any instance is reflected here as `userNeedsOAuth: false`.
    const thirdPartyConfigsWithOverrides = (0, $cozmU.useMemo)(()=>{
        const base = accessibleProductsConfig.thirdPartyConfigs;
        // SSR guard: hasAnyOAuthOverrideForCloud reads from module state, which is not guaranteed to be zero in a long-lived SSR process. If it is non-zero, the server-side contract is violated and the server-rendered markup will mismatch the client render. Return the base configs unmodified during SSR so the server-side contract is preserved.
        if (typeof window === 'undefined') return base;
        if (!cloudIdProp || !(0, $78251dd6557baa84$export$d6e8588579be44ec)(cloudIdProp)) return base;
        return (0, $c65a9fcd52aa8158$export$d10296f0916f2406)(base, (product, datasourceId)=>(0, $78251dd6557baa84$export$e22c9249ea1d8d39)(cloudIdProp, product, datasourceId));
    // `oauthOverridesVersion` is the reactive trigger: it changes whenever the
    // shared store mutates, which is precisely when the overlay must recompute.
    // It acts here as a cache-busting key for the memoization
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accessibleProductsConfig.thirdPartyConfigs,
        cloudIdProp,
        oauthOverridesVersion
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return {
            accessibleProducts: accessibleProducts,
            accessibleNouns: accessibleProductsConfig.nouns,
            thirdPartyConfigs: thirdPartyConfigsWithOverrides,
            firstCloudId: firstCloudId,
            intercomHmac: firstPartyResponse?.intercomHmac,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs,
            combinedConfigResponse: // TODO RAOC-22 clean up when removing FG('rovo_fps_use_rovo_config') and the search-page `useFetchConfig` fallback logic that relies on this field being present in the return type as this will no longer be used
            combinedConfigResponse,
            onOAuthSuccess: onOAuthSuccess
        };
    }, [
        accessibleProducts,
        accessibleProductsConfig.nouns,
        thirdPartyConfigsWithOverrides,
        firstCloudId,
        firstPartyResponse?.intercomHmac,
        isRovoEnabled,
        isJiraIssueIndexed,
        productEdition,
        productDataRegions,
        rovoFeatures,
        isConfigLoaded,
        linkedCloudARIs,
        combinedConfigResponse,
        onOAuthSuccess
    ]);
};
module.exports["useRovoConfig"] = $1d42590b353a470b$export$9d26acf0ac0b34e7;

});

parcelRegister("kQgL7", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $5oT59 = parcelRequire("5oT59");


var $9C63M = parcelRequire("9C63M");




const $b4b673b384c075fe$export$4f967acd0a387888 = (userId, cloudId)=>(0, $bZF61.generateHash)(`${userId}${cloudId}`);



var $6s56R = parcelRequire("6s56R");


const $ee61ee208b79c577$export$c5dfc39e7764783c = 'searchCombinedConfig';
const $ee61ee208b79c577$export$1693aa41d49ec148 = ()=>`
query ${$ee61ee208b79c577$export$c5dfc39e7764783c}($cloudId: ID!) {
  search {
      configuration(cloudId: $cloudId) {
        firstPartyProducts {
          name
        }
        thirdPartyProducts {
          name
          outboundAuthUrl
          isUserOAuthed
          providerId
          integrationARI
          workspaceName
          workspaceUrl
          datasourceId
          connectionId
          connectorSyncType
          isImpersonationAuthEnabled
          connectorCreatedAt
          ${(0, $6s56R.isUsingRovoConfigStoreExperiment)() ? 'connectedAt' : ''}
          lightIcon
          entityTypes
          environmentType
        }
        intercomHmac
        siteMetadata {
          isRovoEnabled
          isJiraIssueIndexed
          applicationMode
          siteName
          orgId
          productEdition
          productInfo {
            name
            dataRegion
          }
        }
    }
  }
}`;


const $07e5cce08214ddb3$export$4d8c59e1d2af415b = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
const $07e5cce08214ddb3$export$520f811efd7d75bb = (0, $5oT59.SEARCH_COMBINED_CONFIG_BARE_CACHE_KEY);
// Adapter-backed cache (host StorageManager → account-namespaced key
// `atlassian.<accountId>.frontend.search-combined-config`, mirrored into
// getRemoteLocalStorage for SSR).
//
// Used by the UNTOUCHED legacy FG-off path (`updateCombinedConfigCacheEntry`,
// `getCombinedSearchConfig` legacy branch) and by the SSR-fill
// (`seedCombinedConfigCacheEntry` via `fillSsrCombinedConfigCache`), which both
// rely on the AAID-scoped key.
const { refreshOnAccessDecorator: $07e5cce08214ddb3$var$refreshOnAccessDecoratorCombined, update: $07e5cce08214ddb3$var$updateCombinedCache, seed: $07e5cce08214ddb3$var$seedCombinedCache } = (0, $fyjce.promiseCache)({
    name: $07e5cce08214ddb3$export$4d8c59e1d2af415b,
    shouldUseStorageAdapter: true
});
// Bare-key runtime cache (client-only, NOT account-namespaced, NOT SSR-visible).
// Writes the literal `frontend.search-combined-config` localStorage key (distinct
// from the account-namespaced adapter key above).
//
// Used ONLY by the FG-on (`rovo_fps_use_rovo_config`) `useRovoConfig` runtime
// writers — `getCombinedSearchConfig` (FG-on branch), `seedBase…`, `updateBase…`.
const { refreshOnAccessDecorator: $07e5cce08214ddb3$var$refreshOnAccessDecoratorBaseRuntime, update: $07e5cce08214ddb3$var$updateBaseRuntimeCache, seed: $07e5cce08214ddb3$var$seedBaseRuntimeCache } = (0, $fyjce.promiseCache)({
    name: $07e5cce08214ddb3$export$520f811efd7d75bb,
    shouldUseStorageAdapter: false
});
const $07e5cce08214ddb3$export$c066f72d16c9afa5 = (userId, cloudId, updater)=>{
    const key = (0, $b4b673b384c075fe$export$4f967acd0a387888)(userId, cloudId);
    return $07e5cce08214ddb3$var$updateCombinedCache(key.toString(), updater);
};
const $07e5cce08214ddb3$export$34fe4a744c051b23 = ({ userId: userId, cloudId: cloudId, config: config, expiration: expiration })=>{
    const key = (0, $b4b673b384c075fe$export$4f967acd0a387888)(userId || '', cloudId);
    return $07e5cce08214ddb3$var$seedCombinedCache(key.toString(), config, expiration);
};
/**
 * The inner cache key for the **base** combined-config runtime entry used by
 * `useRovoConfig`. Keyed on a hash of the `cloudId` only — no `userId` — so the
 * entry is per-site but not per-account (the localStorage key prefix already
 * scopes per-account).
 */ const $07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey = (cloudId)=>(0, $bZF61.generateHash)(cloudId).toString();
/**
 * Resolve the runtime combined-config cache key, gated by the
 * `rovo_fps_use_rovo_config` feature gate.
 *
 * - **FG ON** (the canonical `useRovoConfig` path): a hash of the `cloudId`
 *   only — no `userId` in the inner key.
 * - **FG OFF** (the legacy `useFetchConfigLegacy` path): the historical
 *   `getCombinedConfigHash(userId, cloudId)` inner key, preserving the
 *   pre-RAOC cache behaviour byte-for-byte.
 */ const $07e5cce08214ddb3$var$resolveRuntimeCombinedConfigCacheKey = (userId, cloudId)=>(0, $ixfCV.fg)('rovo_fps_use_rovo_config') ? $07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId || '') : (0, $b4b673b384c075fe$export$4f967acd0a387888)(userId || '', cloudId || '').toString();
const $07e5cce08214ddb3$export$707f15bd9a09224d = (cloudId, updater)=>$07e5cce08214ddb3$var$updateBaseRuntimeCache($07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId), updater);
const $07e5cce08214ddb3$export$5f90db2f52f87370 = ({ cloudId: cloudId, config: config, expiration: expiration })=>$07e5cce08214ddb3$var$seedBaseRuntimeCache($07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId), config, expiration);
const $07e5cce08214ddb3$export$d6a374b1da3ff3ff = async ({ accountId: accountId, cloudId: cloudId, config: config, expiration: expiration })=>{
    if (!accountId) return false;
    await $07e5cce08214ddb3$export$34fe4a744c051b23({
        userId: accountId,
        cloudId: cloudId,
        config: config,
        expiration: expiration
    });
    return true;
};
const $07e5cce08214ddb3$export$8993626c2cc6d711 = async ({ cloudId: cloudId, userId: userId, aggAbsoluteUrl: aggAbsoluteUrl, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired, networkCallbacks: networkCallbacks, headers: headers })=>{
    // FG-on (`useRovoConfig`): bare-key runtime cache (client-only, no AAID).
    // FG-off (legacy): the original adapter-backed cache — untouched.
    const refreshOnAccess = (0, $ixfCV.fg)('rovo_fps_use_rovo_config') ? $07e5cce08214ddb3$var$refreshOnAccessDecoratorBaseRuntime : $07e5cce08214ddb3$var$refreshOnAccessDecoratorCombined;
    return refreshOnAccess({
        key: $07e5cce08214ddb3$var$resolveRuntimeCombinedConfigCacheKey(userId, cloudId),
        supplier: ()=>{
            const combinedConfigPromise = (0, $b0Mpu.fetchAgg)({
                graphQuery: (0, $ee61ee208b79c577$export$1693aa41d49ec148)(),
                variables: {
                    cloudId: cloudId
                },
                operationName: (0, $ee61ee208b79c577$export$c5dfc39e7764783c),
                aggAbsoluteUrl: aggAbsoluteUrl,
                headers: headers
            }).then((response)=>{
                const hasErrors = response.errors?.some((error)=>error);
                if (hasErrors) {
                    const errorsAsString = response.errors?.map((error)=>error.message).join(', ');
                    throw new Error(`Search combined config response had errors: ${errorsAsString}`);
                }
                const configuration = response.data?.search?.configuration;
                if (!configuration) throw new Error('Search combined config response missing configuration.');
                return configuration;
            });
            const degrader = new (0, $9C63M.DegradablePromise)(combinedConfigPromise, degradationCallback);
            return degrader.promise();
        },
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true
    });
};
module.exports["SEARCH_COMBINED_CONFIG"] = $07e5cce08214ddb3$export$4d8c59e1d2af415b;
module.exports["updateCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$c066f72d16c9afa5;
module.exports["seedCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$34fe4a744c051b23;
module.exports["updateBaseCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$707f15bd9a09224d;
module.exports["seedBaseCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$5f90db2f52f87370;
module.exports["fillSsrCombinedConfigCache"] = $07e5cce08214ddb3$export$d6a374b1da3ff3ff;
module.exports["getCombinedSearchConfig"] = $07e5cce08214ddb3$export$8993626c2cc6d711;

});

parcelRegister("9XgN6", function(module, exports) {
/**
 * Internal regex used to extract a cloudId from a Resource ARI of the form:
 *   ari:cloud:<product>::<resourceType>/<cloudId>
 * Capture group 1 yields the cloudId.
 *
 * Public via `getFirstCloudId(...)` and is not exported directly.
 */ const $ee0362899d9e596b$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $ee0362899d9e596b$export$cd4718f771339207 = /ari:cloud:(.*)::/;
const $ee0362899d9e596b$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($ee0362899d9e596b$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $ee0362899d9e596b$export$e9de73272abc8489 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $ee0362899d9e596b$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $ee0362899d9e596b$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $ee0362899d9e596b$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $ee0362899d9e596b$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["EXTRACT_PRODUCT_FROM_ARI"] = $ee0362899d9e596b$export$cd4718f771339207;
module.exports["getFirstCloudId"] = $ee0362899d9e596b$export$c1871fdf674a03c4;
module.exports["isRovoEnabledForSite"] = $ee0362899d9e596b$export$e9de73272abc8489;
module.exports["getJiraIssueIndexedForTenant"] = $ee0362899d9e596b$export$37c9c6a3ae5f363c;
module.exports["getProductEdition"] = $ee0362899d9e596b$export$53e066a63a960439;
module.exports["getProductDataRegions"] = $ee0362899d9e596b$export$c635d3296555e2da;
module.exports["getRovoFeatures"] = $ee0362899d9e596b$export$2a1c0662041ee0a3;

});

parcelRegister("3X0xX", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $93a257f313f96bb6$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $93a257f313f96bb6$export$ea77880e3935182d = 'unknown';
const $93a257f313f96bb6$export$d60e93659f587f71 = {
    search: true // Used to filter out errors that are not from search projects
};
module.exports["SENTRY_DSN"] = $93a257f313f96bb6$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $93a257f313f96bb6$export$ea77880e3935182d;
module.exports["COMMON_TAGS"] = $93a257f313f96bb6$export$d60e93659f587f71;

});

parcelRegister("cFPRS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ // @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $60ba9b041b400cde$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;



var $22XrW = parcelRequire("22XrW");


var $3X0xX = parcelRequire("3X0xX");

let $0370a31091c42c7d$var$Sentry;
const $0370a31091c42c7d$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from search projects
    if (!event.tags?.search) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $0370a31091c42c7d$export$f553e8b08ef59d31 = async ()=>{
    if (!$0370a31091c42c7d$var$Sentry) {
        if ((0, $22XrW.getEnvironment)() === 'development') return;
        $0370a31091c42c7d$var$Sentry = Promise.resolve((parcelRequire("eieXD"))).then((SentryModule)=>{
            SentryModule.init({
                dsn: (0, $3X0xX.SENTRY_DSN),
                attachStacktrace: true,
                release: (0, $60ba9b041b400cde$export$668f31ea3127f48f) || (0, $3X0xX.UNKNOWN_TAG),
                environment: (0, $22XrW.getEnvironment)(),
                beforeSend: $0370a31091c42c7d$var$beforeSend
            });
            return SentryModule;
        }).catch(()=>{
        // TODO: Retry mechanism for chunk loading failures?
        });
    }
    return $0370a31091c42c7d$var$Sentry;
};
module.exports["getSentryClient"] = $0370a31091c42c7d$export$f553e8b08ef59d31;

});

parcelRegister("22XrW", function(module, exports) {
const $f363035d3386b96d$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $f363035d3386b96d$export$57570b1603cf6adb;

});

parcelRegister("ekfm7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $irnO2 = parcelRequire("irnO2");


var $lJ6db = parcelRequire("lJ6db");


var $7pCWA = parcelRequire("7pCWA");

const $a58bea70580ad845$export$fdb92ee0ff9f2fc7 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    const [{ hasFetchAttempted: hasFetchAttempted, isFetching: isFetching }] = (0, $7pCWA.useKnowledgeSourcesStore)();
    const { fetchIfEmpty: fetchIfEmpty } = (0, $7pCWA.useKnowledgeSourcesActions)();
    const fetcher = (0, $cozmU.useCallback)(async ()=>{
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE,
            name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE
        });
        try {
            const response = await assistanceService.getAgentKnowledgeConfiguration();
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE
            });
            return response;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    }, [
        assistanceService,
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!hasFetchAttempted && !isFetching && (0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false)) fetchIfEmpty(fetcher, siteId);
    }, [
        hasFetchAttempted,
        isFetching,
        fetchIfEmpty,
        fetcher,
        siteId
    ]);
});
module.exports["useEnsureConnectorsLoaded"] = $a58bea70580ad845$export$fdb92ee0ff9f2fc7;

});

parcelRegister("gitiq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5Sv3D = parcelRequire("5Sv3D");


var $hAgam = parcelRequire("hAgam");


var $iMnC5 = parcelRequire("iMnC5");


var $4yg9g = parcelRequire("4yg9g");


var $9GVkD = parcelRequire("9GVkD");




const $01a13526c584fb52$var$message = (0, $kSwu1.defineMessages)({
    screenReaderPrompt: {
        id: "rovo-chat.search-input.screen-reader-prompt",
        defaultMessage: "Typing any character in this field will update the search results below"
    }
});
var $01a13526c584fb52$export$2e2bcd8739ae039 = $01a13526c584fb52$var$message;


const $6e696a0b93401143$var$styles = {
    searchIconWrapper: "_1q51v77o _bozgu2gc",
    overlayWrapper: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _bfhk1bhr _jyzf1v1w"
};
const $6e696a0b93401143$export$55d7609a8f1eccd2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, inputRef)=>{
    const $ = (0, $bDgLe.c)(24);
    const { placeholderText: placeholderText, onSearch: onSearch, isDisabled: isDisabled, autoFocus: autoFocus, isCompact: isCompact, debounceTime: t1, variant: t2 } = t0;
    const debounceTime = t1 === undefined ? 500 : t1;
    const variant = t2 === undefined ? "default" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== isDisabled || $[1] !== onSearch) {
        t3 = (searchText)=>{
            if (!isDisabled) onSearch(searchText);
        };
        $[0] = isDisabled;
        $[1] = onSearch;
        $[2] = t3;
    } else t3 = $[2];
    const [debouncedChange] = (0, $5Sv3D.default)(t3, debounceTime);
    let t4;
    if ($[3] !== debouncedChange) {
        t4 = (e)=>debouncedChange(e.currentTarget.value);
        $[3] = debouncedChange;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = variant === "overlay" ? "none" : "standard";
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $6e696a0b93401143$var$styles.searchIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }));
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== autoFocus || $[7] !== inputRef || $[8] !== isCompact || $[9] !== isDisabled || $[10] !== placeholderText || $[11] !== t4 || $[12] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            isCompact: isCompact,
            "aria-label": placeholderText,
            type: "search",
            ref: inputRef,
            placeholder: placeholderText,
            onChange: t4,
            isDisabled: isDisabled,
            autoFocus: autoFocus,
            appearance: t5,
            elemBeforeInput: t6,
            "aria-describedby": "search-description"
        });
        $[6] = autoFocus;
        $[7] = inputRef;
        $[8] = isCompact;
        $[9] = isDisabled;
        $[10] = placeholderText;
        $[11] = t4;
        $[12] = t5;
        $[13] = t7;
    } else t7 = $[13];
    const textField = t7;
    let t8;
    if ($[14] !== textField || $[15] !== variant) {
        t8 = variant === "overlay" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $6e696a0b93401143$var$styles.overlayWrapper
        }, textField) : textField;
        $[14] = textField;
        $[15] = variant;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== formatMessage) {
        t9 = formatMessage((0, $01a13526c584fb52$export$2e2bcd8739ae039).screenReaderPrompt);
        $[17] = formatMessage;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "search-description"
        }, t9));
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t10);
        $[21] = t10;
        $[22] = t8;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : ({ placeholderText: placeholderText, onSearch: onSearch, isDisabled: isDisabled, autoFocus: autoFocus, isCompact: isCompact, debounceTime: debounceTime = 500, variant: variant = 'default' }, inputRef)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [debouncedChange] = (0, $5Sv3D.default)((searchText)=>{
        if (!isDisabled) onSearch(searchText);
    }, debounceTime);
    const textField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        isCompact: isCompact,
        "aria-label": placeholderText,
        type: "search",
        ref: inputRef,
        placeholder: placeholderText,
        onChange: (e)=>debouncedChange(e.currentTarget.value),
        isDisabled: isDisabled,
        autoFocus: autoFocus,
        appearance: variant === 'overlay' ? 'none' : 'standard',
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $6e696a0b93401143$var$styles.searchIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            label: ""
        })),
        "aria-describedby": "search-description"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, variant === 'overlay' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $6e696a0b93401143$var$styles.overlayWrapper
    }, textField) : textField, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "search-description"
    }, formatMessage((0, $01a13526c584fb52$export$2e2bcd8739ae039).screenReaderPrompt))));
});
module.exports["SearchInput"] = $6e696a0b93401143$export$55d7609a8f1eccd2;

});

parcelRegister("its7R", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bltJZ = parcelRequire("bltJZ");


var $91ZZN = parcelRequire("91ZZN");


var $ak8CL = parcelRequire("ak8CL");


const $29e2588a6989af85$var$Lazy3PLogoWrapper = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("f401D")).then((module)=>({
            default: module.Lazy3PLogoWrapper
        })));
const $29e2588a6989af85$var$ProductKeysToLogoMap = new Map([
    [
        'jira',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.JiraIcon))
    ],
    [
        'confluence',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.ConfluenceIcon))
    ],
    [
        'bamboo',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.BambooIcon))
    ],
    [
        'focus',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.FocusIcon))
    ],
    [
        'compass',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.CompassIcon))
    ],
    [
        'jsm',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.JiraServiceManagementIcon))
    ],
    [
        'admin',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.AdminIcon))
    ],
    [
        'align',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.AlignIcon))
    ],
    [
        'bitbucket',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.BitbucketIcon))
    ],
    [
        'jira_dc',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.JiraDataCenterIcon))
    ],
    [
        'confluence_dc',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.ConfluenceDataCenterIcon))
    ],
    [
        'trello',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.TrelloIcon))
    ],
    [
        'atlas',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.HomeIcon))
    ],
    [
        'help_aggregator',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.CustomerServiceManagementIcon))
    ]
]);
const $29e2588a6989af85$export$88e12026a61a33a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoLogoForAppSource(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { appSource: appSource, rovoLogoProps: rovoLogoProps, fallback: fallback } = t0;
    let t1;
    if ($[0] !== appSource) {
        t1 = $29e2588a6989af85$var$ProductKeysToLogoMap.get(appSource);
        $[0] = appSource;
        $[1] = t1;
    } else t1 = $[1];
    const productLogo = t1;
    if (productLogo) {
        const Logo = productLogo;
        let t2;
        if ($[2] !== Logo || $[3] !== rovoLogoProps) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, rovoLogoProps);
            $[2] = Logo;
            $[3] = rovoLogoProps;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t2;
    if ($[5] !== appSource || $[6] !== fallback || $[7] !== rovoLogoProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29e2588a6989af85$var$Lazy3PLogoWrapper, {
            appSource: appSource,
            rovoLogoProps: rovoLogoProps,
            fallback: fallback
        });
        $[5] = appSource;
        $[6] = fallback;
        $[7] = rovoLogoProps;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== fallback || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-rovo-logo-for-app-source",
            fallback: fallback
        }, t2);
        $[9] = fallback;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : function RovoLogoForAppSource({ appSource: appSource, rovoLogoProps: rovoLogoProps, fallback: fallback }) {
    const productLogo = $29e2588a6989af85$var$ProductKeysToLogoMap.get(appSource);
    if (productLogo) {
        const Logo = productLogo;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, rovoLogoProps);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-rovo-logo-for-app-source",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29e2588a6989af85$var$Lazy3PLogoWrapper, {
        appSource: appSource,
        rovoLogoProps: rovoLogoProps,
        fallback: fallback
    }));
};
module.exports["RovoLogoForAppSource"] = $29e2588a6989af85$export$88e12026a61a33a9;

});

parcelRegister("ak8CL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bb66c4985ea9ad7a$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
};
module.exports["RovoLogoFromLogo"] = $bb66c4985ea9ad7a$export$32db889b380fa03c;

});

parcelRegister("f401D", function(module, exports) {

let $af773fc165d278d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af773fc165d278d8$var$load("d1mSF").then(()=>parcelRequire('duTH0'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("8hYSP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $71003fe44ebb6f95$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $71003fe44ebb6f95$export$e42943029b7e264a = [
    $71003fe44ebb6f95$var$ProductKeys1P.Confluence,
    $71003fe44ebb6f95$var$ProductKeys1P.Jira,
    $71003fe44ebb6f95$var$ProductKeys1P.JiraProductDiscovery,
    $71003fe44ebb6f95$var$ProductKeys1P.JiraServiceManagement,
    $71003fe44ebb6f95$var$ProductKeys1P.Atlas,
    $71003fe44ebb6f95$var$ProductKeys1P.Trello,
    $71003fe44ebb6f95$var$ProductKeys1P.Bitbucket,
    $71003fe44ebb6f95$var$ProductKeys1P.Compass,
    $71003fe44ebb6f95$var$ProductKeys1P.Focus
];



async function $3944aef95aa38413$export$c04f0237bea14274() {
    const { ProductsOrder3P: ProductsOrder3P } = await (parcelRequire("f401D"));
    return [
        ...(0, $71003fe44ebb6f95$export$e42943029b7e264a),
        ...ProductsOrder3P
    ];
}


const $b23a9a999e50db5b$export$5529283e19f23755 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductSortOrder() {
    const $ = (0, $bDgLe.c)(1);
    const productsOrderRef = (0, $cozmU.useRef)(undefined);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = async ()=>{
            let productsOrder = productsOrderRef.current;
            if (productsOrder === undefined) {
                productsOrder = await (0, $3944aef95aa38413$export$c04f0237bea14274)();
                productsOrderRef.current = productsOrder;
            }
            return (a, b)=>{
                const indexA = productsOrder.indexOf(a);
                const indexB = productsOrder.indexOf(b);
                if (indexA === -1 || indexB === -1) return 0;
                else return indexA - indexB;
            };
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function useProductSortOrder() {
    const productsOrderRef = (0, $cozmU.useRef)(undefined);
    return (0, $cozmU.useCallback)(async ()=>{
        let productsOrder = productsOrderRef.current;
        if (productsOrder === undefined) {
            productsOrder = await (0, $3944aef95aa38413$export$c04f0237bea14274)();
            productsOrderRef.current = productsOrder;
        }
        return (a, b)=>{
            const indexA = productsOrder.indexOf(a);
            const indexB = productsOrder.indexOf(b);
            if (indexA === -1 || indexB === -1) return 0;
            else return indexA - indexB;
        };
    }, [
        productsOrderRef
    ]);
};
module.exports["useProductSortOrder"] = $b23a9a999e50db5b$export$5529283e19f23755;

});

parcelRegister("4M6Ac", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7ieQR = parcelRequire("7ieQR");

const $4c53bcf4cb37778f$export$683e74383c07ce41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction, onFailAction: onFailAction, analyticsAttributes: t1 } = t0;
    const { source: source, isNewlyEnabled: isNewlyEnabled, surface: surface } = t1;
    const createHandler = (0, $7ieQR.useOAuthHandlerFactory)();
    let t2;
    if ($[0] !== appSource || $[1] !== createHandler || $[2] !== friendlyName || $[3] !== isNewlyEnabled || $[4] !== onCompletedAction || $[5] !== onFailAction || $[6] !== outboundAuthUrl || $[7] !== source || $[8] !== surface) {
        t2 = createHandler({
            friendlyName: friendlyName,
            appSource: appSource,
            outboundAuthUrl: outboundAuthUrl,
            onCompletedAction: onCompletedAction,
            onFailAction: onFailAction,
            analyticsAttributes: {
                source: source,
                isNewlyEnabled: isNewlyEnabled,
                surface: surface
            }
        });
        $[0] = appSource;
        $[1] = createHandler;
        $[2] = friendlyName;
        $[3] = isNewlyEnabled;
        $[4] = onCompletedAction;
        $[5] = onFailAction;
        $[6] = outboundAuthUrl;
        $[7] = source;
        $[8] = surface;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction, onFailAction: onFailAction, analyticsAttributes: { source: source, isNewlyEnabled: isNewlyEnabled, surface: surface } })=>{
    const createHandler = (0, $7ieQR.useOAuthHandlerFactory)();
    return (0, $cozmU.useMemo)(()=>createHandler({
            friendlyName: friendlyName,
            appSource: appSource,
            outboundAuthUrl: outboundAuthUrl,
            onCompletedAction: onCompletedAction,
            onFailAction: onFailAction,
            analyticsAttributes: {
                source: source,
                isNewlyEnabled: isNewlyEnabled,
                surface: surface
            }
        }), [
        createHandler,
        friendlyName,
        appSource,
        outboundAuthUrl,
        onCompletedAction,
        onFailAction,
        source,
        isNewlyEnabled,
        surface
    ]);
};
module.exports["useAppOAuth"] = $4c53bcf4cb37778f$export$683e74383c07ce41;

});

parcelRegister("7ieQR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $2ot3O = parcelRequire("2ot3O");


var $eh6Ml = parcelRequire("eh6Ml");


var $24dy7 = parcelRequire("24dy7");


var $kMzDv = parcelRequire("kMzDv");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $7pCWA = parcelRequire("7pCWA");

const $e8bea614aa966e09$export$3f79151fcefb63db = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { markUserConnected: markUserConnected } = (0, $7pCWA.useKnowledgeSourcesActions)();
    let t0;
    if ($[0] !== markUserConnected || $[1] !== sendAnalyticsEvent || $[2] !== showFlag) {
        t0 = (t1)=>{
            const { friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onCompletedAction: t2, onFailAction: t3, analyticsAttributes: t4 } = t1;
            const onCompletedAction = t2 === undefined ? $e8bea614aa966e09$var$_temp : t2;
            const onFailAction = t3 === undefined ? $e8bea614aa966e09$var$_temp2 : t3;
            const { source: source, isNewlyEnabled: isNewlyEnabled, surface: surface } = t4;
            const onSuccess = ()=>{
                showFlag({
                    title: `Connected to ${friendlyName}`,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                        spacing: "spacious",
                        label: "",
                        color: "var(--ds-icon-success, #6A9A23)"
                    }),
                    isAutoDismiss: true
                });
                sendAnalyticsEvent({
                    eventType: "track",
                    action: "completed",
                    actionSubject: "thirdPartyOAuth",
                    attributes: {
                        productSelected: appSource,
                        source: source,
                        isNewlyEnabled: isNewlyEnabled,
                        surface: surface
                    }
                });
                if ((0, $cXtTj.default).getExperimentValue("rovo_chat_3p_app_discovery_m1_experiment", "isEnabled", false)) markUserConnected(appSource);
                onCompletedAction();
            };
            const onFail = ()=>{
                showFlag({
                    title: `Failed to connect to ${friendlyName}`,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        spacing: "spacious",
                        label: "",
                        color: "var(--ds-icon-danger, #C9372C)"
                    }),
                    isAutoDismiss: true
                });
                sendAnalyticsEvent({
                    eventType: "track",
                    action: "failed",
                    actionSubject: "thirdPartyOAuth",
                    attributes: {
                        productSelected: appSource,
                        source: source,
                        isNewlyEnabled: isNewlyEnabled,
                        surface: surface
                    }
                });
                onFailAction();
            };
            const onAuthorize = async ()=>{
                sendAnalyticsEvent({
                    eventType: "track",
                    action: "clicked",
                    actionSubject: "thirdPartyOAuth",
                    attributes: {
                        productSelected: appSource,
                        source: source,
                        isNewlyEnabled: isNewlyEnabled,
                        surface: surface
                    }
                });
                try {
                    await (0, $kMzDv.auth)(outboundAuthUrl);
                    onSuccess();
                } catch  {
                    onFail();
                }
            };
            return {
                onAuthorize: onAuthorize,
                onSuccess: onSuccess,
                onFail: onFail
            };
        };
        $[0] = markUserConnected;
        $[1] = sendAnalyticsEvent;
        $[2] = showFlag;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { markUserConnected: markUserConnected } = (0, $7pCWA.useKnowledgeSourcesActions)();
    return (0, $cozmU.useCallback)(({ friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction = ()=>{}, onFailAction: onFailAction = ()=>{}, analyticsAttributes: { source: source, isNewlyEnabled: isNewlyEnabled, surface: surface } })=>{
        const onSuccess = ()=>{
            showFlag({
                title: `Connected to ${friendlyName}`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-success, #6A9A23)"
                }),
                isAutoDismiss: true
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'completed',
                actionSubject: 'thirdPartyOAuth',
                attributes: {
                    productSelected: appSource,
                    source: source,
                    isNewlyEnabled: isNewlyEnabled,
                    surface: surface
                }
            });
            if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_app_discovery_m1_experiment', 'isEnabled', false)) markUserConnected(appSource);
            onCompletedAction();
        };
        const onFail = ()=>{
            showFlag({
                title: `Failed to connect to ${friendlyName}`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                isAutoDismiss: true
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'thirdPartyOAuth',
                attributes: {
                    productSelected: appSource,
                    source: source,
                    isNewlyEnabled: isNewlyEnabled,
                    surface: surface
                }
            });
            onFailAction();
        };
        const onAuthorize = async ()=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'clicked',
                actionSubject: 'thirdPartyOAuth',
                attributes: {
                    productSelected: appSource,
                    source: source,
                    isNewlyEnabled: isNewlyEnabled,
                    surface: surface
                }
            });
            try {
                await (0, $kMzDv.auth)(outboundAuthUrl);
                onSuccess();
            } catch  {
                onFail();
            }
        };
        return {
            onAuthorize: onAuthorize,
            onSuccess: onSuccess,
            onFail: onFail
        };
    }, [
        showFlag,
        sendAnalyticsEvent,
        markUserConnected
    ]);
};
function $e8bea614aa966e09$var$_temp() {}
function $e8bea614aa966e09$var$_temp2() {}
module.exports["useOAuthHandlerFactory"] = $e8bea614aa966e09$export$3f79151fcefb63db;

});

parcelRegister("j3dQ1", function(module, exports) {
/**
 * Display name used in the UI for the atlassian-web-crawler knowledge source.
 * Kept in one place so all app-filter call sites stay in sync (see search-page mapping).
 */ const $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_SOURCE = 'atlassian-web-crawler';
const $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_DISPLAY_NAME = 'Web pages';
function $26393ac590b6b6bd$export$ecbd54e9e35a1b36(source, friendlyName) {
    return source === $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_SOURCE ? $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_DISPLAY_NAME : friendlyName;
}
module.exports["getKnowledgeSourceDisplayName"] = $26393ac590b6b6bd$export$ecbd54e9e35a1b36;

});

parcelRegister("6e8qW", function(module, exports) {
/**
 * Shared TAP (Traits and Personalization) delivery client.
 *
 * Provides fetch utilities for both user-level and site-level TAP traits,
 * along with common parsers for trait values.
 */ const $105b061879975503$var$getUserTraitsUrl = (userId)=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
const $105b061879975503$var$getSiteTraitsUrl = (siteId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
const $105b061879975503$var$fetchTraits = async (url, signal)=>{
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        },
        signal: signal
    });
    if (!response.ok) throw new Error(`TAP request failed with status ${response.status}`);
    const data = await response.json();
    return data.attributes ?? [];
};
const $105b061879975503$export$2a353ada541e501f = async (userId, signal)=>{
    return $105b061879975503$var$fetchTraits($105b061879975503$var$getUserTraitsUrl(userId), signal);
};
const $105b061879975503$export$954f05a5dfd487e4 = async (siteId, signal)=>{
    return $105b061879975503$var$fetchTraits($105b061879975503$var$getSiteTraitsUrl(siteId), signal);
};
const $105b061879975503$export$860b8ce93b9dfdcc = (traits, traitName)=>{
    const trait = traits.find((t)=>t.name === traitName);
    return trait?.value;
};
const $105b061879975503$export$f357d04e31823a19 = (traits, traitName)=>{
    const trait = traits.find((t)=>t.name === traitName);
    if (!trait || typeof trait.value !== 'string') return {};
    const result = {};
    const pairs = trait.value.split(',').map((s)=>s.trim());
    for (const pair of pairs){
        const [product, valueStr] = pair.split(':').map((s)=>s.trim());
        if (product && valueStr) {
            const value = Number(valueStr);
            if (Number.isFinite(value)) result[product] = value;
        }
    }
    return result;
};
/**
 * Maps TAP-trait product keys to the FE source keys returned by the
 * assistance-service AgentKnowledgeConfiguration API.
 * Source of truth: convoai-platform `KnowledgeSourceTypeValues`.
 */ const $105b061879975503$var$TAP_KEY_TO_FE_SOURCE = {
    adobexd: 'adobe_xd',
    'adobe-sign': 'adobe_sign',
    aha: 'aha',
    airtable: 'airtable',
    amplitude: 'amplitude',
    asana: 'asana',
    'atlassian-web-crawler': 'atlassian-web-crawler',
    'aws-s3': 'aws',
    'azure-devops': 'azure_devops',
    box: 'box',
    canva: 'canva',
    clickup: 'clickup',
    databricks: 'databricks',
    docusign: 'docusign',
    dovetail: 'dovetail',
    dropbox: 'dropbox',
    figma: 'figma',
    freshservice: 'freshservice',
    gcp: 'gcp',
    github: 'github',
    gitbook: 'gitbook',
    gitlab: 'gitlab',
    gmail: 'gmail',
    'google-calendar': 'google_calendar',
    drive: 'google_drive',
    hubspot: 'hubspot',
    launchdarkly: 'launchdarkly',
    loom: 'loom',
    lucid: 'lucid',
    miro: 'miro',
    monday: 'monday',
    mural: 'mural',
    notion: 'notion',
    onedrive: 'microsoft_onedrive',
    'outlook-calendar': 'microsoft_outlook_calendar',
    'outlook-mail': 'microsoft_outlook_mail',
    pagerduty: 'pagerduty',
    pipedrive: 'pipedrive',
    'power-bi': 'microsoft_power_bi',
    salesforce: 'salesforce',
    sentry: 'sentry',
    servicenow: 'servicenow',
    sharepoint: 'microsoft_sharepoint',
    slack: 'slack',
    smartsheet: 'smartsheet',
    stripe: 'stripe',
    teams: 'teams',
    todoist: 'todoist',
    webex: 'cisco_webex',
    zendesk: 'zendesk',
    zeplin: 'zeplin'
};
const $105b061879975503$export$75425aa5703db6b4 = (parsed)=>{
    const normalized = {};
    for (const [tapKey, value] of Object.entries(parsed)){
        const normalizedKey = $105b061879975503$var$TAP_KEY_TO_FE_SOURCE[tapKey] ?? tapKey;
        normalized[normalizedKey] = Math.max(normalized[normalizedKey] ?? Number.NEGATIVE_INFINITY, value);
    }
    return normalized;
};
const $105b061879975503$export$e8d0db1b887b304b = 'rovo_connector_authed_users_percentage_by_app';
module.exports["fetchSiteTraits"] = $105b061879975503$export$954f05a5dfd487e4;
module.exports["parseProductValueTrait"] = $105b061879975503$export$f357d04e31823a19;
module.exports["normalizeTapKeys"] = $105b061879975503$export$75425aa5703db6b4;
module.exports["CONNECTOR_AUTH_RATE_TRAIT"] = $105b061879975503$export$e8d0db1b887b304b;

});

parcelRegister("kQMBL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc91bd4f7aec7121abc848a4fa856bb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2de5e8201858161$var$_react = $f2de5e8201858161$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f2de5e8201858161$var$_baseNew = $f2de5e8201858161$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f2de5e8201858161$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiModel".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing large language and reasoning models.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2de5e8201858161$var$AiModelIcon = (props)=>/*#__PURE__*/ $f2de5e8201858161$var$_react.default.createElement($f2de5e8201858161$var$_baseNew.default, Object.assign({
        name: "AiModelIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 3.19c0-.644.536-1.19 1.229-1.19.692 0 1.228.546 1.228 1.19q0 .137-.03.263a.75.75 0 0 0 .902.9.996.996 0 0 1 .59 1.897.75.75 0 0 0 .054 1.416 1.811 1.811 0 0 1-.368 3.533.75.75 0 0 0-.682.747v.593a1.462 1.462 0 0 1-2.923 0V9.362c.6.348 1.32.552 2.043.552v-1.5a2.6 2.6 0 0 1-1.481-.47c-.4-.289-.562-.61-.562-.875zm-1.5 9.35a2.961 2.961 0 0 0 5.923.016 3.31 3.31 0 0 0 1.116-5.72 2.496 2.496 0 0 0-1.604-3.98C12.517 1.518 11.359.5 9.979.5 8.486.5 7.25 1.69 7.25 3.19z"/><path fill="currentcolor" d="M7.25 3.19C7.25 2.545 6.714 2 6.021 2c-.692 0-1.228.546-1.228 1.19q0 .137.03.263a.75.75 0 0 1-.902.9.996.996 0 0 0-.59 1.897.75.75 0 0 1-.054 1.416 1.811 1.811 0 0 0 .368 3.533.75.75 0 0 1 .682.747v.593a1.462 1.462 0 0 0 2.923 0V9.362a4.13 4.13 0 0 1-2.043.552v-1.5c.542 0 1.086-.184 1.481-.47.4-.289.562-.61.562-.875zm1.5 9.35a2.961 2.961 0 0 1-5.923.016 3.31 3.31 0 0 1-1.116-5.72 2.496 2.496 0 0 1 1.604-3.98C3.483 1.518 4.641.5 6.021.5 7.514.5 8.75 1.69 8.75 3.19z"/>`
    }, props));
$f2de5e8201858161$var$AiModelIcon.displayName = 'AiModelIcon';
var $f2de5e8201858161$var$_default = module.exports.default = $f2de5e8201858161$var$AiModelIcon;

});


//# sourceMappingURL=browse-agents.c1dfb101.js.map
